import "./index.css";
import { jsxs as k, jsx as p, Fragment as lt } from "react/jsx-runtime";
import ge, { forwardRef as vr, useEffect as $e, cloneElement as gt, useState as fe, Fragment as gl, Children as ra, useRef as je, createContext as _l, useContext as wl, useImperativeHandle as Ol, useMemo as Wr, createElement as jr } from "react";
import bu from "react-dom";
function ht(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
function qe(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", o;
    if (r === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, i = n != null && n.width ? String(n.width) : a;
      o = e.formattingValues[i] || e.formattingValues[a];
    } else {
      var u = e.defaultWidth, l = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[l] || e.values[u];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[c];
  };
}
function Fe(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    var i = a[0], u = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(u) ? Tl(u, function(s) {
      return s.test(i);
    }) : Pl(u, function(s) {
      return s.test(i);
    }), c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var f = t.slice(i.length);
    return {
      value: c,
      rest: f
    };
  };
}
function Pl(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function Tl(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function gu(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var o = r[0], a = t.match(e.parsePattern);
    if (!a)
      return null;
    var i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    var u = t.slice(o.length);
    return {
      value: i,
      rest: u
    };
  };
}
function we(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function le(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function kt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? kt = function(n) {
    return typeof n;
  } : kt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, kt(e);
}
function de(e) {
  le(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || kt(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function _u(e, t) {
  le(2, arguments);
  var n = de(e), r = we(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function oa(e, t) {
  le(2, arguments);
  var n = de(e), r = we(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var o = n.getDate(), a = new Date(n.getTime());
  a.setMonth(n.getMonth() + r + 1, 0);
  var i = a.getDate();
  return o >= i ? a : (n.setFullYear(a.getFullYear(), a.getMonth(), o), n);
}
function Sl(e, t) {
  le(2, arguments);
  var n = de(e).getTime(), r = we(t);
  return new Date(n + r);
}
var $l = {};
function Ze() {
  return $l;
}
function Rr(e, t) {
  var n, r, o, a, i, u, l, c;
  le(1, arguments);
  var f = Ze(), s = we((n = (r = (o = (a = t?.weekStartsOn) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && o !== void 0 ? o : f.weekStartsOn) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(s >= 0 && s <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = de(e), y = d.getDay(), h = (y < s ? 7 : 0) + y - s;
  return d.setDate(d.getDate() - h), d.setHours(0, 0, 0, 0), d;
}
function wu(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function ba(e) {
  le(1, arguments);
  var t = de(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Rl(e, t) {
  le(2, arguments);
  var n = we(t), r = n * 7;
  return _u(e, r);
}
function Ou(e, t) {
  le(2, arguments);
  var n = we(t);
  return oa(e, n * 12);
}
var El = 6e4, xl = 36e5, Cl = 1e3;
function Tt(e, t) {
  le(2, arguments);
  var n = ba(e), r = ba(t);
  return n.getTime() === r.getTime();
}
function At(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? At = function(n) {
    return typeof n;
  } : At = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, At(e);
}
function Nl(e) {
  return le(1, arguments), e instanceof Date || At(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Pu(e) {
  if (le(1, arguments), !Nl(e) && typeof e != "number")
    return !1;
  var t = de(e);
  return !isNaN(Number(t));
}
function Tu(e) {
  le(1, arguments);
  var t = de(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Dl(e, t) {
  var n;
  le(1, arguments);
  var r = e || {}, o = de(r.start), a = de(r.end), i = a.getTime();
  if (!(o.getTime() <= i))
    throw new RangeError("Invalid interval");
  var u = [], l = o;
  l.setHours(0, 0, 0, 0);
  var c = Number((n = t?.step) !== null && n !== void 0 ? n : 1);
  if (c < 1 || isNaN(c))
    throw new RangeError("`options.step` must be a number greater than 1");
  for (; l.getTime() <= i; )
    u.push(de(l)), l.setDate(l.getDate() + c), l.setHours(0, 0, 0, 0);
  return u;
}
function Su(e) {
  le(1, arguments);
  var t = de(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function ga(e, t) {
  var n, r, o, a, i, u, l, c;
  le(1, arguments);
  var f = Ze(), s = we((n = (r = (o = (a = t?.weekStartsOn) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && o !== void 0 ? o : f.weekStartsOn) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(s >= 0 && s <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = de(e), y = d.getDay(), h = (y < s ? -7 : 0) + 6 - (y - s);
  return d.setDate(d.getDate() + h), d.setHours(23, 59, 59, 999), d;
}
function $u(e, t) {
  le(2, arguments);
  var n = we(t);
  return Sl(e, -n);
}
var Ml = 864e5;
function kl(e) {
  le(1, arguments);
  var t = de(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), o = n - r;
  return Math.floor(o / Ml) + 1;
}
function vt(e) {
  le(1, arguments);
  var t = 1, n = de(e), r = n.getUTCDay(), o = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function Ru(e) {
  le(1, arguments);
  var t = de(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = vt(r), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var i = vt(a);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function Al(e) {
  le(1, arguments);
  var t = Ru(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = vt(n);
  return r;
}
var Il = 6048e5;
function Eu(e) {
  le(1, arguments);
  var t = de(e), n = vt(t).getTime() - Al(t).getTime();
  return Math.round(n / Il) + 1;
}
function ct(e, t) {
  var n, r, o, a, i, u, l, c;
  le(1, arguments);
  var f = Ze(), s = we((n = (r = (o = (a = t?.weekStartsOn) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && o !== void 0 ? o : f.weekStartsOn) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(s >= 0 && s <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = de(e), y = d.getUTCDay(), h = (y < s ? 7 : 0) + y - s;
  return d.setUTCDate(d.getUTCDate() - h), d.setUTCHours(0, 0, 0, 0), d;
}
function aa(e, t) {
  var n, r, o, a, i, u, l, c;
  le(1, arguments);
  var f = de(e), s = f.getUTCFullYear(), d = Ze(), y = we((n = (r = (o = (a = t?.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && o !== void 0 ? o : d.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(y >= 1 && y <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(s + 1, 0, y), h.setUTCHours(0, 0, 0, 0);
  var v = ct(h, t), O = /* @__PURE__ */ new Date(0);
  O.setUTCFullYear(s, 0, y), O.setUTCHours(0, 0, 0, 0);
  var b = ct(O, t);
  return f.getTime() >= v.getTime() ? s + 1 : f.getTime() >= b.getTime() ? s : s - 1;
}
function Ul(e, t) {
  var n, r, o, a, i, u, l, c;
  le(1, arguments);
  var f = Ze(), s = we((n = (r = (o = (a = t?.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), d = aa(e, t), y = /* @__PURE__ */ new Date(0);
  y.setUTCFullYear(d, 0, s), y.setUTCHours(0, 0, 0, 0);
  var h = ct(y, t);
  return h;
}
var Ll = 6048e5;
function xu(e, t) {
  le(1, arguments);
  var n = de(e), r = ct(n, t).getTime() - Ul(n, t).getTime();
  return Math.round(r / Ll) + 1;
}
function se(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var Wl = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), o = r > 0 ? r : 1 - r;
    return se(n === "yy" ? o % 100 : o, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : se(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return se(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return se(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return se(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return se(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return se(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, o = t.getUTCMilliseconds(), a = Math.floor(o * Math.pow(10, r - 3));
    return se(a, n.length);
  }
};
const Ve = Wl;
var dt = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, jl = {
  // Era
  G: function(t, n, r) {
    var o = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(o, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(o, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(o, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var o = t.getUTCFullYear(), a = o > 0 ? o : 1 - o;
      return r.ordinalNumber(a, {
        unit: "year"
      });
    }
    return Ve.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, o) {
    var a = aa(t, o), i = a > 0 ? a : 1 - a;
    if (n === "YY") {
      var u = i % 100;
      return se(u, 2);
    }
    return n === "Yo" ? r.ordinalNumber(i, {
      unit: "year"
    }) : se(i, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = Ru(t);
    return se(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return se(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(o);
      case "QQ":
        return se(o, 2);
      case "Qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(o);
      case "qq":
        return se(o, 2);
      case "qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Ve.M(t, n);
      case "Mo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(o + 1);
      case "LL":
        return se(o + 1, 2);
      case "Lo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, o) {
    var a = xu(t, o);
    return n === "wo" ? r.ordinalNumber(a, {
      unit: "week"
    }) : se(a, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var o = Eu(t);
    return n === "Io" ? r.ordinalNumber(o, {
      unit: "week"
    }) : se(o, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Ve.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var o = kl(t);
    return n === "Do" ? r.ordinalNumber(o, {
      unit: "dayOfYear"
    }) : se(o, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var o = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, o) {
    var a = t.getUTCDay(), i = (a - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(i);
      case "ee":
        return se(i, 2);
      case "eo":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, o) {
    var a = t.getUTCDay(), i = (a - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(i);
      case "cc":
        return se(i, n.length);
      case "co":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var o = t.getUTCDay(), a = o === 0 ? 7 : o;
    switch (n) {
      case "i":
        return String(a);
      case "ii":
        return se(a, n.length);
      case "io":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var o = t.getUTCHours(), a = o / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var o = t.getUTCHours(), a;
    switch (o === 12 ? a = dt.noon : o === 0 ? a = dt.midnight : a = o / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var o = t.getUTCHours(), a;
    switch (o >= 17 ? a = dt.evening : o >= 12 ? a = dt.afternoon : o >= 4 ? a = dt.morning : a = dt.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var o = t.getUTCHours() % 12;
      return o === 0 && (o = 12), r.ordinalNumber(o, {
        unit: "hour"
      });
    }
    return Ve.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Ve.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var o = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : se(o, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var o = t.getUTCHours();
    return o === 0 && (o = 24), n === "ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : se(o, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Ve.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Ve.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return Ve.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (n) {
      case "X":
        return wa(i);
      case "XXXX":
      case "XX":
        return tt(i);
      case "XXXXX":
      case "XXX":
      default:
        return tt(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTimezoneOffset();
    switch (n) {
      case "x":
        return wa(i);
      case "xxxx":
      case "xx":
        return tt(i);
      case "xxxxx":
      case "xxx":
      default:
        return tt(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + _a(i, ":");
      case "OOOO":
      default:
        return "GMT" + tt(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + _a(i, ":");
      case "zzzz":
      default:
        return "GMT" + tt(i, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, o) {
    var a = o._originalDate || t, i = Math.floor(a.getTime() / 1e3);
    return se(i, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTime();
    return se(i, n.length);
  }
};
function _a(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.floor(r / 60), a = r % 60;
  if (a === 0)
    return n + String(o);
  var i = t || "";
  return n + String(o) + i + se(a, 2);
}
function wa(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + se(Math.abs(e) / 60, 2);
  }
  return tt(e, t);
}
function tt(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", o = Math.abs(e), a = se(Math.floor(o / 60), 2), i = se(o % 60, 2);
  return r + a + n + i;
}
const ql = jl;
var Oa = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, Cu = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, Fl = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], o = r[1], a = r[2];
  if (!a)
    return Oa(t, n);
  var i;
  switch (o) {
    case "P":
      i = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = n.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", Oa(o, n)).replace("{{time}}", Cu(a, n));
}, Hl = {
  p: Cu,
  P: Fl
};
const qr = Hl;
var Yl = ["D", "DD"], Bl = ["YY", "YYYY"];
function Nu(e) {
  return Yl.indexOf(e) !== -1;
}
function Du(e) {
  return Bl.indexOf(e) !== -1;
}
function _n(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var zl = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Vl = function(t, n, r) {
  var o, a = zl[t];
  return typeof a == "string" ? o = a : n === 1 ? o = a.one : o = a.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
const Ql = Vl;
var Xl = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Gl = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Kl = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Jl = {
  date: ht({
    formats: Xl,
    defaultWidth: "full"
  }),
  time: ht({
    formats: Gl,
    defaultWidth: "full"
  }),
  dateTime: ht({
    formats: Kl,
    defaultWidth: "full"
  })
};
const Zl = Jl;
var ec = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, tc = function(t, n, r, o) {
  return ec[t];
};
const nc = tc;
var rc = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, oc = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ac = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, ic = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, uc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, lc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, cc = function(t, n) {
  var r = Number(t), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, sc = {
  ordinalNumber: cc,
  era: qe({
    values: rc,
    defaultWidth: "wide"
  }),
  quarter: qe({
    values: oc,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: qe({
    values: ac,
    defaultWidth: "wide"
  }),
  day: qe({
    values: ic,
    defaultWidth: "wide"
  }),
  dayPeriod: qe({
    values: uc,
    defaultWidth: "wide",
    formattingValues: lc,
    defaultFormattingWidth: "wide"
  })
};
const fc = sc;
var dc = /^(\d+)(th|st|nd|rd)?/i, pc = /\d+/i, yc = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, hc = {
  any: [/^b/i, /^(a|c)/i]
}, mc = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, vc = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, bc = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, gc = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, _c = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, wc = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Oc = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Pc = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Tc = {
  ordinalNumber: gu({
    matchPattern: dc,
    parsePattern: pc,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Fe({
    matchPatterns: yc,
    defaultMatchWidth: "wide",
    parsePatterns: hc,
    defaultParseWidth: "any"
  }),
  quarter: Fe({
    matchPatterns: mc,
    defaultMatchWidth: "wide",
    parsePatterns: vc,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Fe({
    matchPatterns: bc,
    defaultMatchWidth: "wide",
    parsePatterns: gc,
    defaultParseWidth: "any"
  }),
  day: Fe({
    matchPatterns: _c,
    defaultMatchWidth: "wide",
    parsePatterns: wc,
    defaultParseWidth: "any"
  }),
  dayPeriod: Fe({
    matchPatterns: Oc,
    defaultMatchWidth: "any",
    parsePatterns: Pc,
    defaultParseWidth: "any"
  })
};
const Sc = Tc;
var $c = {
  code: "en-US",
  formatDistance: Ql,
  formatLong: Zl,
  formatRelative: nc,
  localize: fc,
  match: Sc,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Mu = $c;
var Rc = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ec = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, xc = /^'([^]*?)'?$/, Cc = /''/g, Nc = /[a-zA-Z]/;
function Ee(e, t, n) {
  var r, o, a, i, u, l, c, f, s, d, y, h, v, O, b, x, $, P;
  le(2, arguments);
  var m = String(t), A = Ze(), D = (r = (o = n?.locale) !== null && o !== void 0 ? o : A.locale) !== null && r !== void 0 ? r : Mu, I = we((a = (i = (u = (l = n?.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (c = n.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && u !== void 0 ? u : A.firstWeekContainsDate) !== null && i !== void 0 ? i : (s = A.locale) === null || s === void 0 || (d = s.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(I >= 1 && I <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var L = we((y = (h = (v = (O = n?.weekStartsOn) !== null && O !== void 0 ? O : n == null || (b = n.locale) === null || b === void 0 || (x = b.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && v !== void 0 ? v : A.weekStartsOn) !== null && h !== void 0 ? h : ($ = A.locale) === null || $ === void 0 || (P = $.options) === null || P === void 0 ? void 0 : P.weekStartsOn) !== null && y !== void 0 ? y : 0);
  if (!(L >= 0 && L <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!D.localize)
    throw new RangeError("locale must contain localize property");
  if (!D.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var Q = de(e);
  if (!Pu(Q))
    throw new RangeError("Invalid time value");
  var W = wu(Q), z = $u(Q, W), J = {
    firstWeekContainsDate: I,
    weekStartsOn: L,
    locale: D,
    _originalDate: Q
  }, N = m.match(Ec).map(function(S) {
    var C = S[0];
    if (C === "p" || C === "P") {
      var g = qr[C];
      return g(S, D.formatLong);
    }
    return S;
  }).join("").match(Rc).map(function(S) {
    if (S === "''")
      return "'";
    var C = S[0];
    if (C === "'")
      return Dc(S);
    var g = ql[C];
    if (g)
      return !(n != null && n.useAdditionalWeekYearTokens) && Du(S) && _n(S, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && Nu(S) && _n(S, t, String(e)), g(z, S, D.localize, J);
    if (C.match(Nc))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + C + "`");
    return S;
  }).join("");
  return N;
}
function Dc(e) {
  var t = e.match(xc);
  return t ? t[1].replace(Cc, "'") : e;
}
function Mc(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function ku(e, t) {
  var n, r;
  le(1, arguments);
  var o = de(e);
  if (isNaN(o.getTime()))
    throw new RangeError("Invalid time value");
  var a = String((n = t?.format) !== null && n !== void 0 ? n : "extended"), i = String((r = t?.representation) !== null && r !== void 0 ? r : "complete");
  if (a !== "extended" && a !== "basic")
    throw new RangeError("format must be 'extended' or 'basic'");
  if (i !== "date" && i !== "time" && i !== "complete")
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  var u = "", l = "", c = a === "extended" ? "-" : "", f = a === "extended" ? ":" : "";
  if (i !== "time") {
    var s = se(o.getDate(), 2), d = se(o.getMonth() + 1, 2), y = se(o.getFullYear(), 4);
    u = "".concat(y).concat(c).concat(d).concat(c).concat(s);
  }
  if (i !== "date") {
    var h = o.getTimezoneOffset();
    if (h !== 0) {
      var v = Math.abs(h), O = se(Math.floor(v / 60), 2), b = se(v % 60, 2), x = h < 0 ? "+" : "-";
      l = "".concat(x).concat(O, ":").concat(b);
    } else
      l = "Z";
    var $ = se(o.getHours(), 2), P = se(o.getMinutes(), 2), m = se(o.getSeconds(), 2), A = u === "" ? "" : "T", D = [$, P, m].join(f);
    u = "".concat(u).concat(A).concat(D).concat(l);
  }
  return u;
}
function kc(e) {
  le(1, arguments);
  var t = de(e), n = t.getDate();
  return n;
}
function wn(e) {
  le(1, arguments);
  var t = de(e), n = t.getMonth();
  return n;
}
function bt(e) {
  return le(1, arguments), de(e).getFullYear();
}
function On(e, t) {
  le(2, arguments);
  var n = de(e), r = de(t);
  return n.getTime() > r.getTime();
}
function Au(e, t) {
  le(2, arguments);
  var n = de(e), r = de(t);
  return n.getTime() < r.getTime();
}
function It(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? It = function(n) {
    return typeof n;
  } : It = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, It(e);
}
function Iu(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Fr(e, t);
}
function Fr(e, t) {
  return Fr = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Fr(e, t);
}
function Uu(e) {
  var t = Ic();
  return function() {
    var r = Pn(e), o;
    if (t) {
      var a = Pn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Ac(this, o);
  };
}
function Ac(e, t) {
  return t && (It(t) === "object" || typeof t == "function") ? t : Hr(e);
}
function Hr(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ic() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Pn(e) {
  return Pn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Pn(e);
}
function ia(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Pa(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function ua(e, t, n) {
  return t && Pa(e.prototype, t), n && Pa(e, n), e;
}
function Yr(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Uc = 10, Lu = /* @__PURE__ */ function() {
  function e() {
    ia(this, e), Yr(this, "subPriority", 0);
  }
  return ua(e, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), e;
}(), Lc = /* @__PURE__ */ function(e) {
  Iu(n, e);
  var t = Uu(n);
  function n(r, o, a, i, u) {
    var l;
    return ia(this, n), l = t.call(this), l.value = r, l.validateValue = o, l.setValue = a, l.priority = i, u && (l.subPriority = u), l;
  }
  return ua(n, [{
    key: "validate",
    value: function(o, a) {
      return this.validateValue(o, this.value, a);
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return this.setValue(o, a, this.value, i);
    }
  }]), n;
}(Lu), Wc = /* @__PURE__ */ function(e) {
  Iu(n, e);
  var t = Uu(n);
  function n() {
    var r;
    ia(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Yr(Hr(r), "priority", Uc), Yr(Hr(r), "subPriority", -1), r;
  }
  return ua(n, [{
    key: "set",
    value: function(o, a) {
      if (a.timestampIsSet)
        return o;
      var i = /* @__PURE__ */ new Date(0);
      return i.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), i.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), i;
    }
  }]), n;
}(Lu);
function jc(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ta(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function qc(e, t, n) {
  return t && Ta(e.prototype, t), n && Ta(e, n), e;
}
var ye = /* @__PURE__ */ function() {
  function e() {
    jc(this, e);
  }
  return qc(e, [{
    key: "run",
    value: function(n, r, o, a) {
      var i = this.parse(n, r, o, a);
      return i ? {
        setter: new Lc(i.value, this.validate, this.set, this.priority, this.subPriority),
        rest: i.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, o) {
      return !0;
    }
  }]), e;
}();
function Ut(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ut = function(n) {
    return typeof n;
  } : Ut = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ut(e);
}
function Fc(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Sa(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Hc(e, t, n) {
  return t && Sa(e.prototype, t), n && Sa(e, n), e;
}
function Yc(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Br(e, t);
}
function Br(e, t) {
  return Br = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Br(e, t);
}
function Bc(e) {
  var t = Vc();
  return function() {
    var r = Tn(e), o;
    if (t) {
      var a = Tn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return zc(this, o);
  };
}
function zc(e, t) {
  return t && (Ut(t) === "object" || typeof t == "function") ? t : zr(e);
}
function zr(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Vc() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Tn(e) {
  return Tn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Tn(e);
}
function $a(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Qc = /* @__PURE__ */ function(e) {
  Yc(n, e);
  var t = Bc(n);
  function n() {
    var r;
    Fc(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), $a(zr(r), "priority", 140), $a(zr(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return Hc(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "G":
        case "GG":
        case "GGG":
          return i.era(o, {
            width: "abbreviated"
          }) || i.era(o, {
            width: "narrow"
          });
        case "GGGGG":
          return i.era(o, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return i.era(o, {
            width: "wide"
          }) || i.era(o, {
            width: "abbreviated"
          }) || i.era(o, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return a.era = i, o.setUTCFullYear(i, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye), Te = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, He = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Se(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function _e(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function Ye(e, t) {
  var n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, i = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * xl + a * El + i * Cl),
    rest: t.slice(n[0].length)
  };
}
function Wu(e) {
  return _e(Te.anyDigitsSigned, e);
}
function Oe(e, t) {
  switch (e) {
    case 1:
      return _e(Te.singleDigit, t);
    case 2:
      return _e(Te.twoDigits, t);
    case 3:
      return _e(Te.threeDigits, t);
    case 4:
      return _e(Te.fourDigits, t);
    default:
      return _e(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Sn(e, t) {
  switch (e) {
    case 1:
      return _e(Te.singleDigitSigned, t);
    case 2:
      return _e(Te.twoDigitsSigned, t);
    case 3:
      return _e(Te.threeDigitsSigned, t);
    case 4:
      return _e(Te.fourDigitsSigned, t);
    default:
      return _e(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function la(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function ju(e, t) {
  var n = t > 0, r = n ? t : 1 - t, o;
  if (r <= 50)
    o = e || 100;
  else {
    var a = r + 50, i = Math.floor(a / 100) * 100, u = e >= a % 100;
    o = e + i - (u ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function qu(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Lt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Lt = function(n) {
    return typeof n;
  } : Lt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Lt(e);
}
function Xc(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ra(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Gc(e, t, n) {
  return t && Ra(e.prototype, t), n && Ra(e, n), e;
}
function Kc(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Vr(e, t);
}
function Vr(e, t) {
  return Vr = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Vr(e, t);
}
function Jc(e) {
  var t = es();
  return function() {
    var r = $n(e), o;
    if (t) {
      var a = $n(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Zc(this, o);
  };
}
function Zc(e, t) {
  return t && (Lt(t) === "object" || typeof t == "function") ? t : Qr(e);
}
function Qr(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function es() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function $n(e) {
  return $n = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, $n(e);
}
function Ea(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var ts = /* @__PURE__ */ function(e) {
  Kc(n, e);
  var t = Jc(n);
  function n() {
    var r;
    Xc(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Ea(Qr(r), "priority", 130), Ea(Qr(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Gc(n, [{
    key: "parse",
    value: function(o, a, i) {
      var u = function(c) {
        return {
          year: c,
          isTwoDigitYear: a === "yy"
        };
      };
      switch (a) {
        case "y":
          return Se(Oe(4, o), u);
        case "yo":
          return Se(i.ordinalNumber(o, {
            unit: "year"
          }), u);
        default:
          return Se(Oe(a.length, o), u);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      var u = o.getUTCFullYear();
      if (i.isTwoDigitYear) {
        var l = ju(i.year, u);
        return o.setUTCFullYear(l, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
      var c = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
      return o.setUTCFullYear(c, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function Wt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Wt = function(n) {
    return typeof n;
  } : Wt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Wt(e);
}
function ns(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function xa(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function rs(e, t, n) {
  return t && xa(e.prototype, t), n && xa(e, n), e;
}
function os(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Xr(e, t);
}
function Xr(e, t) {
  return Xr = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Xr(e, t);
}
function as(e) {
  var t = us();
  return function() {
    var r = Rn(e), o;
    if (t) {
      var a = Rn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return is(this, o);
  };
}
function is(e, t) {
  return t && (Wt(t) === "object" || typeof t == "function") ? t : Gr(e);
}
function Gr(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function us() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Rn(e) {
  return Rn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Rn(e);
}
function Ca(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var ls = /* @__PURE__ */ function(e) {
  os(n, e);
  var t = as(n);
  function n() {
    var r;
    ns(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Ca(Gr(r), "priority", 130), Ca(Gr(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return rs(n, [{
    key: "parse",
    value: function(o, a, i) {
      var u = function(c) {
        return {
          year: c,
          isTwoDigitYear: a === "YY"
        };
      };
      switch (a) {
        case "Y":
          return Se(Oe(4, o), u);
        case "Yo":
          return Se(i.ordinalNumber(o, {
            unit: "year"
          }), u);
        default:
          return Se(Oe(a.length, o), u);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(o, a, i, u) {
      var l = aa(o, u);
      if (i.isTwoDigitYear) {
        var c = ju(i.year, l);
        return o.setUTCFullYear(c, 0, u.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), ct(o, u);
      }
      var f = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
      return o.setUTCFullYear(f, 0, u.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), ct(o, u);
    }
  }]), n;
}(ye);
function jt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? jt = function(n) {
    return typeof n;
  } : jt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, jt(e);
}
function cs(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Na(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function ss(e, t, n) {
  return t && Na(e.prototype, t), n && Na(e, n), e;
}
function fs(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Kr(e, t);
}
function Kr(e, t) {
  return Kr = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Kr(e, t);
}
function ds(e) {
  var t = ys();
  return function() {
    var r = En(e), o;
    if (t) {
      var a = En(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return ps(this, o);
  };
}
function ps(e, t) {
  return t && (jt(t) === "object" || typeof t == "function") ? t : Jr(e);
}
function Jr(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ys() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function En(e) {
  return En = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, En(e);
}
function Da(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var hs = /* @__PURE__ */ function(e) {
  fs(n, e);
  var t = ds(n);
  function n() {
    var r;
    cs(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Da(Jr(r), "priority", 130), Da(Jr(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return ss(n, [{
    key: "parse",
    value: function(o, a) {
      return Sn(a === "R" ? 4 : a.length, o);
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      var u = /* @__PURE__ */ new Date(0);
      return u.setUTCFullYear(i, 0, 4), u.setUTCHours(0, 0, 0, 0), vt(u);
    }
  }]), n;
}(ye);
function qt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? qt = function(n) {
    return typeof n;
  } : qt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, qt(e);
}
function ms(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ma(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function vs(e, t, n) {
  return t && Ma(e.prototype, t), n && Ma(e, n), e;
}
function bs(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Zr(e, t);
}
function Zr(e, t) {
  return Zr = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Zr(e, t);
}
function gs(e) {
  var t = ws();
  return function() {
    var r = xn(e), o;
    if (t) {
      var a = xn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return _s(this, o);
  };
}
function _s(e, t) {
  return t && (qt(t) === "object" || typeof t == "function") ? t : eo(e);
}
function eo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ws() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function xn(e) {
  return xn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, xn(e);
}
function ka(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Os = /* @__PURE__ */ function(e) {
  bs(n, e);
  var t = gs(n);
  function n() {
    var r;
    ms(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), ka(eo(r), "priority", 130), ka(eo(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return vs(n, [{
    key: "parse",
    value: function(o, a) {
      return Sn(a === "u" ? 4 : a.length, o);
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCFullYear(i, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function Ft(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ft = function(n) {
    return typeof n;
  } : Ft = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ft(e);
}
function Ps(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Aa(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ts(e, t, n) {
  return t && Aa(e.prototype, t), n && Aa(e, n), e;
}
function Ss(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && to(e, t);
}
function to(e, t) {
  return to = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, to(e, t);
}
function $s(e) {
  var t = Es();
  return function() {
    var r = Cn(e), o;
    if (t) {
      var a = Cn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Rs(this, o);
  };
}
function Rs(e, t) {
  return t && (Ft(t) === "object" || typeof t == "function") ? t : no(e);
}
function no(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Es() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Cn(e) {
  return Cn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Cn(e);
}
function Ia(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var xs = /* @__PURE__ */ function(e) {
  Ss(n, e);
  var t = $s(n);
  function n() {
    var r;
    Ps(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Ia(no(r), "priority", 120), Ia(no(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ts(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "Q":
        case "QQ":
          return Oe(a.length, o);
        case "Qo":
          return i.ordinalNumber(o, {
            unit: "quarter"
          });
        case "QQQ":
          return i.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return i.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return i.quarter(o, {
            width: "wide",
            context: "formatting"
          }) || i.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCMonth((i - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function Ht(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ht = function(n) {
    return typeof n;
  } : Ht = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ht(e);
}
function Cs(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ua(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ns(e, t, n) {
  return t && Ua(e.prototype, t), n && Ua(e, n), e;
}
function Ds(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && ro(e, t);
}
function ro(e, t) {
  return ro = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, ro(e, t);
}
function Ms(e) {
  var t = As();
  return function() {
    var r = Nn(e), o;
    if (t) {
      var a = Nn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return ks(this, o);
  };
}
function ks(e, t) {
  return t && (Ht(t) === "object" || typeof t == "function") ? t : oo(e);
}
function oo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function As() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Nn(e) {
  return Nn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Nn(e);
}
function La(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Is = /* @__PURE__ */ function(e) {
  Ds(n, e);
  var t = Ms(n);
  function n() {
    var r;
    Cs(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), La(oo(r), "priority", 120), La(oo(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ns(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "q":
        case "qq":
          return Oe(a.length, o);
        case "qo":
          return i.ordinalNumber(o, {
            unit: "quarter"
          });
        case "qqq":
          return i.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return i.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return i.quarter(o, {
            width: "wide",
            context: "standalone"
          }) || i.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCMonth((i - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function Yt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Yt = function(n) {
    return typeof n;
  } : Yt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Yt(e);
}
function Us(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Wa(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ls(e, t, n) {
  return t && Wa(e.prototype, t), n && Wa(e, n), e;
}
function Ws(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && ao(e, t);
}
function ao(e, t) {
  return ao = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, ao(e, t);
}
function js(e) {
  var t = Fs();
  return function() {
    var r = Dn(e), o;
    if (t) {
      var a = Dn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return qs(this, o);
  };
}
function qs(e, t) {
  return t && (Yt(t) === "object" || typeof t == "function") ? t : io(e);
}
function io(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Fs() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Dn(e) {
  return Dn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Dn(e);
}
function ja(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Hs = /* @__PURE__ */ function(e) {
  Ws(n, e);
  var t = js(n);
  function n() {
    var r;
    Us(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), ja(io(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), ja(io(r), "priority", 110), r;
  }
  return Ls(n, [{
    key: "parse",
    value: function(o, a, i) {
      var u = function(c) {
        return c - 1;
      };
      switch (a) {
        case "M":
          return Se(_e(Te.month, o), u);
        case "MM":
          return Se(Oe(2, o), u);
        case "Mo":
          return Se(i.ordinalNumber(o, {
            unit: "month"
          }), u);
        case "MMM":
          return i.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return i.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return i.month(o, {
            width: "wide",
            context: "formatting"
          }) || i.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCMonth(i, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function Bt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Bt = function(n) {
    return typeof n;
  } : Bt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Bt(e);
}
function Ys(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qa(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Bs(e, t, n) {
  return t && qa(e.prototype, t), n && qa(e, n), e;
}
function zs(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && uo(e, t);
}
function uo(e, t) {
  return uo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, uo(e, t);
}
function Vs(e) {
  var t = Xs();
  return function() {
    var r = Mn(e), o;
    if (t) {
      var a = Mn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Qs(this, o);
  };
}
function Qs(e, t) {
  return t && (Bt(t) === "object" || typeof t == "function") ? t : lo(e);
}
function lo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Xs() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Mn(e) {
  return Mn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Mn(e);
}
function Fa(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Gs = /* @__PURE__ */ function(e) {
  zs(n, e);
  var t = Vs(n);
  function n() {
    var r;
    Ys(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Fa(lo(r), "priority", 110), Fa(lo(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Bs(n, [{
    key: "parse",
    value: function(o, a, i) {
      var u = function(c) {
        return c - 1;
      };
      switch (a) {
        case "L":
          return Se(_e(Te.month, o), u);
        case "LL":
          return Se(Oe(2, o), u);
        case "Lo":
          return Se(i.ordinalNumber(o, {
            unit: "month"
          }), u);
        case "LLL":
          return i.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return i.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return i.month(o, {
            width: "wide",
            context: "standalone"
          }) || i.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCMonth(i, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function Ks(e, t, n) {
  le(2, arguments);
  var r = de(e), o = we(t), a = xu(r, n) - o;
  return r.setUTCDate(r.getUTCDate() - a * 7), r;
}
function zt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? zt = function(n) {
    return typeof n;
  } : zt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, zt(e);
}
function Js(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ha(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Zs(e, t, n) {
  return t && Ha(e.prototype, t), n && Ha(e, n), e;
}
function ef(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && co(e, t);
}
function co(e, t) {
  return co = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, co(e, t);
}
function tf(e) {
  var t = rf();
  return function() {
    var r = kn(e), o;
    if (t) {
      var a = kn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return nf(this, o);
  };
}
function nf(e, t) {
  return t && (zt(t) === "object" || typeof t == "function") ? t : so(e);
}
function so(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rf() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function kn(e) {
  return kn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, kn(e);
}
function Ya(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var of = /* @__PURE__ */ function(e) {
  ef(n, e);
  var t = tf(n);
  function n() {
    var r;
    Js(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Ya(so(r), "priority", 100), Ya(so(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Zs(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "w":
          return _e(Te.week, o);
        case "wo":
          return i.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return Oe(a.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(o, a, i, u) {
      return ct(Ks(o, i, u), u);
    }
  }]), n;
}(ye);
function af(e, t) {
  le(2, arguments);
  var n = de(e), r = we(t), o = Eu(n) - r;
  return n.setUTCDate(n.getUTCDate() - o * 7), n;
}
function Vt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Vt = function(n) {
    return typeof n;
  } : Vt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Vt(e);
}
function uf(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ba(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function lf(e, t, n) {
  return t && Ba(e.prototype, t), n && Ba(e, n), e;
}
function cf(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && fo(e, t);
}
function fo(e, t) {
  return fo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, fo(e, t);
}
function sf(e) {
  var t = df();
  return function() {
    var r = An(e), o;
    if (t) {
      var a = An(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return ff(this, o);
  };
}
function ff(e, t) {
  return t && (Vt(t) === "object" || typeof t == "function") ? t : po(e);
}
function po(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function df() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function An(e) {
  return An = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, An(e);
}
function za(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var pf = /* @__PURE__ */ function(e) {
  cf(n, e);
  var t = sf(n);
  function n() {
    var r;
    uf(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), za(po(r), "priority", 100), za(po(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return lf(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "I":
          return _e(Te.week, o);
        case "Io":
          return i.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return Oe(a.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return vt(af(o, i));
    }
  }]), n;
}(ye);
function Qt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Qt = function(n) {
    return typeof n;
  } : Qt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Qt(e);
}
function yf(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Va(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function hf(e, t, n) {
  return t && Va(e.prototype, t), n && Va(e, n), e;
}
function mf(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && yo(e, t);
}
function yo(e, t) {
  return yo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, yo(e, t);
}
function vf(e) {
  var t = gf();
  return function() {
    var r = In(e), o;
    if (t) {
      var a = In(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return bf(this, o);
  };
}
function bf(e, t) {
  return t && (Qt(t) === "object" || typeof t == "function") ? t : Xt(e);
}
function Xt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gf() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function In(e) {
  return In = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, In(e);
}
function Er(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var _f = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], wf = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Of = /* @__PURE__ */ function(e) {
  mf(n, e);
  var t = vf(n);
  function n() {
    var r;
    yf(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Er(Xt(r), "priority", 90), Er(Xt(r), "subPriority", 1), Er(Xt(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return hf(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "d":
          return _e(Te.date, o);
        case "do":
          return i.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return Oe(a.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      var i = o.getUTCFullYear(), u = qu(i), l = o.getUTCMonth();
      return u ? a >= 1 && a <= wf[l] : a >= 1 && a <= _f[l];
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCDate(i), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function Gt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Gt = function(n) {
    return typeof n;
  } : Gt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Gt(e);
}
function Pf(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Qa(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Tf(e, t, n) {
  return t && Qa(e.prototype, t), n && Qa(e, n), e;
}
function Sf(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && ho(e, t);
}
function ho(e, t) {
  return ho = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, ho(e, t);
}
function $f(e) {
  var t = Ef();
  return function() {
    var r = Un(e), o;
    if (t) {
      var a = Un(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Rf(this, o);
  };
}
function Rf(e, t) {
  return t && (Gt(t) === "object" || typeof t == "function") ? t : Kt(e);
}
function Kt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ef() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Un(e) {
  return Un = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Un(e);
}
function xr(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var xf = /* @__PURE__ */ function(e) {
  Sf(n, e);
  var t = $f(n);
  function n() {
    var r;
    Pf(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), xr(Kt(r), "priority", 90), xr(Kt(r), "subpriority", 1), xr(Kt(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return Tf(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "D":
        case "DD":
          return _e(Te.dayOfYear, o);
        case "Do":
          return i.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return Oe(a.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      var i = o.getUTCFullYear(), u = qu(i);
      return u ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCMonth(0, i), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function ca(e, t, n) {
  var r, o, a, i, u, l, c, f;
  le(2, arguments);
  var s = Ze(), d = we((r = (o = (a = (i = n?.weekStartsOn) !== null && i !== void 0 ? i : n == null || (u = n.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && a !== void 0 ? a : s.weekStartsOn) !== null && o !== void 0 ? o : (c = s.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var y = de(e), h = we(t), v = y.getUTCDay(), O = h % 7, b = (O + 7) % 7, x = (b < d ? 7 : 0) + h - v;
  return y.setUTCDate(y.getUTCDate() + x), y;
}
function Jt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Jt = function(n) {
    return typeof n;
  } : Jt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Jt(e);
}
function Cf(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Xa(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Nf(e, t, n) {
  return t && Xa(e.prototype, t), n && Xa(e, n), e;
}
function Df(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && mo(e, t);
}
function mo(e, t) {
  return mo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, mo(e, t);
}
function Mf(e) {
  var t = Af();
  return function() {
    var r = Ln(e), o;
    if (t) {
      var a = Ln(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return kf(this, o);
  };
}
function kf(e, t) {
  return t && (Jt(t) === "object" || typeof t == "function") ? t : vo(e);
}
function vo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Af() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ln(e) {
  return Ln = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ln(e);
}
function Ga(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var If = /* @__PURE__ */ function(e) {
  Df(n, e);
  var t = Mf(n);
  function n() {
    var r;
    Cf(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Ga(vo(r), "priority", 90), Ga(vo(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return Nf(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "E":
        case "EE":
        case "EEE":
          return i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return i.day(o, {
            width: "wide",
            context: "formatting"
          }) || i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(o, a, i, u) {
      return o = ca(o, i, u), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function Zt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Zt = function(n) {
    return typeof n;
  } : Zt = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Zt(e);
}
function Uf(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ka(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Lf(e, t, n) {
  return t && Ka(e.prototype, t), n && Ka(e, n), e;
}
function Wf(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && bo(e, t);
}
function bo(e, t) {
  return bo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, bo(e, t);
}
function jf(e) {
  var t = Ff();
  return function() {
    var r = Wn(e), o;
    if (t) {
      var a = Wn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return qf(this, o);
  };
}
function qf(e, t) {
  return t && (Zt(t) === "object" || typeof t == "function") ? t : go(e);
}
function go(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ff() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Wn(e) {
  return Wn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Wn(e);
}
function Ja(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Hf = /* @__PURE__ */ function(e) {
  Wf(n, e);
  var t = jf(n);
  function n() {
    var r;
    Uf(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Ja(go(r), "priority", 90), Ja(go(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return Lf(n, [{
    key: "parse",
    value: function(o, a, i, u) {
      var l = function(f) {
        var s = Math.floor((f - 1) / 7) * 7;
        return (f + u.weekStartsOn + 6) % 7 + s;
      };
      switch (a) {
        case "e":
        case "ee":
          return Se(Oe(a.length, o), l);
        case "eo":
          return Se(i.ordinalNumber(o, {
            unit: "day"
          }), l);
        case "eee":
          return i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return i.day(o, {
            width: "wide",
            context: "formatting"
          }) || i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(o, a, i, u) {
      return o = ca(o, i, u), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function en(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? en = function(n) {
    return typeof n;
  } : en = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, en(e);
}
function Yf(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Za(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Bf(e, t, n) {
  return t && Za(e.prototype, t), n && Za(e, n), e;
}
function zf(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && _o(e, t);
}
function _o(e, t) {
  return _o = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, _o(e, t);
}
function Vf(e) {
  var t = Xf();
  return function() {
    var r = jn(e), o;
    if (t) {
      var a = jn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Qf(this, o);
  };
}
function Qf(e, t) {
  return t && (en(t) === "object" || typeof t == "function") ? t : wo(e);
}
function wo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Xf() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function jn(e) {
  return jn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, jn(e);
}
function ei(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Gf = /* @__PURE__ */ function(e) {
  zf(n, e);
  var t = Vf(n);
  function n() {
    var r;
    Yf(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), ei(wo(r), "priority", 90), ei(wo(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return Bf(n, [{
    key: "parse",
    value: function(o, a, i, u) {
      var l = function(f) {
        var s = Math.floor((f - 1) / 7) * 7;
        return (f + u.weekStartsOn + 6) % 7 + s;
      };
      switch (a) {
        case "c":
        case "cc":
          return Se(Oe(a.length, o), l);
        case "co":
          return Se(i.ordinalNumber(o, {
            unit: "day"
          }), l);
        case "ccc":
          return i.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(o, {
            width: "short",
            context: "standalone"
          }) || i.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return i.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return i.day(o, {
            width: "short",
            context: "standalone"
          }) || i.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return i.day(o, {
            width: "wide",
            context: "standalone"
          }) || i.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(o, {
            width: "short",
            context: "standalone"
          }) || i.day(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(o, a, i, u) {
      return o = ca(o, i, u), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function Kf(e, t) {
  le(2, arguments);
  var n = we(t);
  n % 7 === 0 && (n = n - 7);
  var r = 1, o = de(e), a = o.getUTCDay(), i = n % 7, u = (i + 7) % 7, l = (u < r ? 7 : 0) + n - a;
  return o.setUTCDate(o.getUTCDate() + l), o;
}
function tn(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? tn = function(n) {
    return typeof n;
  } : tn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, tn(e);
}
function Jf(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ti(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Zf(e, t, n) {
  return t && ti(e.prototype, t), n && ti(e, n), e;
}
function ed(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Oo(e, t);
}
function Oo(e, t) {
  return Oo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Oo(e, t);
}
function td(e) {
  var t = rd();
  return function() {
    var r = qn(e), o;
    if (t) {
      var a = qn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return nd(this, o);
  };
}
function nd(e, t) {
  return t && (tn(t) === "object" || typeof t == "function") ? t : Po(e);
}
function Po(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rd() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function qn(e) {
  return qn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, qn(e);
}
function ni(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var od = /* @__PURE__ */ function(e) {
  ed(n, e);
  var t = td(n);
  function n() {
    var r;
    Jf(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), ni(Po(r), "priority", 90), ni(Po(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return Zf(n, [{
    key: "parse",
    value: function(o, a, i) {
      var u = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (a) {
        case "i":
        case "ii":
          return Oe(a.length, o);
        case "io":
          return i.ordinalNumber(o, {
            unit: "day"
          });
        case "iii":
          return Se(i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          }), u);
        case "iiiii":
          return Se(i.day(o, {
            width: "narrow",
            context: "formatting"
          }), u);
        case "iiiiii":
          return Se(i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          }), u);
        case "iiii":
        default:
          return Se(i.day(o, {
            width: "wide",
            context: "formatting"
          }) || i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          }), u);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 1 && a <= 7;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o = Kf(o, i), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function nn(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? nn = function(n) {
    return typeof n;
  } : nn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, nn(e);
}
function ad(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ri(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function id(e, t, n) {
  return t && ri(e.prototype, t), n && ri(e, n), e;
}
function ud(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && To(e, t);
}
function To(e, t) {
  return To = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, To(e, t);
}
function ld(e) {
  var t = sd();
  return function() {
    var r = Fn(e), o;
    if (t) {
      var a = Fn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return cd(this, o);
  };
}
function cd(e, t) {
  return t && (nn(t) === "object" || typeof t == "function") ? t : So(e);
}
function So(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function sd() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Fn(e) {
  return Fn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Fn(e);
}
function oi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var fd = /* @__PURE__ */ function(e) {
  ud(n, e);
  var t = ld(n);
  function n() {
    var r;
    ad(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), oi(So(r), "priority", 80), oi(So(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return id(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "a":
        case "aa":
        case "aaa":
          return i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return i.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCHours(la(i), 0, 0, 0), o;
    }
  }]), n;
}(ye);
function rn(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? rn = function(n) {
    return typeof n;
  } : rn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, rn(e);
}
function dd(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ai(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function pd(e, t, n) {
  return t && ai(e.prototype, t), n && ai(e, n), e;
}
function yd(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && $o(e, t);
}
function $o(e, t) {
  return $o = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, $o(e, t);
}
function hd(e) {
  var t = vd();
  return function() {
    var r = Hn(e), o;
    if (t) {
      var a = Hn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return md(this, o);
  };
}
function md(e, t) {
  return t && (rn(t) === "object" || typeof t == "function") ? t : Ro(e);
}
function Ro(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function vd() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Hn(e) {
  return Hn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Hn(e);
}
function ii(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var bd = /* @__PURE__ */ function(e) {
  yd(n, e);
  var t = hd(n);
  function n() {
    var r;
    dd(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), ii(Ro(r), "priority", 80), ii(Ro(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return pd(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "b":
        case "bb":
        case "bbb":
          return i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return i.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCHours(la(i), 0, 0, 0), o;
    }
  }]), n;
}(ye);
function on(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? on = function(n) {
    return typeof n;
  } : on = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, on(e);
}
function gd(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ui(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function _d(e, t, n) {
  return t && ui(e.prototype, t), n && ui(e, n), e;
}
function wd(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Eo(e, t);
}
function Eo(e, t) {
  return Eo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Eo(e, t);
}
function Od(e) {
  var t = Td();
  return function() {
    var r = Yn(e), o;
    if (t) {
      var a = Yn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Pd(this, o);
  };
}
function Pd(e, t) {
  return t && (on(t) === "object" || typeof t == "function") ? t : xo(e);
}
function xo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Td() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Yn(e) {
  return Yn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Yn(e);
}
function li(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Sd = /* @__PURE__ */ function(e) {
  wd(n, e);
  var t = Od(n);
  function n() {
    var r;
    gd(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), li(xo(r), "priority", 80), li(xo(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return _d(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "B":
        case "BB":
        case "BBB":
          return i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return i.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCHours(la(i), 0, 0, 0), o;
    }
  }]), n;
}(ye);
function an(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? an = function(n) {
    return typeof n;
  } : an = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, an(e);
}
function $d(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ci(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Rd(e, t, n) {
  return t && ci(e.prototype, t), n && ci(e, n), e;
}
function Ed(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Co(e, t);
}
function Co(e, t) {
  return Co = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Co(e, t);
}
function xd(e) {
  var t = Nd();
  return function() {
    var r = Bn(e), o;
    if (t) {
      var a = Bn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Cd(this, o);
  };
}
function Cd(e, t) {
  return t && (an(t) === "object" || typeof t == "function") ? t : No(e);
}
function No(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Nd() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Bn(e) {
  return Bn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Bn(e);
}
function si(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Dd = /* @__PURE__ */ function(e) {
  Ed(n, e);
  var t = xd(n);
  function n() {
    var r;
    $d(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), si(No(r), "priority", 70), si(No(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return Rd(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "h":
          return _e(Te.hour12h, o);
        case "ho":
          return i.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Oe(a.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 1 && a <= 12;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      var u = o.getUTCHours() >= 12;
      return u && i < 12 ? o.setUTCHours(i + 12, 0, 0, 0) : !u && i === 12 ? o.setUTCHours(0, 0, 0, 0) : o.setUTCHours(i, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function un(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? un = function(n) {
    return typeof n;
  } : un = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, un(e);
}
function Md(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function fi(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function kd(e, t, n) {
  return t && fi(e.prototype, t), n && fi(e, n), e;
}
function Ad(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Do(e, t);
}
function Do(e, t) {
  return Do = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Do(e, t);
}
function Id(e) {
  var t = Ld();
  return function() {
    var r = zn(e), o;
    if (t) {
      var a = zn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Ud(this, o);
  };
}
function Ud(e, t) {
  return t && (un(t) === "object" || typeof t == "function") ? t : Mo(e);
}
function Mo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ld() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function zn(e) {
  return zn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, zn(e);
}
function di(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Wd = /* @__PURE__ */ function(e) {
  Ad(n, e);
  var t = Id(n);
  function n() {
    var r;
    Md(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), di(Mo(r), "priority", 70), di(Mo(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return kd(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "H":
          return _e(Te.hour23h, o);
        case "Ho":
          return i.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Oe(a.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 0 && a <= 23;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCHours(i, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function ln(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ln = function(n) {
    return typeof n;
  } : ln = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ln(e);
}
function jd(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function pi(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function qd(e, t, n) {
  return t && pi(e.prototype, t), n && pi(e, n), e;
}
function Fd(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && ko(e, t);
}
function ko(e, t) {
  return ko = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, ko(e, t);
}
function Hd(e) {
  var t = Bd();
  return function() {
    var r = Vn(e), o;
    if (t) {
      var a = Vn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Yd(this, o);
  };
}
function Yd(e, t) {
  return t && (ln(t) === "object" || typeof t == "function") ? t : Ao(e);
}
function Ao(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Bd() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Vn(e) {
  return Vn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Vn(e);
}
function yi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var zd = /* @__PURE__ */ function(e) {
  Fd(n, e);
  var t = Hd(n);
  function n() {
    var r;
    jd(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), yi(Ao(r), "priority", 70), yi(Ao(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return qd(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "K":
          return _e(Te.hour11h, o);
        case "Ko":
          return i.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Oe(a.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      var u = o.getUTCHours() >= 12;
      return u && i < 12 ? o.setUTCHours(i + 12, 0, 0, 0) : o.setUTCHours(i, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function cn(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? cn = function(n) {
    return typeof n;
  } : cn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, cn(e);
}
function Vd(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function hi(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Qd(e, t, n) {
  return t && hi(e.prototype, t), n && hi(e, n), e;
}
function Xd(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Io(e, t);
}
function Io(e, t) {
  return Io = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Io(e, t);
}
function Gd(e) {
  var t = Jd();
  return function() {
    var r = Qn(e), o;
    if (t) {
      var a = Qn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Kd(this, o);
  };
}
function Kd(e, t) {
  return t && (cn(t) === "object" || typeof t == "function") ? t : Uo(e);
}
function Uo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Jd() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Qn(e) {
  return Qn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Qn(e);
}
function mi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Zd = /* @__PURE__ */ function(e) {
  Xd(n, e);
  var t = Gd(n);
  function n() {
    var r;
    Vd(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), mi(Uo(r), "priority", 70), mi(Uo(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return Qd(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "k":
          return _e(Te.hour24h, o);
        case "ko":
          return i.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Oe(a.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 1 && a <= 24;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      var u = i <= 24 ? i % 24 : i;
      return o.setUTCHours(u, 0, 0, 0), o;
    }
  }]), n;
}(ye);
function sn(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? sn = function(n) {
    return typeof n;
  } : sn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, sn(e);
}
function ep(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function vi(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function tp(e, t, n) {
  return t && vi(e.prototype, t), n && vi(e, n), e;
}
function np(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Lo(e, t);
}
function Lo(e, t) {
  return Lo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Lo(e, t);
}
function rp(e) {
  var t = ap();
  return function() {
    var r = Xn(e), o;
    if (t) {
      var a = Xn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return op(this, o);
  };
}
function op(e, t) {
  return t && (sn(t) === "object" || typeof t == "function") ? t : Wo(e);
}
function Wo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ap() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Xn(e) {
  return Xn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Xn(e);
}
function bi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var ip = /* @__PURE__ */ function(e) {
  np(n, e);
  var t = rp(n);
  function n() {
    var r;
    ep(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), bi(Wo(r), "priority", 60), bi(Wo(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return tp(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "m":
          return _e(Te.minute, o);
        case "mo":
          return i.ordinalNumber(o, {
            unit: "minute"
          });
        default:
          return Oe(a.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCMinutes(i, 0, 0), o;
    }
  }]), n;
}(ye);
function fn(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? fn = function(n) {
    return typeof n;
  } : fn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, fn(e);
}
function up(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function gi(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function lp(e, t, n) {
  return t && gi(e.prototype, t), n && gi(e, n), e;
}
function cp(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && jo(e, t);
}
function jo(e, t) {
  return jo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, jo(e, t);
}
function sp(e) {
  var t = dp();
  return function() {
    var r = Gn(e), o;
    if (t) {
      var a = Gn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return fp(this, o);
  };
}
function fp(e, t) {
  return t && (fn(t) === "object" || typeof t == "function") ? t : qo(e);
}
function qo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function dp() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Gn(e) {
  return Gn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Gn(e);
}
function _i(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var pp = /* @__PURE__ */ function(e) {
  cp(n, e);
  var t = sp(n);
  function n() {
    var r;
    up(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), _i(qo(r), "priority", 50), _i(qo(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return lp(n, [{
    key: "parse",
    value: function(o, a, i) {
      switch (a) {
        case "s":
          return _e(Te.second, o);
        case "so":
          return i.ordinalNumber(o, {
            unit: "second"
          });
        default:
          return Oe(a.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCSeconds(i, 0), o;
    }
  }]), n;
}(ye);
function dn(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? dn = function(n) {
    return typeof n;
  } : dn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, dn(e);
}
function yp(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function wi(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function hp(e, t, n) {
  return t && wi(e.prototype, t), n && wi(e, n), e;
}
function mp(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Fo(e, t);
}
function Fo(e, t) {
  return Fo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Fo(e, t);
}
function vp(e) {
  var t = gp();
  return function() {
    var r = Kn(e), o;
    if (t) {
      var a = Kn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return bp(this, o);
  };
}
function bp(e, t) {
  return t && (dn(t) === "object" || typeof t == "function") ? t : Ho(e);
}
function Ho(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gp() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Kn(e) {
  return Kn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Kn(e);
}
function Oi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var _p = /* @__PURE__ */ function(e) {
  mp(n, e);
  var t = vp(n);
  function n() {
    var r;
    yp(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Oi(Ho(r), "priority", 30), Oi(Ho(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return hp(n, [{
    key: "parse",
    value: function(o, a) {
      var i = function(l) {
        return Math.floor(l * Math.pow(10, -a.length + 3));
      };
      return Se(Oe(a.length, o), i);
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return o.setUTCMilliseconds(i), o;
    }
  }]), n;
}(ye);
function pn(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? pn = function(n) {
    return typeof n;
  } : pn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, pn(e);
}
function wp(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Pi(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Op(e, t, n) {
  return t && Pi(e.prototype, t), n && Pi(e, n), e;
}
function Pp(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Yo(e, t);
}
function Yo(e, t) {
  return Yo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Yo(e, t);
}
function Tp(e) {
  var t = $p();
  return function() {
    var r = Jn(e), o;
    if (t) {
      var a = Jn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Sp(this, o);
  };
}
function Sp(e, t) {
  return t && (pn(t) === "object" || typeof t == "function") ? t : Bo(e);
}
function Bo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $p() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Jn(e) {
  return Jn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Jn(e);
}
function Ti(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Rp = /* @__PURE__ */ function(e) {
  Pp(n, e);
  var t = Tp(n);
  function n() {
    var r;
    wp(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Ti(Bo(r), "priority", 10), Ti(Bo(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return Op(n, [{
    key: "parse",
    value: function(o, a) {
      switch (a) {
        case "X":
          return Ye(He.basicOptionalMinutes, o);
        case "XX":
          return Ye(He.basic, o);
        case "XXXX":
          return Ye(He.basicOptionalSeconds, o);
        case "XXXXX":
          return Ye(He.extendedOptionalSeconds, o);
        case "XXX":
        default:
          return Ye(He.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return a.timestampIsSet ? o : new Date(o.getTime() - i);
    }
  }]), n;
}(ye);
function yn(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? yn = function(n) {
    return typeof n;
  } : yn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, yn(e);
}
function Ep(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Si(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function xp(e, t, n) {
  return t && Si(e.prototype, t), n && Si(e, n), e;
}
function Cp(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && zo(e, t);
}
function zo(e, t) {
  return zo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, zo(e, t);
}
function Np(e) {
  var t = Mp();
  return function() {
    var r = Zn(e), o;
    if (t) {
      var a = Zn(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Dp(this, o);
  };
}
function Dp(e, t) {
  return t && (yn(t) === "object" || typeof t == "function") ? t : Vo(e);
}
function Vo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Mp() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Zn(e) {
  return Zn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Zn(e);
}
function $i(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var kp = /* @__PURE__ */ function(e) {
  Cp(n, e);
  var t = Np(n);
  function n() {
    var r;
    Ep(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), $i(Vo(r), "priority", 10), $i(Vo(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return xp(n, [{
    key: "parse",
    value: function(o, a) {
      switch (a) {
        case "x":
          return Ye(He.basicOptionalMinutes, o);
        case "xx":
          return Ye(He.basic, o);
        case "xxxx":
          return Ye(He.basicOptionalSeconds, o);
        case "xxxxx":
          return Ye(He.extendedOptionalSeconds, o);
        case "xxx":
        default:
          return Ye(He.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return a.timestampIsSet ? o : new Date(o.getTime() - i);
    }
  }]), n;
}(ye);
function hn(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? hn = function(n) {
    return typeof n;
  } : hn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, hn(e);
}
function Ap(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ri(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ip(e, t, n) {
  return t && Ri(e.prototype, t), n && Ri(e, n), e;
}
function Up(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Qo(e, t);
}
function Qo(e, t) {
  return Qo = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Qo(e, t);
}
function Lp(e) {
  var t = jp();
  return function() {
    var r = er(e), o;
    if (t) {
      var a = er(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return Wp(this, o);
  };
}
function Wp(e, t) {
  return t && (hn(t) === "object" || typeof t == "function") ? t : Xo(e);
}
function Xo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jp() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function er(e) {
  return er = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, er(e);
}
function Ei(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var qp = /* @__PURE__ */ function(e) {
  Up(n, e);
  var t = Lp(n);
  function n() {
    var r;
    Ap(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Ei(Xo(r), "priority", 40), Ei(Xo(r), "incompatibleTokens", "*"), r;
  }
  return Ip(n, [{
    key: "parse",
    value: function(o) {
      return Wu(o);
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return [new Date(i * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(ye);
function mn(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? mn = function(n) {
    return typeof n;
  } : mn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, mn(e);
}
function Fp(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function xi(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Hp(e, t, n) {
  return t && xi(e.prototype, t), n && xi(e, n), e;
}
function Yp(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Go(e, t);
}
function Go(e, t) {
  return Go = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Go(e, t);
}
function Bp(e) {
  var t = Vp();
  return function() {
    var r = tr(e), o;
    if (t) {
      var a = tr(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return zp(this, o);
  };
}
function zp(e, t) {
  return t && (mn(t) === "object" || typeof t == "function") ? t : Ko(e);
}
function Ko(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Vp() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function tr(e) {
  return tr = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, tr(e);
}
function Ci(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Qp = /* @__PURE__ */ function(e) {
  Yp(n, e);
  var t = Bp(n);
  function n() {
    var r;
    Fp(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), Ci(Ko(r), "priority", 20), Ci(Ko(r), "incompatibleTokens", "*"), r;
  }
  return Hp(n, [{
    key: "parse",
    value: function(o) {
      return Wu(o);
    }
  }, {
    key: "set",
    value: function(o, a, i) {
      return [new Date(i), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(ye), Xp = {
  G: new Qc(),
  y: new ts(),
  Y: new ls(),
  R: new hs(),
  u: new Os(),
  Q: new xs(),
  q: new Is(),
  M: new Hs(),
  L: new Gs(),
  w: new of(),
  I: new pf(),
  d: new Of(),
  D: new xf(),
  E: new If(),
  e: new Hf(),
  c: new Gf(),
  i: new od(),
  a: new fd(),
  b: new bd(),
  B: new Sd(),
  h: new Dd(),
  H: new Wd(),
  K: new zd(),
  k: new Zd(),
  m: new ip(),
  s: new pp(),
  S: new _p(),
  X: new Rp(),
  x: new kp(),
  t: new qp(),
  T: new Qp()
};
function vn(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? vn = function(n) {
    return typeof n;
  } : vn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, vn(e);
}
function Ni(e, t) {
  var n;
  if (typeof Symbol > "u" || e[Symbol.iterator] == null) {
    if (Array.isArray(e) || (n = Gp(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, o = function() {
      };
      return { s: o, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(c) {
        throw c;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, i = !1, u;
  return { s: function() {
    n = e[Symbol.iterator]();
  }, n: function() {
    var c = n.next();
    return a = c.done, c;
  }, e: function(c) {
    i = !0, u = c;
  }, f: function() {
    try {
      !a && n.return != null && n.return();
    } finally {
      if (i)
        throw u;
    }
  } };
}
function Gp(e, t) {
  if (e) {
    if (typeof e == "string")
      return Di(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Di(e, t);
  }
}
function Di(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Kp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Jp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Zp = /^'([^]*?)'?$/, ey = /''/g, ty = /\S/, ny = /[a-zA-Z]/;
function Mi(e, t, n, r) {
  var o, a, i, u, l, c, f, s, d, y, h, v, O, b, x, $, P, m;
  le(3, arguments);
  var A = String(e), D = String(t), I = Ze(), L = (o = (a = r?.locale) !== null && a !== void 0 ? a : I.locale) !== null && o !== void 0 ? o : Mu;
  if (!L.match)
    throw new RangeError("locale must contain match property");
  var Q = we((i = (u = (l = (c = r?.firstWeekContainsDate) !== null && c !== void 0 ? c : r == null || (f = r.locale) === null || f === void 0 || (s = f.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && l !== void 0 ? l : I.firstWeekContainsDate) !== null && u !== void 0 ? u : (d = I.locale) === null || d === void 0 || (y = d.options) === null || y === void 0 ? void 0 : y.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(Q >= 1 && Q <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var W = we((h = (v = (O = (b = r?.weekStartsOn) !== null && b !== void 0 ? b : r == null || (x = r.locale) === null || x === void 0 || ($ = x.options) === null || $ === void 0 ? void 0 : $.weekStartsOn) !== null && O !== void 0 ? O : I.weekStartsOn) !== null && v !== void 0 ? v : (P = I.locale) === null || P === void 0 || (m = P.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(W >= 0 && W <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (D === "")
    return A === "" ? de(n) : /* @__PURE__ */ new Date(NaN);
  var z = {
    firstWeekContainsDate: Q,
    weekStartsOn: W,
    locale: L
  }, J = [new Wc()], N = D.match(Jp).map(function(B) {
    var F = B[0];
    if (F in qr) {
      var w = qr[F];
      return w(B, L.formatLong);
    }
    return B;
  }).join("").match(Kp), S = [], C = Ni(N), g;
  try {
    var j = function() {
      var F = g.value;
      !(r != null && r.useAdditionalWeekYearTokens) && Du(F) && _n(F, D, e), !(r != null && r.useAdditionalDayOfYearTokens) && Nu(F) && _n(F, D, e);
      var w = F[0], H = Xp[w];
      if (H) {
        var T = H.incompatibleTokens;
        if (Array.isArray(T)) {
          var oe = S.find(function(te) {
            return T.includes(te.token) || te.token === w;
          });
          if (oe)
            throw new RangeError("The format string mustn't contain `".concat(oe.fullToken, "` and `").concat(F, "` at the same time"));
        } else if (H.incompatibleTokens === "*" && S.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(F, "` and any other token at the same time"));
        S.push({
          token: w,
          fullToken: F
        });
        var re = H.run(A, F, L.match, z);
        if (!re)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        J.push(re.setter), A = re.rest;
      } else {
        if (w.match(ny))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + w + "`");
        if (F === "''" ? F = "'" : w === "'" && (F = ry(F)), A.indexOf(F) === 0)
          A = A.slice(F.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (C.s(); !(g = C.n()).done; ) {
      var ce = j();
      if (vn(ce) === "object")
        return ce.v;
    }
  } catch (B) {
    C.e(B);
  } finally {
    C.f();
  }
  if (A.length > 0 && ty.test(A))
    return /* @__PURE__ */ new Date(NaN);
  var _ = J.map(function(B) {
    return B.priority;
  }).sort(function(B, F) {
    return F - B;
  }).filter(function(B, F, w) {
    return w.indexOf(B) === F;
  }).map(function(B) {
    return J.filter(function(F) {
      return F.priority === B;
    }).sort(function(F, w) {
      return w.subPriority - F.subPriority;
    });
  }).map(function(B) {
    return B[0];
  }), R = de(n);
  if (isNaN(R.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var Y = $u(R, wu(R)), E = {}, U = Ni(_), Z;
  try {
    for (U.s(); !(Z = U.n()).done; ) {
      var V = Z.value;
      if (!V.validate(Y, z))
        return /* @__PURE__ */ new Date(NaN);
      var G = V.set(Y, E, z);
      Array.isArray(G) ? (Y = G[0], Mc(E, G[1])) : Y = G;
    }
  } catch (B) {
    U.e(B);
  } finally {
    U.f();
  }
  return Y;
}
function ry(e) {
  return e.match(Zp)[1].replace(ey, "'");
}
function oy(e, t) {
  le(2, arguments);
  var n = we(t);
  return oa(e, -n);
}
function ay(e, t) {
  le(2, arguments);
  var n = we(t);
  return Ou(e, -n);
}
var iy = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, uy = function(t, n, r) {
  var o, a = iy[t];
  return typeof a == "string" ? o = a : n === 1 ? o = a.one : o = a.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "over " + o : o + " geleden" : o;
};
const ly = uy;
var cy = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, sy = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, fy = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dy = {
  date: ht({
    formats: cy,
    defaultWidth: "full"
  }),
  time: ht({
    formats: sy,
    defaultWidth: "full"
  }),
  dateTime: ht({
    formats: fy,
    defaultWidth: "full"
  })
};
const py = dy;
var yy = {
  lastWeek: "'vorige' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, hy = function(t, n, r, o) {
  return yy[t];
};
const my = hy;
var vy = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, by = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, gy = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
}, _y = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
}, wy = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, Oy = function(t, n) {
  var r = Number(t);
  return r + "e";
}, Py = {
  ordinalNumber: Oy,
  era: qe({
    values: vy,
    defaultWidth: "wide"
  }),
  quarter: qe({
    values: by,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: qe({
    values: gy,
    defaultWidth: "wide"
  }),
  day: qe({
    values: _y,
    defaultWidth: "wide"
  }),
  dayPeriod: qe({
    values: wy,
    defaultWidth: "wide"
  })
};
const Ty = Py;
var Sy = /^(\d+)e?/i, $y = /\d+/i, Ry = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, Ey = {
  any: [/^v/, /^n/]
}, xy = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, Cy = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ny = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, Dy = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
}, My = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, ky = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, Ay = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, Iy = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, Uy = {
  ordinalNumber: gu({
    matchPattern: Sy,
    parsePattern: $y,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Fe({
    matchPatterns: Ry,
    defaultMatchWidth: "wide",
    parsePatterns: Ey,
    defaultParseWidth: "any"
  }),
  quarter: Fe({
    matchPatterns: xy,
    defaultMatchWidth: "wide",
    parsePatterns: Cy,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Fe({
    matchPatterns: Ny,
    defaultMatchWidth: "wide",
    parsePatterns: Dy,
    defaultParseWidth: "any"
  }),
  day: Fe({
    matchPatterns: My,
    defaultMatchWidth: "wide",
    parsePatterns: ky,
    defaultParseWidth: "any"
  }),
  dayPeriod: Fe({
    matchPatterns: Ay,
    defaultMatchWidth: "any",
    parsePatterns: Iy,
    defaultParseWidth: "any"
  })
};
const Ly = Uy;
var Wy = {
  code: "nl-BE",
  formatDistance: ly,
  formatLong: py,
  formatRelative: my,
  localize: Ty,
  match: Ly,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const jy = Wy, qy = "https://cdn.antwerpen.be/core_branding_scss/6.5.0/assets/images/ai.svg", Fy = "single-neutral", sa = "u-screen-reader-only", ki = "ascending", Ai = "descending", Hy = "dd/MM/yyyy", Fu = jy;
function X(e) {
  return Object.keys(e).filter((t) => !!e[t]).join(" ");
}
function Yy(e) {
  return e.clientWidth >= e.scrollWidth || e.clientWidth + e.scrollLeft >= e.scrollWidth;
}
const By = 1048576;
function Hu(e, t = "") {
  return t.split(",").map((r) => r.trim()).flatMap((r) => r.split(".")).some(
    (r) => !r || r === "*" || r === e.type || r.includes("*") && !!r.split("/")?.[0] && e.type.startsWith(r.split("/")?.[0])
  );
}
function Yu(e, t) {
  return !t || e.size <= t * By;
}
function Ii(e, t, n) {
  return e.map((r) => ({ validFormat: Hu(r, t), validSize: Yu(r, n) }));
}
function zy(e) {
  const { width: t, height: n } = e.getBBox();
  return t === 0 && n === 0;
}
function br(e) {
  console.warn(`[AUI] Warning - ${e}.`);
}
const Cr = "ai-svg", ve = vr(function({ name: t, tabIndex: n, onKeyDown: r, className: o, role: a, onClick: i, screenReaderText: u, thin: l, qa: c }, f) {
  const s = async function() {
    if (typeof fetch != "function")
      return null;
    const v = await (await fetch(qy)).text(), O = document.createElement("svg");
    O.id = Cr, O.innerHTML = v, document.getElementById(Cr) || document.body.appendChild(O), d()?.forEach((b) => {
      zy(b) && br(
        `The provided icon with name "${t}" does not seem to exist. Please make sure the 'name' is correct`
      );
    });
  }, d = () => Array.from(document.querySelectorAll(`.ai-${t.replace("ai-", "")} use`));
  typeof document < "u" && !document.getElementById(Cr) && s();
  const y = X({
    ai: !0,
    [`ai-${t?.replace("ai-", "")}`]: !!t,
    "ai--thin": !!l,
    [o || ""]: !!o
  });
  return /* @__PURE__ */ k(
    "span",
    {
      ref: f,
      onKeyDown: r,
      tabIndex: n,
      role: a,
      onClick: i,
      className: y,
      "data-qa": c,
      children: [
        t ? /* @__PURE__ */ p("svg", { "aria-hidden": "true", children: /* @__PURE__ */ p("use", { href: `#ai-${t.replace("ai-", "")}` }) }) : null,
        !!u && /* @__PURE__ */ p("span", { className: sa, children: u })
      ]
    }
  );
});
var bn = /* @__PURE__ */ ((e) => (e.HIGH = "high", e.MEDIUM = "medium", e.LOW = "low", e))(bn || {});
const Jo = "high", Ui = {
  medium: "outlined",
  low: "transparent"
};
var gn = /* @__PURE__ */ ((e) => (e.XS = "extra-small", e.S = "small", e.MD = "medium", e.L = "large", e))(gn || {});
const Me = "medium", ke = {
  [
    "extra-small"
    /* XS */
  ]: "xs",
  small: "s",
  medium: "md",
  large: "l"
};
var nr = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.NEUTRAL = "neutral", e.DANGER = "danger", e.SUCCESS = "success", e.WARNING = "warning", e))(nr || {});
const rr = {
  success: "check-1",
  warning: "alert-circle",
  danger: "alert-triangle"
};
var pt = /* @__PURE__ */ ((e) => (e.SUCCESS = "success", e.ERROR = "error", e))(pt || {});
const Vy = (e) => /* @__PURE__ */ p("span", { className: "a-avatar__letter", children: e }), Qy = (e, t) => /* @__PURE__ */ p("img", { src: `${e}`, alt: `${t}` }), Xy = (e, t) => /* @__PURE__ */ p("span", { className: "a-avatar__icon", "aria-label": t, role: "img", children: /* @__PURE__ */ p(ve, { name: e }) });
function Bu({
  className: e,
  letter: t,
  rounded: n,
  size: r,
  ariaLabel: o = "Gebruiker",
  image: a,
  imageAlt: i = "Avatar",
  icon: u,
  qa: l
}) {
  const c = () => a ? Qy(a, i || "") : t ? Vy(t.slice(0, 3)) : Xy(u || Fy, o || ""), f = X({
    "a-avatar": !0,
    "a-avatar--primary": !!t,
    "a-avatar--rounded": !!n,
    [`a-avatar--${ke[r || Me]}`]: !!r,
    [e || ""]: !!e
  });
  return /* @__PURE__ */ p("div", { className: f, "data-qa": l, children: c() });
}
function nv({ ariaLabel: e, theme: t, emphasis: n, children: r, qa: o }) {
  const a = parseInt(r), i = X({
    "a-badge": !0,
    [`a-badge--${t}`]: !!t,
    [`a-badge--${Ui[n || Jo]}`]: !!Ui[n || Jo]
  });
  return $e(() => {
    isNaN(a) && br("Using the Badge Component with a non-numerical value");
  }, [r]), /* @__PURE__ */ p("span", { className: i, "aria-label": e, "data-qa": o, children: isNaN(a) ? "" : `${a}` });
}
function zu({ label: e = "Wordt geladen...", showText: t, size: n, vertical: r, ariaHidden: o, qa: a }) {
  const i = X({
    "a-spinner": !0,
    [`a-spinner--${ke[n || Me]}`]: !!n,
    "a-spinner--vertical": !!r
  }), u = X({
    "a-spinner__text": !!t,
    [sa]: !t
  });
  return /* @__PURE__ */ k("div", { className: i, "aria-hidden": o, "data-qa": a, children: [
    /* @__PURE__ */ p("span", { role: "alert", className: "a-spinner__circle" }),
    /* @__PURE__ */ p("span", { className: u, children: e })
  ] });
}
function gr(e, t, n) {
  return n ? gt(t, { children: e }) : e;
}
function fa(e, t, n) {
  return !e?.href && !e?.onClick ? e?.label || "" : e?.href ? /* @__PURE__ */ k("a", { href: e.href, target: e.target || "_self", ...n, children: [
    e.label || "",
    t ? /* @__PURE__ */ p(ve, { name: t }) : null
  ] }) : /* @__PURE__ */ k(
    "a",
    {
      style: { cursor: "pointer" },
      onClick: (a) => (a.preventDefault(), e.onClick && e.onClick(a)),
      onKeyDown: (a) => {
        if (a.key === "Enter")
          return a.preventDefault(), e.onClick && e.onClick(a);
      },
      role: "button",
      tabIndex: 0,
      ...n,
      children: [
        e.label || "",
        t ? /* @__PURE__ */ p(ve, { name: t }) : null
      ]
    }
  );
}
function Gy(e, t, n, r) {
  return t ? /* @__PURE__ */ k("div", { className: "a-input", children: [
    /* @__PURE__ */ p("label", { className: "a-input__label", id: r, htmlFor: n, children: t }),
    e
  ] }) : e;
}
function Ky(e, t) {
  return e?.type === "spinner" ? /* @__PURE__ */ p(zu, { ariaHidden: !0, size: t === gn.S ? gn.XS : gn.S }) : e?.type === "avatar" ? /* @__PURE__ */ p(Bu, { ...e?.avatarProps, size: t }) : e?.type === "icon" ? /* @__PURE__ */ p(ve, { ...e?.iconProps }) : null;
}
function Ce({
  addOn: e,
  ariaLabel: t,
  children: n,
  className: r,
  disabled: o,
  emphasis: a = Jo,
  fullWidth: i,
  htmlType: u = "button",
  id: l,
  onClick: c,
  qa: f,
  size: s,
  theme: d,
  title: y,
  ...h
}) {
  const v = {
    "a-button": !0,
    [`a-button--${ke[s || Me]}`]: !!s,
    [`a-button--${d}`]: !!d && !(d === nr.NEUTRAL && a === bn.HIGH),
    "a-button--outlined": a === bn.MEDIUM,
    "a-button--text": a === bn.LOW,
    "a-button--full": !!i,
    "has-icon": e?.type === "icon" && !["left", "right"].includes(e?.align || ""),
    "has-icon-left": e?.type !== "avatar" && e?.align === "left",
    "has-icon-right": e?.type !== "avatar" && e?.align === "right" || e?.type === "spinner" && e?.align !== "left",
    "has-avatar": e?.type === "avatar",
    "has-avatar-with-inset": e?.type === "avatar" && (!!e.avatarProps?.letter || !!e.avatarProps?.image),
    [`${r}`]: !!r
  }, O = X(v);
  return $e(() => {
    e?.type === "icon" && !["left", "right"].includes(e?.align || "") && !t && br("Using an Icon Button without an aria-label");
  }, [e, t]), /* @__PURE__ */ k(
    "button",
    {
      id: l,
      className: O,
      title: y,
      onClick: c,
      type: u,
      "aria-label": t,
      "data-qa": f,
      disabled: o,
      ...h["aria-haspopup"] ? { "aria-haspopup": !0 } : {},
      ...h["aria-expanded"] === !0 || h["aria-expanded"] === !1 ? { "aria-expanded": h["aria-expanded"] } : {},
      children: [
        Ky(e, s),
        v["has-icon"] ? null : n
      ]
    }
  );
}
function rv({ title: e, items: t = [], renderLinkFunction: n, qa: r }) {
  const o = () => Array.isArray(t) ? t.map((i) => /* @__PURE__ */ p("li", { children: n ? n(i) : fa(i) }, `${i.id}`)) : null, a = () => {
    if (e && e.label) {
      const i = e.tag || "h1";
      return /* @__PURE__ */ p(i, { className: `${e.className || ""} u-margin-top-xxs`, children: e.label });
    }
    return null;
  };
  return /* @__PURE__ */ k(lt, { children: [
    /* @__PURE__ */ p("ul", { className: "a-breadcrumb", "data-qa": r, children: o() }),
    a()
  ] });
}
function da({
  label: e,
  showLabel: t = !0,
  checked: n,
  id: r,
  qa: o,
  name: a,
  disabled: i,
  indeterminate: u,
  onChange: l
}) {
  const c = (d) => l && l(d), f = (d) => {
    d && u && (d.indeterminate = !0);
  }, s = X({
    "a-input__checkbox": !0
  });
  return /* @__PURE__ */ k("div", { "data-qa": o, className: s, children: [
    /* @__PURE__ */ p(
      "input",
      {
        type: "checkbox",
        id: r,
        name: a,
        checked: n,
        ref: f,
        disabled: i,
        onChange: c
      }
    ),
    /* @__PURE__ */ p("label", { htmlFor: r, children: /* @__PURE__ */ p("span", { className: t ? void 0 : sa, children: e }) })
  ] });
}
function ov({ sign: e = "©", label: t, link: n, forImage: r = !0, qa: o }) {
  const a = X({
    "a-copyright": !0,
    "m-image__copyright": !!r
  });
  return /* @__PURE__ */ k(`${n ? "a" : "div"}`, { href: n, className: a, "data-qa": o, children: [
    /* @__PURE__ */ p("span", { className: "a-copyright__sign", children: e }),
    t ? /* @__PURE__ */ p("span", { className: "a-copyright__label", children: t }) : null
  ] });
}
const _r = ({ label: e, id: t, required: n, inline: r }) => {
  const o = X({
    "a-input__label": !0,
    "a-input__label--inline": !!r
  });
  return e ? /* @__PURE__ */ k("label", { className: o, htmlFor: t, children: [
    e,
    n && /* @__PURE__ */ p("span", { className: "u-text-danger", children: "*" })
  ] }) : null;
}, wr = ({ id: e, description: t, state: n }) => {
  const r = X({
    "a-input__description": !0,
    "is-error": n === pt.ERROR,
    "is-success": n === pt.SUCCESS
  });
  return t ? /* @__PURE__ */ k("small", { id: `${e}--description`, className: r, children: [
    n === pt.SUCCESS && /* @__PURE__ */ p(ve, { name: rr[nr.SUCCESS] }),
    n === pt.ERROR && /* @__PURE__ */ p(ve, { name: rr[nr.DANGER] }),
    t
  ] }) : null;
}, Vu = ({
  id: e,
  charCountText: t,
  charCounter: n,
  characterCount: r,
  maxLength: o
}) => n && o ? /* @__PURE__ */ p("small", { "aria-live": "polite", id: `${e}--counter`, className: "a-input__description u-text-right", children: t?.replace("%max%", o.toString()).replace("%count%", r.toString()).replace("%left%", (o - r).toString()) }) : null;
const Qu = vr(function({
  addOn: t,
  autoComplete: n,
  charCounter: r,
  charCountText: o = "%count% / %max%",
  description: a,
  disabled: i,
  id: u = "aui-text-field",
  role: l,
  inline: c,
  label: f,
  maxLength: s,
  name: d,
  onChange: y,
  qa: h,
  readOnly: v,
  required: O,
  size: b,
  state: x,
  type: $ = "text",
  value: P,
  onBlur: m,
  onClick: A,
  onFocus: D,
  onKeyDown: I,
  onKeyUp: L
}, Q) {
  const [W, z] = fe(P ? P.length : 0), J = t?.type === "text" && t.placement === "left" ? t.content : null, N = t?.type === "text" && t.placement === "right" ? t.content : null, S = t?.type === "icon" && t.placement === "left" ? t.content : null, C = t?.type === "icon" && t.placement === "right" ? t.content : null, g = X({
    "a-input": !0,
    "a-input--inline": !!c,
    [`a-input--${ke[b || Me]}`]: !!b,
    "has-icon-left": !!S || t?.type === "spinner" && t?.placement === "left",
    "has-icon-right": !S && !!C,
    "has-addon-left": !!J,
    "has-addon-right": !!N,
    "has-error": x === "error",
    "has-spinner": t?.type === "spinner",
    [`has-spinner-${t?.placement}`]: !!t
  }), j = X({
    "a-input__wrapper": !0,
    "a-input__wrapper--inline": !!c
  }), ce = (_) => (z(_.target.value.length), y && y(_));
  return /* @__PURE__ */ k("div", { className: g, "data-qa": h, children: [
    _r({ label: f, id: u, required: O, inline: c }),
    wr({ id: u, description: a, state: x }),
    /* @__PURE__ */ k("div", { className: j, children: [
      t?.type === "spinner" && /* @__PURE__ */ p(zu, { size: "small" }),
      !!S && /* @__PURE__ */ p(ve, { name: S }),
      !!J && /* @__PURE__ */ p("div", { className: "a-input__addon", children: J }),
      /* @__PURE__ */ p(
        "input",
        {
          ref: Q,
          type: $,
          value: P,
          name: d,
          id: u,
          autoComplete: n,
          disabled: i,
          readOnly: v,
          required: O,
          maxLength: s,
          onChange: ce,
          onBlur: m,
          onClick: A,
          onFocus: D,
          onKeyDown: I,
          onKeyUp: L,
          role: l,
          ...r && s ? { "aria-describedby": `${u}--counter` } : {},
          ...a ? { "aria-describedby": `${u}--description` } : {}
        }
      ),
      !!C && !S && /* @__PURE__ */ p(ve, { name: C }),
      !!N && /* @__PURE__ */ p("div", { className: "a-input__addon", children: N })
    ] }),
    Vu({
      id: u,
      charCountText: o,
      charCounter: r,
      characterCount: P ? P.length : W,
      maxLength: s
    })
  ] });
});
function av({
  charCounter: e,
  charCountText: t = "%count% / %max%",
  description: n,
  disabled: r,
  id: o = "aui-text-area",
  inline: a,
  label: i,
  maxLength: u,
  name: l,
  onChange: c,
  qa: f,
  readOnly: s,
  required: d,
  size: y,
  state: h,
  value: v,
  onBlur: O,
  onClick: b,
  onFocus: x,
  onKeyDown: $,
  onKeyUp: P
}) {
  const [m, A] = fe(v ? v.length : 0), D = X({
    "a-input": !0,
    "a-input--inline": !!a,
    [`a-input--${ke[y || Me]}`]: !!y,
    "has-error": h === pt.ERROR
  }), I = X({
    "a-input__wrapper": !0,
    "a-input__wrapper--inline": !!a
  }), L = (Q) => (A(Q.target.value.length), c && c(Q));
  return /* @__PURE__ */ k("div", { className: D, "data-qa": f, children: [
    _r({ label: i, id: o, required: d, inline: a }),
    wr({ id: o, description: n, state: h }),
    /* @__PURE__ */ p("div", { className: I, children: /* @__PURE__ */ p(
      "textarea",
      {
        value: v,
        name: l,
        id: o,
        disabled: r,
        readOnly: s,
        required: d,
        ...e && u ? { "aria-describedby": `${o}--counter` } : {},
        ...n ? { "aria-describedby": `${o}--description` } : {},
        maxLength: u,
        onChange: L,
        onBlur: O,
        onClick: b,
        onFocus: x,
        onKeyDown: $,
        onKeyUp: P
      }
    ) }),
    Vu({
      id: o,
      charCountText: t,
      charCounter: e,
      characterCount: v ? v.length : m,
      maxLength: u
    })
  ] });
}
function iv({ children: e, type: t, qa: n }) {
  const r = X({
    "a-label": !0,
    [`a-label--${[t]}`]: !!t
  });
  return /* @__PURE__ */ p("span", { className: r, "data-qa": n, children: e });
}
function uv({ items: e = [], qa: t }) {
  return /* @__PURE__ */ p("dl", { className: "a-definition-list", "data-qa": t, children: e.map((n) => /* @__PURE__ */ k(gl, { children: [
    /* @__PURE__ */ p("dt", { "data-qa": n.qaTerm, children: n.term }),
    /* @__PURE__ */ p("dd", { "data-qa": n.qaDescription, children: n.description })
  ] }, n.id)) });
}
function or({ onItemClick: e, type: t, ordered: n, flushed: r, lined: o, children: a, qa: i }) {
  const u = X({
    "a-list": t !== "avatar" && t !== "checkbox",
    "a-list--flushed": !!r && t !== "avatar" && t !== "checkbox",
    "a-list--lined": !!o,
    "a-avatar-list": t === "avatar",
    "a-avatar-list--flushed": !!(t === "avatar" && r),
    "a-checkbox-list": t === "checkbox",
    "a-checkbox-list--flushed": !!(t === "checkbox" && r)
  });
  return /* @__PURE__ */ p(`${n ? "ol" : "ul"}`, { className: u, "data-qa": i, children: ra.map(a || [], (c) => gt(c, {
    key: c.props.id,
    onClick: c.props.onClick || e
  })) });
}
function lv(e) {
  return /* @__PURE__ */ p(or, { type: "avatar", ...e });
}
function cv(e) {
  return /* @__PURE__ */ p(or, { type: "checkbox", ...e });
}
function Li({
  name: e,
  link: t,
  active: n,
  highlighted: r,
  iconLeft: o,
  iconRight: a,
  id: i,
  children: u,
  onClick: l,
  onMouseDown: c,
  tabIndex: f,
  qa: s
}) {
  const d = `${t && (t.href || t.href === "") ? "a" : "span"}`, y = X({
    "a-list__content": !0,
    "is-highlighted": !!r,
    "is-active": !!n
  });
  return /* @__PURE__ */ p("li", { className: "a-list__item", id: i, "data-qa": s, children: /* @__PURE__ */ k(
    d,
    {
      className: y,
      onClick: (v) => {
        l && (v.preventDefault(), l(e));
      },
      onMouseDown: c,
      tabIndex: f,
      ...t && (t.href || t.href === "") ? { href: t.href } : {},
      children: [
        o && /* @__PURE__ */ p(ve, { name: o }),
        /* @__PURE__ */ p("span", { className: "a-list__text", children: u }),
        a && /* @__PURE__ */ p(ve, { name: a })
      ]
    }
  ) });
}
function sv({ avatar: e, name: t, link: n, active: r, user: o, iconRight: a, id: i, onClick: u, qa: l }) {
  const c = `${n && (n.href || n.href === "") ? "a" : "span"}`, f = X({
    "a-avatar-list__item": !0,
    "is-active": !!r
  });
  return /* @__PURE__ */ p("li", { className: f, id: i, "data-qa": l, children: /* @__PURE__ */ k(
    c,
    {
      className: "a-avatar-list__item-container",
      onClick: (d) => {
        u && (d.preventDefault(), u(t));
      },
      ...n && (n.href || n.href === "") ? { href: n.href } : {},
      children: [
        /* @__PURE__ */ p(Bu, { ...e, className: "a-avatar-list__avatar", rounded: !0, size: "small" }),
        /* @__PURE__ */ k("div", { className: "a-avatar-list__content", children: [
          /* @__PURE__ */ k("span", { className: "a-avatar-list__text", children: [
            o?.name ? /* @__PURE__ */ p("span", { className: "avatar-list__name paragraph", children: o.name }) : null,
            o?.function ? /* @__PURE__ */ p("span", { className: "small", children: o.function }) : null,
            o?.email ? /* @__PURE__ */ p("span", { className: "small", children: o.email }) : null
          ] }),
          a && /* @__PURE__ */ p(ve, { name: a })
        ] })
      ]
    }
  ) });
}
function fv({ name: e, onClick: t, qa: n, ...r }) {
  return /* @__PURE__ */ p("li", { className: "a-checkbox-list__item", children: /* @__PURE__ */ p("div", { onClick: () => {
    t && t(e);
  }, className: "a-input a-checkbox-list__checkbox", children: /* @__PURE__ */ p(da, { name: e, ...r }) }) });
}
function dv({
  label: e,
  labelId: t = "aui-progress-label",
  showLabel: n = !0,
  percentage: r = 0,
  ariaValueNow: o,
  minValue: a = 0,
  maxValue: i = 100,
  large: u,
  qa: l
}) {
  const c = o || r, f = X({
    "a-progress": !0,
    "a-progress--l": !!u
  });
  return /* @__PURE__ */ k("div", { className: f, "data-qa": l, children: [
    n ? /* @__PURE__ */ p("div", { id: t, className: "a-progress__label", children: e }) : null,
    /* @__PURE__ */ p("div", { className: "a-progress__inner", children: /* @__PURE__ */ p(
      "div",
      {
        className: "a-progress__bar",
        role: "progressbar",
        "aria-valuenow": c,
        "aria-valuemin": a,
        "aria-valuemax": i,
        style: { width: `${r}%` },
        ...n ? { "aria-labelledby": t } : { "aria-label": e }
      }
    ) })
  ] });
}
function pv({ autoFocus: e, value: t, label: n, id: r, qa: o, name: a, onChange: i, checked: u, disabled: l }) {
  return /* @__PURE__ */ k("div", { className: "a-input__radio", "data-qa": o, children: [
    /* @__PURE__ */ p(
      "input",
      {
        type: "radio",
        id: r,
        checked: u,
        name: a,
        value: t,
        onChange: (f) => {
          i && i(f);
        },
        disabled: l,
        autoFocus: e
      }
    ),
    /* @__PURE__ */ p("label", { htmlFor: r, children: n })
  ] });
}
function yv({ label: e, name: t, children: n = [], value: r, qa: o, onChange: a }) {
  const i = (l) => a && a(l.target?.value), u = X({
    "a-input": !0
  });
  return /* @__PURE__ */ k("fieldset", { className: u, "data-qa": o, children: [
    /* @__PURE__ */ p("legend", { className: "a-input__label", children: e }),
    ra.map(n, (l) => gt(l, {
      name: t,
      onChange: i,
      ...r ? { checked: l.props.value === r } : {},
      ...l.props
    }))
  ] });
}
const Wi = (e, t) => Array(t - e + 1).fill(0).map((n, r) => r + e), Jy = (e, t) => {
  const n = t <= 7 ? 7 : e > 4 && e < t - 3 ? 2 : 4;
  let r = Math.round(e - n / 2), o = Math.round(e + n / 2);
  (r - 1 === 1 || o + 1 === t) && (r += 1, o += 1);
  let a = e > n ? Wi(Math.min(r, t - n), Math.min(o, t)) : Wi(1, Math.min(t, n + 1));
  return a[0] !== 1 && (a = [1, 0].concat(a)), a[a.length - 1] < t && (a = a.concat([0, t])), a;
}, Zy = (e, t, n, r) => {
  const o = n - t, i = (e - t) / o;
  return Math.round(i * r);
}, eh = (e, t, n) => Math.min(Math.max(e, t), n), th = (e, t) => t ? e - t : e, nh = (e, t, n, r, o, a, i) => {
  const u = eh(e, 0, t) / (t || 1);
  let c = n * Math.round(u * (i - a)) / n + a;
  return c >= o && (c = o), c <= r && (c = r), c;
}, Xu = (e, t, n, r, o, a, i, u) => {
  const l = "clientX", c = e.type !== "touchmove" ? e[l] : e.touches[0][l], f = th(c, u);
  return nh(f, t, n, r, o, a, i);
}, rh = (e, t, n) => {
  const r = [];
  if (n <= 0)
    return [t];
  for (let o = e; o < t; o += n)
    r.push(o);
  return [...r, t];
};
function oh({ start: e, end: t, range: n, min: r, getPositionFromValue: o }) {
  return /* @__PURE__ */ p(
    "div",
    {
      className: "a-range-slider__bar",
      style: {
        left: n ? o(e) + "px" : "",
        width: n && t ? o(t + r - e) + "px" : o(e) + "px"
      }
    }
  );
}
function ji({
  value: e,
  min: t,
  max: n,
  sliderMin: r,
  sliderMax: o,
  step: a,
  direction: i,
  sliderPos: u,
  onUpdate: l,
  getPositionFromValue: c,
  ariaLabel: f
}) {
  const [s, d] = ge.useState(0), y = ge.useRef(null);
  ge.useEffect(() => {
    u && d(u);
  }, [i, u]);
  const h = (P) => {
    P.stopPropagation(), P.preventDefault();
  }, v = () => {
    document.addEventListener("mousemove", O), document.addEventListener("mouseup", b);
  }, O = (P) => {
    P.type === "mousemove" ? h(P) : P.stopPropagation();
    const m = x(P);
    return l && l(m);
  }, b = (P) => {
    document.removeEventListener("mousemove", O), document.removeEventListener("mouseup", b);
    const m = x(P);
    return l && l(m);
  }, x = (P) => Xu(P, s, a, t, n, r, o, i), $ = (P) => {
    let m = e;
    P.key === "ArrowUp" || P.key === "ArrowRight" ? (P.preventDefault(), m += a) : P.key === "ArrowDown" || P.key === "ArrowLeft" ? (P.preventDefault(), m -= a) : P.key === "End" ? (P.preventDefault(), m = n) : P.key === "Home" && (P.preventDefault(), m = t), m >= t && m <= n && l(m);
  };
  return /* @__PURE__ */ p(
    "div",
    {
      className: "a-range-slider__handle",
      tabIndex: 0,
      style: {
        left: c(e) + "px"
      },
      onMouseDown: v,
      onTouchEnd: h,
      onTouchMove: O,
      onKeyDown: $,
      role: "slider",
      "aria-orientation": "horizontal",
      "aria-valuemax": n,
      "aria-valuemin": t,
      "aria-valuenow": e,
      "aria-label": f,
      ref: y
    }
  );
}
function hv({
  label: e,
  start: t = 0,
  end: n,
  min: r = 0,
  max: o = 10,
  step: a = 1,
  unit: i = "",
  minRange: u = 1,
  range: l = !1,
  labelStart: c,
  labelEnd: f,
  iconStart: s,
  iconEnd: d,
  ariaLabelMin: y = "Minimum",
  ariaLabelMax: h = "Maximimum",
  tickMarks: v,
  qa: O,
  onChange: b
}) {
  const [x, $] = ge.useState(0), [P, m] = ge.useState(0), [A, D] = ge.useState(0), I = ge.useRef(null);
  ge.useEffect(() => (window.addEventListener("resize", L), L(), () => window.removeEventListener("resize", L)), []);
  const L = () => {
    if (I.current) {
      const S = I.current.offsetWidth, C = I.current;
      if (C && C instanceof HTMLElement) {
        const g = C.getBoundingClientRect().left;
        D(g);
      }
      $(S), m(S);
    }
  }, Q = (S) => {
    if (!(l && n && u && n - S < u))
      return b && b(S, l ? n : void 0);
  }, W = (S) => {
    if (!(t && u && S - t < u))
      return b && b(t, S);
  }, z = (S) => Zy(S, r, o, x), J = (S) => Xu(S, x, a, r, o, r, o, A), N = (S) => {
    const C = J(S);
    if (l && n && Math.abs(C - n) < Math.abs(C - t)) {
      W(C);
      return;
    }
    Q(C);
  };
  return /* @__PURE__ */ k("div", { className: "a-range-slider", "data-qa": O, ref: I, children: [
    /* @__PURE__ */ k("div", { className: "a-range-slider__labels", children: [
      /* @__PURE__ */ p("div", { className: "a-range-slider__label", children: e }),
      /* @__PURE__ */ k("div", { className: "a-range-slider__label", children: [
        l ? `${t} - ${n}` : `${t}`,
        ` ${i}`
      ] })
    ] }),
    /* @__PURE__ */ k("div", { className: "a-range-slider__inner", onClick: N, children: [
      v && /* @__PURE__ */ p("div", { className: "a-range-slider__tickmarks", children: rh(r, o, a).map((S) => /* @__PURE__ */ p("div", { className: "a-range-slider__tickmark" }, S)) }),
      /* @__PURE__ */ p(oh, { start: t, end: n, getPositionFromValue: z, range: !!l, min: r }),
      /* @__PURE__ */ p(
        ji,
        {
          value: t,
          onUpdate: Q,
          min: r,
          max: l && u ? o - u : o,
          sliderMin: r,
          sliderMax: o,
          step: a,
          sliderPos: P,
          direction: A,
          getPositionFromValue: z,
          ariaLabel: y
        }
      ),
      l && typeof u == "number" && typeof n == "number" && /* @__PURE__ */ p(
        ji,
        {
          value: n,
          onUpdate: W,
          min: r + u,
          max: o,
          sliderMin: r,
          sliderMax: o,
          step: a,
          sliderPos: P,
          direction: A,
          getPositionFromValue: z,
          ariaLabel: h
        }
      )
    ] }),
    /* @__PURE__ */ k("div", { className: "a-range-slider__descriptions", children: [
      /* @__PURE__ */ k("div", { className: "a-range-slider__description small", children: [
        c,
        s ? /* @__PURE__ */ p(ve, { name: s }) : null
      ] }),
      /* @__PURE__ */ k("div", { className: "a-range-slider__description small", children: [
        f,
        d ? /* @__PURE__ */ p(ve, { name: d }) : null
      ] })
    ] })
  ] });
}
function mv({
  description: e,
  disabled: t,
  id: n,
  inline: r,
  label: o,
  name: a,
  options: i,
  placeholder: u = "Maak een keuze",
  required: l,
  size: c,
  state: f,
  value: s,
  onChange: d,
  qa: y
}) {
  const h = (b) => d && d(b), v = X({
    "a-input": !0,
    "has-icon-right": !0,
    "a-input--inline": !!r,
    [`a-input--${ke[c || Me]}`]: !!c,
    "has-error": f === "error"
  }), O = X({
    "a-input__wrapper": !0,
    "a-input__wrapper--inline": !!r
  });
  return /* @__PURE__ */ k("div", { className: v, "data-qa": y, children: [
    _r({ label: o, id: n, required: l, inline: r }),
    wr({ id: n, description: e, state: f }),
    /* @__PURE__ */ k("div", { className: O, children: [
      /* @__PURE__ */ k(
        "select",
        {
          disabled: t,
          name: a,
          id: n,
          value: s,
          defaultValue: !s && u || void 0,
          onChange: h,
          children: [
            /* @__PURE__ */ p("option", { disabled: !0, children: u }),
            (i || []).map((b, x) => /* @__PURE__ */ p("option", { value: b.value, disabled: b.disabled, children: b.label }, `${b.value}-${x}`))
          ]
        },
        s
      ),
      /* @__PURE__ */ p(ve, { name: "arrow-down-1" })
    ] })
  ] });
}
function vv({
  ariaLabel: e,
  checked: t,
  disabled: n = !1,
  id: r,
  internalIOLabels: o = !1,
  label: a,
  labelId: i = "aui-switch-label",
  onClick: u,
  qa: l,
  statusLabelOff: c = "Uit",
  statusLabelOn: f = "Aan",
  statusLabelSide: s = ""
}) {
  const [d, y] = fe(!!t), h = t === !0 || t === !1 ? !!t : d, v = (b) => {
    y(!d), u && typeof u == "function" && u(b);
  }, O = /* @__PURE__ */ k(lt, { children: [
    /* @__PURE__ */ p("div", { className: "a-switch__label a-switch__label--on", "aria-hidden": "true", children: f }),
    /* @__PURE__ */ p("div", { className: "a-switch__label a-switch__label--off", "aria-hidden": "true", children: c })
  ] });
  return Gy(
    /* @__PURE__ */ k(
      "button",
      {
        id: r,
        "data-qa": l,
        className: "a-switch",
        role: "switch",
        "aria-checked": h,
        "aria-label": a ? void 0 : e,
        "aria-labelledby": a ? i : void 0,
        disabled: n,
        onClick: v,
        children: [
          s === "left" && O,
          /* @__PURE__ */ p("div", { className: "a-switch__toggle", "aria-hidden": "true", children: o && /* @__PURE__ */ k(lt, { children: [
            /* @__PURE__ */ p("div", { className: "a-switch__toggle-label a-switch__toggle-label--on", "aria-hidden": "true", children: "i" }),
            /* @__PURE__ */ p("div", { className: "a-switch__toggle-label a-switch__toggle-label--off", "aria-hidden": "true", children: "o" })
          ] }) }),
          s === "right" && O
        ]
      }
    ),
    a,
    r,
    i
  );
}
function ah({
  columns: e,
  selectable: t,
  selected: n = [],
  rows: r = [],
  onSelectAll: o,
  sort: a,
  small: i,
  sortDirection: u,
  tableId: l,
  onSortClick: c,
  actions: f
}) {
  const s = n.length && n.sort().join(",") === r.map((d) => d.id).sort().join(",");
  return /* @__PURE__ */ p("thead", { children: /* @__PURE__ */ k("tr", { children: [
    t ? /* @__PURE__ */ p("th", { children: /* @__PURE__ */ p(
      da,
      {
        name: `aui-table-checkbox-${l}-all`,
        id: `aui-table-checkbox-${l}-all`,
        checked: !!s,
        indeterminate: !!n.length && !s,
        onChange: o,
        label: "selecteren",
        showLabel: !1
      }
    ) }) : null,
    e.map((d) => {
      const y = X({
        "u-text-right": !!d.alignRight,
        "is-collapsed": !!d.sortable,
        "is-condensed": !!i
      }), h = a === d?.value && u === ki, v = a === d?.value && u === Ai, O = X({
        "a-table__sort-button": !0,
        "a-table__sort-button--unsorted": a !== d?.value,
        "a-table__sort-button--sorted-asc": h,
        "a-table__sort-button--sorted-desc": v
      });
      return /* @__PURE__ */ p(
        "th",
        {
          className: y,
          ...d.sortable && (h || v) && { "aria-sort": h ? ki : Ai },
          ...d.sortable && { "aria-live": "polite" },
          children: gr(
            d?.label,
            /* @__PURE__ */ p("button", { onClick: (b) => c && c(d.value), className: O }),
            !!d?.sortable
          )
        },
        d?.value
      );
    }),
    f?.buttons?.length ? /* @__PURE__ */ p("th", { children: f?.label }) : null
  ] }) });
}
function ih({
  actions: e,
  columns: t,
  small: n,
  tableId: r,
  selectable: o,
  onSelect: a,
  selected: i = [],
  rows: u
}) {
  const l = X({
    "is-clickable": !!o
  }), c = (f, s) => {
    const d = f.target;
    return d?.classList.contains("a-button") || d.parentElement?.parentElement?.classList.contains("a-button") ? !1 : (f.preventDefault(), f.stopPropagation(), o && a && a(s.id));
  };
  return /* @__PURE__ */ p("tbody", { children: u.map((f) => /* @__PURE__ */ k("tr", { onClick: (s) => c(s, f), className: l, children: [
    o ? /* @__PURE__ */ p("td", { children: /* @__PURE__ */ p(
      da,
      {
        name: `aui-table-checkbox-${r}-${f.id}`,
        id: `aui-table-checkbox-row-${r}-${f.id}`,
        checked: (i || []).includes(f.id),
        onChange: (s) => c(s, f),
        label: f.checkboxLabel,
        showLabel: !1
      }
    ) }) : null,
    t.map((s) => {
      const d = X({
        "u-text-right": !!s.alignRight,
        "u-text-bold": s.dataType === "primary",
        small: s.dataType === "secondary",
        "is-condensed": !!n
      });
      return /* @__PURE__ */ p("td", { className: d, children: s.transformFunction ? s.transformFunction(f[s?.value] || null) : f[s?.value] || null }, s?.value);
    }),
    gr(
      e?.buttons?.map((s) => /* @__PURE__ */ p(
        Ce,
        {
          onClick: (d) => s?.onActionClick && s?.onActionClick(d, f.id),
          ...s,
          id: `aui-table-action-${r}-${s?.id}-${f.id}`,
          size: s?.size || "small",
          children: s?.label || s?.children
        },
        `aui-table-action-${r}-${s?.id}-${f.id}`
      )) || null,
      /* @__PURE__ */ p("td", {}),
      !!e?.buttons?.length
    )
  ] }, f?.id)) });
}
function Gu() {
  const [e, t] = fe(!0), [n, r] = fe(!0), o = je(null), a = (u) => {
    t(u.scrollLeft <= 0), r(Yy(u));
  };
  return $e(() => {
    const u = o.current;
    u && a(u);
  }, [o]), $e(() => {
    function u() {
      o.current && a(o.current);
    }
    return window.addEventListener("resize", u), () => window.removeEventListener("resize", u);
  }, []), [o, (u) => {
    const l = u.target;
    a(l);
  }, e, n];
}
function uh(e) {
  const t = je(null), n = (r) => {
    t?.current?.contains(r?.target) || e(r?.target);
  };
  return $e(() => (window.addEventListener("click", n), () => {
    window.removeEventListener("click", n);
  })), { elementRef: t };
}
function bv({
  id: e = "aui-table",
  sort: t,
  sortDirection: n,
  rows: r = [],
  columns: o = [],
  qa: a,
  striped: i,
  small: u,
  open: l,
  selectable: c,
  selected: f,
  onSelect: s,
  onSelectAll: d,
  onSortClick: y,
  actions: h,
  responsive: v = !0,
  fixedColumnRight: O,
  fixedColumnLeft: b
}) {
  const [x, $, P, m] = Gu(), A = X({
    "a-table": !0,
    "a-table--striped": !!i,
    "a-table--open": !!l
  }), D = X({
    "a-table-responsive-wrapper": !!v,
    "has-shadow-left": !!v && !P,
    "has-shadow-right": !!v && !m,
    "has-first-column-fixed": !!b,
    "has-last-column-fixed": !!O
  }), I = /* @__PURE__ */ k("table", { id: e, className: A, "data-qa": a, children: [
    /* @__PURE__ */ p(
      ah,
      {
        tableId: e,
        small: u,
        selectable: c,
        selected: f,
        columns: o,
        sort: t,
        rows: r,
        onSortClick: y,
        sortDirection: n,
        onSelectAll: d,
        actions: h
      }
    ),
    /* @__PURE__ */ p(
      ih,
      {
        tableId: e,
        small: u,
        selectable: c,
        selected: f,
        columns: o,
        rows: r,
        onSelect: s,
        actions: h
      }
    )
  ] });
  return v ? /* @__PURE__ */ p("div", { className: D, "data-qa": a, children: /* @__PURE__ */ p("div", { ref: x, onScroll: $, className: "a-table-scrollable-wrapper", children: I }) }) : I;
}
function gv({
  checked: e = !1,
  checkedTheme: t = "",
  checkedIcon: n,
  checkedLabel: r = "",
  id: o,
  onClick: a,
  qa: i,
  showLabels: u = !1,
  size: l,
  uncheckedTheme: c = "danger",
  uncheckedIcon: f,
  uncheckedLabel: s = ""
}) {
  const d = () => {
    a && a(!e);
  }, y = X({
    "a-toggle": !0,
    [`a-toggle--${ke[l || Me]}`]: !!l
  }), h = (b, x, $) => X({
    "a-button": !0,
    [`a-button--${ke[l || Me]}`]: !!l,
    [`a-button--${b}`]: !!b,
    "has-icon-left": !!u && !!x,
    "has-icon": !u && !!x,
    [`a-toggle__${$}`]: !!$
  }), v = h(t, n, "on"), O = h(c, f, "off");
  return /* @__PURE__ */ p("div", { className: y, "data-qa": i, children: /* @__PURE__ */ k("button", { className: "a-toggle__button", id: o, "aria-expanded": e, onClick: d, children: [
    /* @__PURE__ */ k("span", { className: v, children: [
      n ? /* @__PURE__ */ p(ve, { name: n, screenReaderText: u ? "" : r }) : null,
      u && /* @__PURE__ */ p("span", { className: "a-toggle__label", children: r })
    ] }),
    /* @__PURE__ */ k("span", { className: O, children: [
      f ? /* @__PURE__ */ p(ve, { name: f, screenReaderText: u ? "" : s }) : null,
      u && /* @__PURE__ */ p("span", { className: "a-toggle__label", children: s })
    ] })
  ] }) });
}
var Qe, rt = { exports: {} }, qi = {};
/** @license React v16.14.0
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Qe = qi, function() {
  var e = ge, t = 60103, n = 60106;
  Qe.Fragment = 60107;
  var r = 60108, o = 60114, a = 60109, i = 60110, u = 60112, l = 60113, c = 60120, f = 60115, s = 60116, d = 60121, y = 60122, h = 60117, v = 60129, O = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var b = Symbol.for;
    t = b("react.element"), n = b("react.portal"), Qe.Fragment = b("react.fragment"), r = b("react.strict_mode"), o = b("react.profiler"), a = b("react.provider"), i = b("react.context"), u = b("react.forward_ref"), l = b("react.suspense"), c = b("react.suspense_list"), f = b("react.memo"), s = b("react.lazy"), d = b("react.block"), y = b("react.server.block"), h = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), v = b("react.debug_trace_mode"), b("react.offscreen"), O = b("react.legacy_hidden");
  }
  var x = typeof Symbol == "function" && Symbol.iterator, $ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  function P(w) {
    for (var H = arguments.length, T = new Array(H > 1 ? H - 1 : 0), oe = 1; oe < H; oe++)
      T[oe - 1] = arguments[oe];
    m("error", w, T);
  }
  function m(w, H, T) {
    var oe = $.ReactDebugCurrentFrame, re = "";
    if (L) {
      var te = D(L.type), ie = L._owner;
      re += function(M, ue, ae) {
        var K = "";
        if (ue) {
          var pe = ue.fileName, ee = pe.replace(A, "");
          if (/^index\./.test(ee)) {
            var Ne = pe.match(A);
            if (Ne) {
              var Pe = Ne[1];
              Pe && (ee = Pe.replace(A, "") + "/" + ee);
            }
          }
          K = " (at " + ee + ":" + ue.lineNumber + ")";
        } else
          ae && (K = " (created by " + ae + ")");
        return `
    in ` + (M || "Unknown") + K;
      }(te, L._source, ie && D(ie.type));
    }
    (re += oe.getStackAddendum()) !== "" && (H += "%s", T = T.concat([re]));
    var q = T.map(function(M) {
      return "" + M;
    });
    q.unshift("Warning: " + H), Function.prototype.apply.call(console[w], console, q);
  }
  var A = /^(.*)[\\\/]/;
  function D(w) {
    if (w == null)
      return null;
    if (typeof w.tag == "number" && P("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof w == "function")
      return w.displayName || w.name || null;
    if (typeof w == "string")
      return w;
    switch (w) {
      case Qe.Fragment:
        return "Fragment";
      case n:
        return "Portal";
      case o:
        return "Profiler";
      case r:
        return "StrictMode";
      case l:
        return "Suspense";
      case c:
        return "SuspenseList";
    }
    if (typeof w == "object")
      switch (w.$$typeof) {
        case i:
          return "Context.Consumer";
        case a:
          return "Context.Provider";
        case u:
          return oe = w, re = w.render, te = "ForwardRef", ie = re.displayName || re.name || "", oe.displayName || (ie !== "" ? te + "(" + ie + ")" : te);
        case f:
          return D(w.type);
        case d:
          return D(w.render);
        case s:
          var H = (T = w)._status === 1 ? T._result : null;
          if (H)
            return D(H);
      }
    var T, oe, re, te, ie;
    return null;
  }
  var I = {};
  $.ReactDebugCurrentFrame;
  var L = null;
  function Q(w) {
    L = w;
  }
  var W, z, J, N = $.ReactCurrentOwner, S = Object.prototype.hasOwnProperty, C = { key: !0, ref: !0, __self: !0, __source: !0 };
  function g(w, H, T, oe, re) {
    var te, ie = {}, q = null, M = null;
    for (te in T !== void 0 && (q = "" + T), function(K) {
      if (S.call(K, "key")) {
        var pe = Object.getOwnPropertyDescriptor(K, "key").get;
        if (pe && pe.isReactWarning)
          return !1;
      }
      return K.key !== void 0;
    }(H) && (q = "" + H.key), function(K) {
      if (S.call(K, "ref")) {
        var pe = Object.getOwnPropertyDescriptor(K, "ref").get;
        if (pe && pe.isReactWarning)
          return !1;
      }
      return K.ref !== void 0;
    }(H) && (M = H.ref, function(K, pe) {
      if (typeof K.ref == "string" && N.current && pe && N.current.stateNode !== pe) {
        var ee = D(N.current.type);
        J[ee] || (P('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(N.current.type), K.ref), J[ee] = !0);
      }
    }(H, re)), H)
      S.call(H, te) && !C.hasOwnProperty(te) && (ie[te] = H[te]);
    if (w && w.defaultProps) {
      var ue = w.defaultProps;
      for (te in ue)
        ie[te] === void 0 && (ie[te] = ue[te]);
    }
    if (q || M) {
      var ae = typeof w == "function" ? w.displayName || w.name || "Unknown" : w;
      q && function(K, pe) {
        var ee = function() {
          W || (W = !0, P("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", pe));
        };
        ee.isReactWarning = !0, Object.defineProperty(K, "key", { get: ee, configurable: !0 });
      }(ie, ae), M && function(K, pe) {
        var ee = function() {
          z || (z = !0, P("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", pe));
        };
        ee.isReactWarning = !0, Object.defineProperty(K, "ref", { get: ee, configurable: !0 });
      }(ie, ae);
    }
    return function(K, pe, ee, Ne, Pe, Ae, Pt) {
      var De = { $$typeof: t, type: K, key: pe, ref: ee, props: Pt, _owner: Ae, _store: {} };
      return Object.defineProperty(De._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: !1 }), Object.defineProperty(De, "_self", { configurable: !1, enumerable: !1, writable: !1, value: Ne }), Object.defineProperty(De, "_source", { configurable: !1, enumerable: !1, writable: !1, value: Pe }), Object.freeze && (Object.freeze(De.props), Object.freeze(De)), De;
    }(w, q, M, re, oe, N.current, ie);
  }
  J = {};
  var j, ce = $.ReactCurrentOwner;
  function _(w) {
    L = w;
  }
  function R(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }
  function Y() {
    if (ce.current) {
      var w = D(ce.current.type);
      if (w)
        return `

Check the render method of \`` + w + "`.";
    }
    return "";
  }
  $.ReactDebugCurrentFrame, j = !1;
  var E = {};
  function U(w, H) {
    if (w._store && !w._store.validated && w.key == null) {
      w._store.validated = !0;
      var T = function(re) {
        var te = Y();
        if (!te) {
          var ie = typeof re == "string" ? re : re.displayName || re.name;
          ie && (te = `

Check the top-level render call using <` + ie + ">.");
        }
        return te;
      }(H);
      if (!E[T]) {
        E[T] = !0;
        var oe = "";
        w && w._owner && w._owner !== ce.current && (oe = " It was passed a child from " + D(w._owner.type) + "."), _(w), P('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', T, oe), _(null);
      }
    }
  }
  function Z(w, H) {
    if (typeof w == "object") {
      if (Array.isArray(w))
        for (var T = 0; T < w.length; T++) {
          var oe = w[T];
          R(oe) && U(oe, H);
        }
      else if (R(w))
        w._store && (w._store.validated = !0);
      else if (w) {
        var re = function(q) {
          if (q === null || typeof q != "object")
            return null;
          var M = x && q[x] || q["@@iterator"];
          return typeof M == "function" ? M : null;
        }(w);
        if (typeof re == "function" && re !== w.entries)
          for (var te, ie = re.call(w); !(te = ie.next()).done; )
            R(te.value) && U(te.value, H);
      }
    }
  }
  function V(w) {
    var H, T = w.type;
    if (T != null && typeof T != "string") {
      if (typeof T == "function")
        H = T.propTypes;
      else {
        if (typeof T != "object" || T.$$typeof !== u && T.$$typeof !== f)
          return;
        H = T.propTypes;
      }
      if (H) {
        var oe = D(T);
        (function(re, te, ie, q, M) {
          var ue = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var ae in re)
            if (ue(re, ae)) {
              var K = void 0;
              try {
                if (typeof re[ae] != "function") {
                  var pe = Error((q || "React class") + ": " + ie + " type `" + ae + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof re[ae] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw pe.name = "Invariant Violation", pe;
                }
                K = re[ae](te, ae, q, ie, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ee) {
                K = ee;
              }
              !K || K instanceof Error || (Q(M), P("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", q || "React class", ie, ae, typeof K), Q(null)), K instanceof Error && !(K.message in I) && (I[K.message] = !0, Q(M), P("Failed %s type: %s", ie, K.message), Q(null));
            }
        })(H, w.props, "prop", oe, w);
      } else
        T.PropTypes === void 0 || j || (j = !0, P("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", D(T) || "Unknown"));
      typeof T.getDefaultProps != "function" || T.getDefaultProps.isReactClassApproved || P("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
  }
  function G(w, H, T, oe, re, te) {
    var ie = function(ee) {
      return typeof ee == "string" || typeof ee == "function" || ee === Qe.Fragment || ee === o || ee === v || ee === r || ee === l || ee === c || ee === O || typeof ee == "object" && ee !== null && (ee.$$typeof === s || ee.$$typeof === f || ee.$$typeof === a || ee.$$typeof === i || ee.$$typeof === u || ee.$$typeof === h || ee.$$typeof === d || ee[0] === y);
    }(w);
    if (!ie) {
      var q = "";
      (w === void 0 || typeof w == "object" && w !== null && Object.keys(w).length === 0) && (q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
      var M, ue = function(ee) {
        return ee !== void 0 ? `

Check your code at ` + ee.fileName.replace(/^.*[\\\/]/, "") + ":" + ee.lineNumber + "." : "";
      }(re);
      q += ue || Y(), w === null ? M = "null" : Array.isArray(w) ? M = "array" : w !== void 0 && w.$$typeof === t ? (M = "<" + (D(w.type) || "Unknown") + " />", q = " Did you accidentally export a JSX literal instead of a component?") : M = typeof w, P("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, q);
    }
    var ae = g(w, H, T, re, te);
    if (ae == null)
      return ae;
    if (ie) {
      var K = H.children;
      if (K !== void 0)
        if (oe)
          if (Array.isArray(K)) {
            for (var pe = 0; pe < K.length; pe++)
              Z(K[pe], w);
            Object.freeze && Object.freeze(K);
          } else
            P("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
        else
          Z(K, w);
    }
    return w === Qe.Fragment ? function(ee) {
      for (var Ne = Object.keys(ee.props), Pe = 0; Pe < Ne.length; Pe++) {
        var Ae = Ne[Pe];
        if (Ae !== "children" && Ae !== "key") {
          _(ee), P("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ae), _(null);
          break;
        }
      }
      ee.ref !== null && (_(ee), P("Invalid attribute `ref` supplied to `React.Fragment`."), _(null));
    }(ae) : V(ae), ae;
  }
  var B = function(w, H, T) {
    return G(w, H, T, !1);
  }, F = function(w, H, T) {
    return G(w, H, T, !0);
  };
  Qe.jsx = B, Qe.jsxs = F;
}(), rt.exports = qi;
var Nr, Ku = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
Nr = Ku, function() {
  var e = {}.hasOwnProperty;
  function t() {
    for (var n = [], r = 0; r < arguments.length; r++) {
      var o = arguments[r];
      if (o) {
        var a = typeof o;
        if (a === "string" || a === "number")
          n.push(o);
        else if (Array.isArray(o)) {
          if (o.length) {
            var i = t.apply(null, o);
            i && n.push(i);
          }
        } else if (a === "object") {
          if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
            n.push(o.toString());
            continue;
          }
          for (var u in o)
            e.call(o, u) && o[u] && n.push(u);
        }
      }
    }
    return n.join(" ");
  }
  Nr.exports ? (t.default = t, Nr.exports = t) : window.classNames = t;
}();
var Fi = Ku.exports;
const Hi = (e, t, n) => {
  let r = null;
  return function(...o) {
    r && clearTimeout(r), r = setTimeout(() => {
      r = null, n || e.apply(this, o);
    }, t);
  };
}, lh = ({ content: e }) => rt.exports.jsx("span", { dangerouslySetInnerHTML: { __html: e } }), ch = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, sh = _l({ getTooltipData: () => ch });
function Ju(e = "DEFAULT_TOOLTIP_ID") {
  return wl(sh).getTooltipData(e);
}
function Ct(e) {
  return e.split("-")[0];
}
function Or(e) {
  return e.split("-")[1];
}
function $t(e) {
  return ["top", "bottom"].includes(Ct(e)) ? "x" : "y";
}
function pa(e) {
  return e === "y" ? "height" : "width";
}
function Yi(e, t, n) {
  let { reference: r, floating: o } = e;
  const a = r.x + r.width / 2 - o.width / 2, i = r.y + r.height / 2 - o.height / 2, u = $t(t), l = pa(u), c = r[l] / 2 - o[l] / 2, f = u === "x";
  let s;
  switch (Ct(t)) {
    case "top":
      s = { x: a, y: r.y - o.height };
      break;
    case "bottom":
      s = { x: a, y: r.y + r.height };
      break;
    case "right":
      s = { x: r.x + r.width, y: i };
      break;
    case "left":
      s = { x: r.x - o.width, y: i };
      break;
    default:
      s = { x: r.x, y: r.y };
  }
  switch (Or(t)) {
    case "start":
      s[u] -= c * (n && f ? -1 : 1);
      break;
    case "end":
      s[u] += c * (n && f ? -1 : 1);
  }
  return s;
}
function Zu(e) {
  return typeof e != "number" ? function(t) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...t };
  }(e) : { top: e, right: e, bottom: e, left: e };
}
function ar(e) {
  return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
}
async function el(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: r, y: o, platform: a, rects: i, elements: u, strategy: l } = e, { boundary: c = "clippingAncestors", rootBoundary: f = "viewport", elementContext: s = "floating", altBoundary: d = !1, padding: y = 0 } = t, h = Zu(y), v = u[d ? s === "floating" ? "reference" : "floating" : s], O = ar(await a.getClippingRect({ element: (n = await (a.isElement == null ? void 0 : a.isElement(v))) == null || n ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(u.floating)), boundary: c, rootBoundary: f, strategy: l })), b = ar(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: s === "floating" ? { ...i.floating, x: r, y: o } : i.reference, offsetParent: await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u.floating)), strategy: l }) : i[s]);
  return { top: O.top - b.top + h.top, bottom: b.bottom - O.bottom + h.bottom, left: O.left - b.left + h.left, right: b.right - O.right + h.right };
}
const fh = Math.min, dh = Math.max;
function Dr(e, t, n) {
  return dh(e, fh(t, n));
}
const ph = { left: "right", right: "left", bottom: "top", top: "bottom" };
function Dt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => ph[t]);
}
const yh = { start: "end", end: "start" };
function Bi(e) {
  return e.replace(/start|end/g, (t) => yh[t]);
}
const hh = function(e) {
  return e === void 0 && (e = {}), { name: "flip", options: e, async fn(t) {
    var n;
    const { placement: r, middlewareData: o, rects: a, initialPlacement: i, platform: u, elements: l } = t, { mainAxis: c = !0, crossAxis: f = !0, fallbackPlacements: s, fallbackStrategy: d = "bestFit", flipAlignment: y = !0, ...h } = e, v = Ct(r), O = s || (v === i || !y ? [Dt(i)] : function(I) {
      const L = Dt(I);
      return [Bi(I), L, Bi(L)];
    }(i)), b = [i, ...O], x = await el(t, h), $ = [];
    let P = ((n = o.flip) == null ? void 0 : n.overflows) || [];
    if (c && $.push(x[v]), f) {
      const { main: I, cross: L } = function(Q, W, z) {
        z === void 0 && (z = !1);
        const J = Or(Q), N = $t(Q), S = pa(N);
        let C = N === "x" ? J === (z ? "end" : "start") ? "right" : "left" : J === "start" ? "bottom" : "top";
        return W.reference[S] > W.floating[S] && (C = Dt(C)), { main: C, cross: Dt(C) };
      }(r, a, await (u.isRTL == null ? void 0 : u.isRTL(l.floating)));
      $.push(x[I], x[L]);
    }
    if (P = [...P, { placement: r, overflows: $ }], !$.every((I) => I <= 0)) {
      var m, A;
      const I = ((m = (A = o.flip) == null ? void 0 : A.index) != null ? m : 0) + 1, L = b[I];
      if (L)
        return { data: { index: I, overflows: P }, reset: { placement: L } };
      let Q = "bottom";
      switch (d) {
        case "bestFit": {
          var D;
          const W = (D = P.map((z) => [z, z.overflows.filter((J) => J > 0).reduce((J, N) => J + N, 0)]).sort((z, J) => z[1] - J[1])[0]) == null ? void 0 : D[0].placement;
          W && (Q = W);
          break;
        }
        case "initialPlacement":
          Q = i;
      }
      if (r !== Q)
        return { reset: { placement: Q } };
    }
    return {};
  } };
}, mh = function(e) {
  return e === void 0 && (e = 0), { name: "offset", options: e, async fn(t) {
    const { x: n, y: r } = t, o = await async function(a, i) {
      const { placement: u, platform: l, elements: c } = a, f = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), s = Ct(u), d = Or(u), y = $t(u) === "x", h = ["left", "top"].includes(s) ? -1 : 1, v = f && y ? -1 : 1, O = typeof i == "function" ? i(a) : i;
      let { mainAxis: b, crossAxis: x, alignmentAxis: $ } = typeof O == "number" ? { mainAxis: O, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...O };
      return d && typeof $ == "number" && (x = d === "end" ? -1 * $ : $), y ? { x: x * v, y: b * h } : { x: b * h, y: x * v };
    }(t, e);
    return { x: n + o.x, y: r + o.y, data: o };
  } };
};
function tl(e) {
  return e && e.document && e.location && e.alert && e.setInterval;
}
function ze(e) {
  if (e == null)
    return window;
  if (!tl(e)) {
    const t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Ke(e) {
  return ze(e).getComputedStyle(e);
}
function Je(e) {
  return tl(e) ? "" : e ? (e.nodeName || "").toLowerCase() : "";
}
function nl() {
  const e = navigator.userAgentData;
  return e != null && e.brands ? e.brands.map((t) => t.brand + "/" + t.version).join(" ") : navigator.userAgent;
}
function Be(e) {
  return e instanceof ze(e).HTMLElement;
}
function mt(e) {
  return e instanceof ze(e).Element;
}
function zi(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ze(e).ShadowRoot || e instanceof ShadowRoot;
}
function Pr(e) {
  const { overflow: t, overflowX: n, overflowY: r, display: o } = Ke(e);
  return /auto|scroll|overlay|hidden/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function vh(e) {
  return ["table", "td", "th"].includes(Je(e));
}
function Zo(e) {
  const t = /firefox/i.test(nl()), n = Ke(e), r = n.backdropFilter || n.WebkitBackdropFilter;
  return n.transform !== "none" || n.perspective !== "none" || !!r && r !== "none" || t && n.willChange === "filter" || t && !!n.filter && n.filter !== "none" || ["transform", "perspective"].some((o) => n.willChange.includes(o)) || ["paint", "layout", "strict", "content"].some((o) => {
    const a = n.contain;
    return a != null && a.includes(o);
  });
}
function rl() {
  return !/^((?!chrome|android).)*safari/i.test(nl());
}
function ya(e) {
  return ["html", "body", "#document"].includes(Je(e));
}
const Vi = Math.min, St = Math.max, ir = Math.round;
function ot(e, t, n) {
  var r, o, a, i;
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const u = e.getBoundingClientRect();
  let l = 1, c = 1;
  t && Be(e) && (l = e.offsetWidth > 0 && ir(u.width) / e.offsetWidth || 1, c = e.offsetHeight > 0 && ir(u.height) / e.offsetHeight || 1);
  const f = mt(e) ? ze(e) : window, s = !rl() && n, d = (u.left + (s && (r = (o = f.visualViewport) == null ? void 0 : o.offsetLeft) != null ? r : 0)) / l, y = (u.top + (s && (a = (i = f.visualViewport) == null ? void 0 : i.offsetTop) != null ? a : 0)) / c, h = u.width / l, v = u.height / c;
  return { width: h, height: v, top: y, right: d + h, bottom: y + v, left: d, x: d, y };
}
function Ge(e) {
  return (t = e, (t instanceof ze(t).Node ? e.ownerDocument : e.document) || window.document).documentElement;
  var t;
}
function Tr(e) {
  return mt(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function ol(e) {
  return ot(Ge(e)).left + Tr(e).scrollLeft;
}
function bh(e, t, n) {
  const r = Be(t), o = Ge(t), a = ot(e, r && function(l) {
    const c = ot(l);
    return ir(c.width) !== l.offsetWidth || ir(c.height) !== l.offsetHeight;
  }(t), n === "fixed");
  let i = { scrollLeft: 0, scrollTop: 0 };
  const u = { x: 0, y: 0 };
  if (r || !r && n !== "fixed")
    if ((Je(t) !== "body" || Pr(o)) && (i = Tr(t)), Be(t)) {
      const l = ot(t, !0);
      u.x = l.x + t.clientLeft, u.y = l.y + t.clientTop;
    } else
      o && (u.x = ol(o));
  return { x: a.left + i.scrollLeft - u.x, y: a.top + i.scrollTop - u.y, width: a.width, height: a.height };
}
function ur(e) {
  if (Je(e) === "html")
    return e;
  const t = e.assignedSlot || e.parentNode || (zi(e) ? e.host : null) || Ge(e);
  return zi(t) ? t.host : t;
}
function Qi(e) {
  return Be(e) && Ke(e).position !== "fixed" ? e.offsetParent : null;
}
function Xi(e) {
  const t = ze(e);
  let n = Qi(e);
  for (; n && vh(n) && Ke(n).position === "static"; )
    n = Qi(n);
  return n && (Je(n) === "html" || Je(n) === "body" && Ke(n).position === "static" && !Zo(n)) ? t : n || function(r) {
    let o = ur(r);
    for (; Be(o) && !ya(o); ) {
      if (Zo(o))
        return o;
      o = ur(o);
    }
    return null;
  }(e) || t;
}
function Gi(e) {
  if (Be(e))
    return { width: e.offsetWidth, height: e.offsetHeight };
  const t = ot(e);
  return { width: t.width, height: t.height };
}
function al(e) {
  const t = ur(e);
  return ya(t) ? e.ownerDocument.body : Be(t) && Pr(t) ? t : al(t);
}
function il(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = al(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = ze(r), i = o ? [a].concat(a.visualViewport || [], Pr(r) ? r : []) : r, u = t.concat(i);
  return o ? u : u.concat(il(i));
}
function Ki(e, t, n) {
  return t === "viewport" ? ar(function(r, o) {
    const a = ze(r), i = Ge(r), u = a.visualViewport;
    let l = i.clientWidth, c = i.clientHeight, f = 0, s = 0;
    if (u) {
      l = u.width, c = u.height;
      const d = rl();
      (d || !d && o === "fixed") && (f = u.offsetLeft, s = u.offsetTop);
    }
    return { width: l, height: c, x: f, y: s };
  }(e, n)) : mt(t) ? function(r, o) {
    const a = ot(r, !1, o === "fixed"), i = a.top + r.clientTop, u = a.left + r.clientLeft;
    return { top: i, left: u, x: u, y: i, right: u + r.clientWidth, bottom: i + r.clientHeight, width: r.clientWidth, height: r.clientHeight };
  }(t, n) : ar(function(r) {
    var o;
    const a = Ge(r), i = Tr(r), u = (o = r.ownerDocument) == null ? void 0 : o.body, l = St(a.scrollWidth, a.clientWidth, u ? u.scrollWidth : 0, u ? u.clientWidth : 0), c = St(a.scrollHeight, a.clientHeight, u ? u.scrollHeight : 0, u ? u.clientHeight : 0);
    let f = -i.scrollLeft + ol(r);
    const s = -i.scrollTop;
    return Ke(u || a).direction === "rtl" && (f += St(a.clientWidth, u ? u.clientWidth : 0) - l), { width: l, height: c, x: f, y: s };
  }(Ge(e)));
}
const gh = { getClippingRect: function(e) {
  let { element: t, boundary: n, rootBoundary: r, strategy: o } = e;
  const a = n === "clippingAncestors" ? function(c) {
    let f = il(c).filter((y) => mt(y) && Je(y) !== "body"), s = c, d = null;
    for (; mt(s) && !ya(s); ) {
      const y = Ke(s);
      y.position === "static" && d && ["absolute", "fixed"].includes(d.position) && !Zo(s) ? f = f.filter((h) => h !== s) : d = y, s = ur(s);
    }
    return f;
  }(t) : [].concat(n), i = [...a, r], u = i[0], l = i.reduce((c, f) => {
    const s = Ki(t, f, o);
    return c.top = St(s.top, c.top), c.right = Vi(s.right, c.right), c.bottom = Vi(s.bottom, c.bottom), c.left = St(s.left, c.left), c;
  }, Ki(t, u, o));
  return { width: l.right - l.left, height: l.bottom - l.top, x: l.left, y: l.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: t, offsetParent: n, strategy: r } = e;
  const o = Be(n), a = Ge(n);
  if (n === a)
    return t;
  let i = { scrollLeft: 0, scrollTop: 0 };
  const u = { x: 0, y: 0 };
  if ((o || !o && r !== "fixed") && ((Je(n) !== "body" || Pr(a)) && (i = Tr(n)), Be(n))) {
    const l = ot(n, !0);
    u.x = l.x + n.clientLeft, u.y = l.y + n.clientTop;
  }
  return { ...t, x: t.x - i.scrollLeft + u.x, y: t.y - i.scrollTop + u.y };
}, isElement: mt, getDimensions: Gi, getOffsetParent: Xi, getDocumentElement: Ge, getElementRects: (e) => {
  let { reference: t, floating: n, strategy: r } = e;
  return { reference: bh(t, Xi(n), r), floating: { ...Gi(n), x: 0, y: 0 } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => Ke(e).direction === "rtl" }, Ji = (e, t, n) => (async (r, o, a) => {
  const { placement: i = "bottom", strategy: u = "absolute", middleware: l = [], platform: c } = a, f = l.filter(Boolean), s = await (c.isRTL == null ? void 0 : c.isRTL(o));
  if (c == null && console.error(["Floating UI: `platform` property was not passed to config. If you", "want to use Floating UI on the web, install @floating-ui/dom", "instead of the /core package. Otherwise, you can create your own", "`platform`: https://floating-ui.com/docs/platform"].join(" ")), f.filter((x) => {
    let { name: $ } = x;
    return $ === "autoPlacement" || $ === "flip";
  }).length > 1)
    throw new Error(["Floating UI: duplicate `flip` and/or `autoPlacement` middleware", "detected. This will lead to an infinite loop. Ensure only one of", "either has been passed to the `middleware` array."].join(" "));
  r && o || console.error(["Floating UI: The reference and/or floating element was not defined", "when `computePosition()` was called. Ensure that both elements have", "been created and can be measured."].join(" "));
  let d = await c.getElementRects({ reference: r, floating: o, strategy: u }), { x: y, y: h } = Yi(d, i, s), v = i, O = {}, b = 0;
  for (let x = 0; x < f.length; x++) {
    const { name: $, fn: P } = f[x], { x: m, y: A, data: D, reset: I } = await P({ x: y, y: h, initialPlacement: i, placement: v, strategy: u, middlewareData: O, rects: d, platform: c, elements: { reference: r, floating: o } });
    y = m ?? y, h = A ?? h, O = { ...O, [$]: { ...O[$], ...D } }, b > 50 && console.warn(["Floating UI: The middleware lifecycle appears to be running in an", "infinite loop. This is usually caused by a `reset` continually", "being returned without a break condition."].join(" ")), I && b <= 50 && (b++, typeof I == "object" && (I.placement && (v = I.placement), I.rects && (d = I.rects === !0 ? await c.getElementRects({ reference: r, floating: o, strategy: u }) : I.rects), { x: y, y: h } = Yi(d, v, s)), x = -1);
  }
  return { x: y, y: h, placement: v, strategy: u, middlewareData: O };
})(e, t, { platform: gh, ...n }), Zi = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: n = null, place: r = "top", offset: o = 10, strategy: a = "absolute" }) => {
  if (!e)
    return { tooltipStyles: {}, tooltipArrowStyles: {} };
  if (t === null)
    return { tooltipStyles: {}, tooltipArrowStyles: {} };
  const i = [mh(Number(o)), hh(), (u = { padding: 5 }, u === void 0 && (u = {}), { name: "shift", options: u, async fn(l) {
    const { x: c, y: f, placement: s } = l, { mainAxis: d = !0, crossAxis: y = !1, limiter: h = { fn: (D) => {
      let { x: I, y: L } = D;
      return { x: I, y: L };
    } }, ...v } = u, O = { x: c, y: f }, b = await el(l, v), x = $t(Ct(s)), $ = x === "x" ? "y" : "x";
    let P = O[x], m = O[$];
    if (d) {
      const D = x === "y" ? "bottom" : "right";
      P = Dr(P + b[x === "y" ? "top" : "left"], P, P - b[D]);
    }
    if (y) {
      const D = $ === "y" ? "bottom" : "right";
      m = Dr(m + b[$ === "y" ? "top" : "left"], m, m - b[D]);
    }
    const A = h.fn({ ...l, [x]: P, [$]: m });
    return { ...A, data: { x: A.x - c, y: A.y - f } };
  } })];
  var u;
  return n ? (i.push(((l) => ({ name: "arrow", options: l, async fn(c) {
    const { element: f, padding: s = 0 } = l ?? {}, { x: d, y, placement: h, rects: v, platform: O } = c;
    if (f == null)
      return console.warn("Floating UI: No `element` was passed to the `arrow` middleware."), {};
    const b = Zu(s), x = { x: d, y }, $ = $t(h), P = Or(h), m = pa($), A = await O.getDimensions(f), D = $ === "y" ? "top" : "left", I = $ === "y" ? "bottom" : "right", L = v.reference[m] + v.reference[$] - x[$] - v.floating[m], Q = x[$] - v.reference[$], W = await (O.getOffsetParent == null ? void 0 : O.getOffsetParent(f));
    let z = W ? $ === "y" ? W.clientHeight || 0 : W.clientWidth || 0 : 0;
    z === 0 && (z = v.floating[m]);
    const J = L / 2 - Q / 2, N = b[D], S = z - A[m] - b[I], C = z / 2 - A[m] / 2 + J, g = Dr(N, C, S), j = (P === "start" ? b[D] : b[I]) > 0 && C !== g && v.reference[m] <= v.floating[m];
    return { [$]: x[$] - (j ? C < N ? N - C : S - C : 0), data: { [$]: g, centerOffset: C - g } };
  } }))({ element: n, padding: 5 })), Ji(e, t, { placement: r, strategy: a, middleware: i }).then(({ x: l, y: c, placement: f, middlewareData: s }) => {
    var d, y;
    const h = { left: `${l}px`, top: `${c}px` }, { x: v, y: O } = (d = s.arrow) !== null && d !== void 0 ? d : { x: 0, y: 0 };
    return { tooltipStyles: h, tooltipArrowStyles: { left: v != null ? `${v}px` : "", top: O != null ? `${O}px` : "", right: "", bottom: "", [(y = { top: "bottom", right: "left", bottom: "top", left: "right" }[f.split("-")[0]]) !== null && y !== void 0 ? y : "bottom"]: "-4px" } };
  })) : Ji(e, t, { placement: "bottom", strategy: a, middleware: i }).then(({ x: l, y: c }) => ({ tooltipStyles: { left: `${l}px`, top: `${c}px` }, tooltipArrowStyles: {} }));
};
var et = { tooltip: "styles-module_tooltip__mnnfp", fixed: "styles-module_fixed__7ciUi", arrow: "styles-module_arrow__K0L3T", "no-arrow": "styles-module_no-arrow__KcFZN", clickable: "styles-module_clickable__Bv9o7", show: "styles-module_show__2NboJ", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const eu = ({ id: e, className: t, classNameArrow: n, variant: r = "dark", anchorId: o, place: a = "top", offset: i = 10, events: u = ["hover"], positionStrategy: l = "absolute", wrapper: c = "div", children: f = null, delayShow: s = 0, delayHide: d = 0, float: y = !1, noArrow: h = !1, clickable: v = !1, style: O, position: b, afterShow: x, afterHide: $, content: P, html: m, isOpen: A, setIsOpen: D }) => {
  const I = je(null), L = je(null), Q = je(null), W = je(null), [z, J] = fe({}), [N, S] = fe({}), [C, g] = fe(!1), j = je(!1), [ce, _] = fe(!1), R = je(null), { anchorRefs: Y, setActiveAnchor: E } = Ju(e), [U, Z] = fe({ current: null }), V = je(!1), G = (M) => {
    D ? D(M) : A === void 0 && g(M);
  };
  $e(() => {
    C !== j.current && (j.current = C, C ? x?.() : $?.());
  }, [C]);
  const B = (M = d) => {
    W.current && clearTimeout(W.current), W.current = setTimeout(() => {
      V.current || G(!1);
    }, M);
  }, F = (M) => {
    var ue;
    if (!M)
      return;
    s ? (Q.current && clearTimeout(Q.current), Q.current = setTimeout(() => {
      G(!0);
    }, s)) : G(!0);
    const ae = (ue = M.currentTarget) !== null && ue !== void 0 ? ue : M.target;
    Z((K) => K.current === ae ? K : { current: ae }), E({ current: ae }), W.current && clearTimeout(W.current);
  }, w = () => {
    v ? B(d || 50) : d ? B() : G(!1), Q.current && clearTimeout(Q.current);
  }, H = ({ x: M, y: ue }) => {
    const ae = { getBoundingClientRect: () => ({ x: M, y: ue, width: 0, height: 0, top: ue, left: M, right: M, bottom: ue }) };
    _(!0), Zi({ place: a, offset: i, elementReference: ae, tooltipReference: I.current, tooltipArrowReference: L.current, strategy: l }).then((K) => {
      _(!1), Object.keys(K.tooltipStyles).length && J(K.tooltipStyles), Object.keys(K.tooltipArrowStyles).length && S(K.tooltipArrowStyles);
    });
  }, T = (M) => {
    if (!M)
      return;
    const ue = M, ae = { x: ue.clientX, y: ue.clientY };
    H(ae), R.current = ae;
  }, oe = (M) => {
    F(M), d && B();
  }, re = (M) => {
    var ue;
    !((ue = U.current) === null || ue === void 0) && ue.contains(M.target) || G(!1);
  }, te = Hi(F, 50), ie = Hi(w, 50);
  $e(() => {
    var M, ue;
    const ae = new Set(Y), K = document.querySelector(`[id='${o}']`);
    if (K && (Z((Pe) => Pe.current === K ? Pe : { current: K }), ae.add({ current: K })), !ae.size)
      return () => null;
    const pe = [];
    u.find((Pe) => Pe === "click") && (window.addEventListener("click", re), pe.push({ event: "click", listener: oe })), u.find((Pe) => Pe === "hover") && (pe.push({ event: "mouseenter", listener: te }, { event: "mouseleave", listener: ie }, { event: "focus", listener: te }, { event: "blur", listener: ie }), y && pe.push({ event: "mousemove", listener: T }));
    const ee = () => {
      V.current = !0;
    }, Ne = () => {
      V.current = !1, w();
    };
    return v && ((M = I.current) === null || M === void 0 || M.addEventListener("mouseenter", ee), (ue = I.current) === null || ue === void 0 || ue.addEventListener("mouseleave", Ne)), pe.forEach(({ event: Pe, listener: Ae }) => {
      ae.forEach((Pt) => {
        var De;
        (De = Pt.current) === null || De === void 0 || De.addEventListener(Pe, Ae);
      });
    }), () => {
      var Pe, Ae;
      window.removeEventListener("click", re), v && ((Pe = I.current) === null || Pe === void 0 || Pe.removeEventListener("mouseenter", ee), (Ae = I.current) === null || Ae === void 0 || Ae.removeEventListener("mouseleave", Ne)), pe.forEach(({ event: Pt, listener: De }) => {
        ae.forEach((bl) => {
          var $r;
          ($r = bl.current) === null || $r === void 0 || $r.removeEventListener(Pt, De);
        });
      });
    };
  }, [Y, U, o, u, d, s]), $e(() => {
    if (b)
      return H(b), () => null;
    if (y)
      return R.current && H(R.current), () => null;
    let M = U.current;
    o && (M = document.querySelector(`[id='${o}']`)), _(!0);
    let ue = !0;
    return Zi({ place: a, offset: i, elementReference: M, tooltipReference: I.current, tooltipArrowReference: L.current, strategy: l }).then((ae) => {
      ue && (_(!1), Object.keys(ae.tooltipStyles).length && J(ae.tooltipStyles), Object.keys(ae.tooltipArrowStyles).length && S(ae.tooltipArrowStyles));
    }), () => {
      ue = !1;
    };
  }, [C, A, o, U, P, m, a, i, l, b]), $e(() => () => {
    Q.current && clearTimeout(Q.current), W.current && clearTimeout(W.current);
  }, []);
  const q = !!(m || P || f);
  return rt.exports.jsxs(c, { id: e, role: "tooltip", className: Fi("react-tooltip", et.tooltip, et[r], t, { [et.show]: q && !ce && (A || C), [et.fixed]: l === "fixed", [et.clickable]: v }), style: { ...O, ...z }, ref: I, children: [f || m && rt.exports.jsx(lh, { content: m }) || P, rt.exports.jsx("div", { className: Fi("react-tooltip-arrow", et.arrow, n, { [et["no-arrow"]]: h }), style: N, ref: L })] });
}, _h = ({ id: e, anchorId: t, content: n, html: r, className: o, classNameArrow: a, variant: i = "dark", place: u = "top", offset: l = 10, wrapper: c = "div", children: f = null, events: s = ["hover"], positionStrategy: d = "absolute", delayShow: y = 0, delayHide: h = 0, float: v = !1, noArrow: O = !1, clickable: b = !1, style: x, position: $, isOpen: P, setIsOpen: m, afterShow: A, afterHide: D }) => {
  const [I, L] = fe(n), [Q, W] = fe(r), [z, J] = fe(u), [N, S] = fe(i), [C, g] = fe(l), [j, ce] = fe(y), [_, R] = fe(h), [Y, E] = fe(v), [U, Z] = fe(c), [V, G] = fe(s), [B, F] = fe(d), { anchorRefs: w, activeAnchor: H } = Ju(e), T = (te) => te?.getAttributeNames().reduce((ie, q) => {
    var M;
    return q.startsWith("data-tooltip-") && (ie[q.replace(/^data-tooltip-/, "")] = (M = te?.getAttribute(q)) !== null && M !== void 0 ? M : null), ie;
  }, {}), oe = (te) => {
    const ie = { place: (q) => {
      var M;
      J((M = q) !== null && M !== void 0 ? M : u);
    }, content: (q) => {
      L(q ?? n);
    }, html: (q) => {
      W(q ?? r);
    }, variant: (q) => {
      var M;
      S((M = q) !== null && M !== void 0 ? M : i);
    }, offset: (q) => {
      g(q === null ? l : Number(q));
    }, wrapper: (q) => {
      var M;
      Z((M = q) !== null && M !== void 0 ? M : "div");
    }, events: (q) => {
      const M = q?.split(" ");
      G(M ?? s);
    }, "position-strategy": (q) => {
      var M;
      F((M = q) !== null && M !== void 0 ? M : d);
    }, "delay-show": (q) => {
      ce(q === null ? y : Number(q));
    }, "delay-hide": (q) => {
      R(q === null ? h : Number(q));
    }, float: (q) => {
      E(q === null ? v : !!q);
    } };
    Object.values(ie).forEach((q) => q(null)), Object.entries(te).forEach(([q, M]) => {
      var ue;
      (ue = ie[q]) === null || ue === void 0 || ue.call(ie, M);
    });
  };
  $e(() => {
    L(n);
  }, [n]), $e(() => {
    W(r);
  }, [r]), $e(() => {
    var te;
    const ie = new Set(w), q = document.querySelector(`[id='${t}']`);
    if (q && ie.add({ current: q }), !ie.size)
      return () => null;
    const M = (te = H.current) !== null && te !== void 0 ? te : q, ue = new MutationObserver((K) => {
      K.forEach((pe) => {
        var ee;
        if (!M || pe.type !== "attributes" || !(!((ee = pe.attributeName) === null || ee === void 0) && ee.startsWith("data-tooltip-")))
          return;
        const Ne = T(M);
        oe(Ne);
      });
    }), ae = { attributes: !0, childList: !1, subtree: !1 };
    if (M) {
      const K = T(M);
      oe(K), ue.observe(M, ae);
    }
    return () => {
      ue.disconnect();
    };
  }, [w, H, t]);
  const re = { id: e, anchorId: t, className: o, classNameArrow: a, content: I, html: Q, place: z, variant: N, offset: C, wrapper: U, events: V, positionStrategy: B, delayShow: j, delayHide: _, float: Y, noArrow: O, clickable: b, style: x, position: $, isOpen: P, setIsOpen: m, afterShow: A, afterHide: D };
  return f ? rt.exports.jsx(eu, { ...re, children: f }) : rt.exports.jsx(eu, { ...re });
};
function _v({ anchor: e, anchorId: t = "aui-tooltip", location: n = "bottom", text: r = "", qa: o }) {
  return /* @__PURE__ */ k(lt, { children: [
    gt(e, { id: t, "aria-describedby": `${t}-tooltip`, tabIndex: 0 }),
    /* @__PURE__ */ p(
      _h,
      {
        id: `${t}-tooltip`,
        anchorId: t,
        className: "a-tooltip__base",
        noArrow: !0,
        positionStrategy: "fixed",
        place: n,
        children: /* @__PURE__ */ p("div", { className: "a-tooltip", "data-qa": o, children: r })
      }
    )
  ] });
}
function wv({ children: e = [], type: t, qa: n }) {
  const r = X({
    "m-accordion": !0,
    "m-accordion--open": t === "open"
  });
  return /* @__PURE__ */ p("div", { className: r, "data-qa": n, children: e });
}
function Ov({ id: e = "", header: t = "", children: n, open: r, onToggle: o, qa: a }) {
  const [i, u] = ge.useState(!!r), l = r === !0 || r === !1 ? r : i, c = X({
    "m-accordion__tab": !0
  });
  return /* @__PURE__ */ k("div", { className: c, "data-qa": a, children: [
    /* @__PURE__ */ p("button", { id: e, className: "m-accordion__header", "aria-expanded": l, onClick: () => (u(!i), o && o(e)), children: t }),
    /* @__PURE__ */ p("div", { style: l ? { maxHeight: "none" } : {}, className: "m-accordion__content", children: n })
  ] });
}
const wh = (e, t) => {
  const {
    ariaLabelClose: n = "Sluiten",
    cancelButton: r,
    children: o,
    confirmButton: a,
    onClose: i,
    qa: u,
    theme: l,
    title: c = { label: "" },
    titleId: f
  } = t, s = t.title?.tag || "h5", d = X({
    "u-margin-bottom": !!(a || r)
  });
  return /* @__PURE__ */ k("div", { role: "alertdialog", className: e, "aria-labelledby": f, "aria-modal": "true", "data-qa": u, children: [
    /* @__PURE__ */ p(
      Ce,
      {
        addOn: { type: "icon", iconProps: { name: "remove" } },
        emphasis: "low",
        className: "m-alert__close",
        theme: l,
        ariaLabel: n,
        onClick: i
      }
    ),
    !!l && /* @__PURE__ */ p("span", { className: "m-alert__icon", children: /* @__PURE__ */ p(ve, { name: rr[l] }) }),
    c?.label && /* @__PURE__ */ p(s, { id: f, className: "u-margin-bottom-xs", children: c.label }),
    /* @__PURE__ */ p("p", { className: d, children: o }),
    /* @__PURE__ */ k("div", { className: "m-alert__actions", children: [
      a ? /* @__PURE__ */ p(Ce, { ...a }) : null,
      r ? /* @__PURE__ */ p(Ce, { ...r }) : null
    ] })
  ] });
}, Oh = (e, t) => {
  const n = t.title?.tag || "h5";
  return /* @__PURE__ */ k("div", { role: "alert", className: e, "aria-labelledby": t.titleId, "data-qa": t.qa, children: [
    !!t.theme && /* @__PURE__ */ p("span", { className: "m-alert__icon", children: /* @__PURE__ */ p(ve, { name: rr[t.theme] }) }),
    !!t.title && /* @__PURE__ */ p(n, { id: t.titleId, className: "paragraph has-base-font", children: t.title?.label }),
    /* @__PURE__ */ p("p", { children: t.children })
  ] });
};
function Pv(e) {
  const t = X({
    "m-alert": !0,
    [`m-alert--${e.theme}`]: !!e.theme,
    "m-alert--inline": !!e.inline
  });
  return e.inline ? Oh(t, e) : wh(t, e);
}
const ul = vr(function({
  trigger: t,
  open: n,
  hasPadding: r = !0,
  className: o = "",
  orientation: a = "bottom-left",
  size: i,
  children: u,
  scrollable: l = !1,
  onStateChange: c,
  qa: f
}, s) {
  const [d, y] = ge.useState(!!n), h = n === !1 || n === !0 ? n : d, v = ge.useRef(null);
  Ol(s, () => v.current);
  const O = ge.useCallback(
    (m) => {
      const A = bu.findDOMNode(v.current);
      m.target === A?.lastChild && m.preventDefault(), A && !A.contains(m.target) && (y(!1), c && c(!1));
    },
    [c]
  ), b = ge.useCallback(() => {
    h ? document.addEventListener("mousedown", O, !1) : document.removeEventListener("mousedown", O, !1);
  }, [O, h]), x = () => {
    y(!h), b(), c && c(!h);
  };
  ge.useEffect(() => {
    b();
  }, [b]);
  const $ = X({
    "m-flyout": !0,
    [o]: !!o,
    "is-open": !!h,
    "u-text-right": !!a?.includes("right"),
    [`m-flyout--${a}`]: !!a,
    [`m-flyout--${ke[i || Me]}`]: !!i,
    "m-flyout--scrollable": !!l
  }), P = X({
    "m-flyout__content": !0,
    "has-padding": !!r
  });
  return t ? /* @__PURE__ */ k("div", { className: $, ref: v, "data-qa": f, children: [
    gt(t, { onClick: x, "aria-haspopup": !0, "aria-expanded": h }),
    /* @__PURE__ */ p("div", { className: P, ...l ? { tabIndex: 0 } : {}, children: u })
  ] }) : null;
});
function Tv({
  id: e = "aui-autocomplete",
  label: t,
  items: n,
  name: r,
  multiple: o,
  required: a,
  inputValue: i,
  value: u,
  onInputChange: l,
  onChange: c,
  noResultsText: f = "Geen resultaten",
  qa: s,
  description: d,
  state: y,
  addOn: h
}) {
  const [v, O] = fe(!1), [b, x] = fe(n), [$, P] = fe(i || ""), [m, A] = fe(!o && u || ""), [D, I] = fe(-1), [L, Q] = fe(o && u || []), W = i || i === "" ? i : $, z = u || u === "" ? u : m, J = ge.useRef(null);
  $e(() => {
    u && !o && g(u, !0), u && o && Q(u);
  }, [u]), $e(() => {
    x(
      (n || []).filter((E) => W ? E.label?.toLowerCase().includes(W.toLowerCase()) : !0)
    );
  }, [W, n]), $e(() => {
    J.current && J.current.querySelector(`.a-list__item:nth-child(${D + 1})`)?.scrollIntoView({ block: "nearest", inline: "nearest" });
  }, [D]);
  const N = (E) => {
    O(E);
  }, S = () => {
    O(!1), I(-1);
  }, C = (E) => {
    P(E), O(!0), z && !E && (A(""), !o && c && c("", r)), l && l(E, r);
  }, g = (E, U = !1) => {
    if (!o && u !== "" && (!u || u === E)) {
      const Z = n?.find((V) => V.value === E);
      C(Z?.label || ""), A(Z?.value || ""), S();
    }
    !U && c && c(E, r);
  }, j = (E) => {
    const U = n?.find((V) => V.value === E);
    U && A(U.value);
    const Z = L.includes(E) ? L.filter((V) => V !== E) : [...L, E].filter((V) => V !== "");
    Q(Z), c && c(Z, r);
  }, ce = () => {
    const E = n?.find((U) => U.value === z);
    E && W?.length && E.label !== W && C(E.label), S();
  }, _ = () => {
    const E = b && b[D];
    E && (o ? j(E.value) : g(E.value));
  }, R = (E) => {
    const U = b?.length || 0;
    switch (E.key) {
      case "ArrowDown":
        return E.preventDefault(), I(D === -1 ? 0 : (D + 1) % U), O(!0);
      case "ArrowUp":
        return E.preventDefault(), I(D === -1 || D - 1 < 0 ? U - 1 : D - 1), O(!0);
      case "Enter":
        return _();
      case "Escape":
        return S();
    }
  }, Y = (E) => o ? L.includes(E) : E === z;
  return /* @__PURE__ */ p(
    ul,
    {
      scrollable: !0,
      hasPadding: !1,
      qa: s,
      className: "m-autocomplete",
      trigger: /* @__PURE__ */ p(
        Qu,
        {
          id: e,
          name: r,
          label: t,
          onBlur: ce,
          value: W,
          onChange: (E) => C(E.target.value),
          role: "combobox",
          autoComplete: "off",
          "aria-autocomplete": "list",
          "aria-haspopup": "true",
          "aria-expanded": v,
          onKeyDown: R,
          description: d,
          required: a,
          state: y,
          addOn: h ? { ...h, content: h.content } : void 0
        }
      ),
      ref: J,
      open: v,
      onStateChange: N,
      children: b && b.length ? /* @__PURE__ */ p(
        or,
        {
          lined: !0,
          onItemClick: (E) => {
            o ? j(E) : g(E);
          },
          children: b.map((E, U) => /* @__PURE__ */ p(
            Li,
            {
              id: E.value,
              tabIndex: -1,
              highlighted: U === D,
              onMouseDown: (Z) => Z.preventDefault(),
              active: Y(E.value),
              name: E.value,
              link: { href: "" },
              children: E.label
            },
            E.value
          ))
        }
      ) : /* @__PURE__ */ p(or, { lined: !0, children: /* @__PURE__ */ p(Li, { id: "aui-autocomplete-no-results", children: /* @__PURE__ */ p("small", { children: f }) }) })
    }
  );
}
function Sv({ children: e, vertical: t, qa: n }) {
  const r = X({
    "m-button-group": !0,
    "m-button-group--vertical": !!t
  });
  return /* @__PURE__ */ p("div", { className: r, "data-qa": n, children: e });
}
function Ph({ alt: e = "", children: t, src: n, noClass: r, qa: o }) {
  const a = X({
    "m-image": !r
  });
  return t && !((u) => u && typeof u == "object" && (u.type === "figcaption" || typeof u.type != "string" && u.type.name === "Copyright"))(t) && br("Image's children should only be a Copyright component or a figcaption element"), /* @__PURE__ */ k("figure", { className: a, "data-qa": o, children: [
    /* @__PURE__ */ p("img", { src: n, alt: e }),
    t
  ] });
}
function $v({ title: e, subTitle: t, description: n, children: r, image: o, link: a, qa: i }) {
  const u = e?.tag || "h4";
  return /* @__PURE__ */ k("div", { className: "m-card", "data-qa": i, children: [
    !!o && /* @__PURE__ */ p("div", { className: "m-card__image", children: /* @__PURE__ */ p(Ph, { ...o }) }),
    /* @__PURE__ */ k("div", { className: "m-card__body", children: [
      !!e?.label && /* @__PURE__ */ p(u, { id: `${e?.id}`, className: `u-margin-bottom-xs ${e.className ?? ""}`, children: e.label }),
      !!t && /* @__PURE__ */ p("p", { className: "small u-text-bold u-margin-bottom-xs", children: t }),
      !!n && /* @__PURE__ */ p("p", { className: "u-margin-bottom", children: n }),
      !!a && /* @__PURE__ */ p("p", { className: "u-text-right", children: fa({ ...a, href: a.href ?? "#" }, "arrow-right-1", {
        className: "has-icon-right",
        "aria-labelledby": e?.id
      }) }),
      r
    ] })
  ] });
}
var be = /* @__PURE__ */ ((e) => (e.DAYS = "d", e.MONTHS = "m", e.YEARS = "y", e))(be || {});
function ll(e, t, n, r) {
  return n && (Au(e, new Date(n)) || Tt(e, new Date(n))) || t && (On(e, new Date(t)) || Tt(e, new Date(t))) || !!r?.find((o) => Tt(e, new Date(o)));
}
function Th({
  date: e,
  monthYear: t,
  unavailable: n,
  unavailableFrom: r,
  unavailableTo: o,
  value: a,
  onChange: i,
  ariaLabelCurrentDay: u
}) {
  const l = Wr(
    () => ll(e, r, o, n),
    [n, r, o, e]
  ), c = Wr(() => !!a && Tt(a, e), [a, e]), f = Tt(e, /* @__PURE__ */ new Date()), s = X({
    "is-current": f,
    "is-faded": Au(e, Su(t)) || On(e, Tu(t)),
    "is-unavailable": l,
    "is-selected": c
  });
  return /* @__PURE__ */ p("td", { children: /* @__PURE__ */ p(
    "button",
    {
      className: s,
      tabIndex: l ? -1 : void 0,
      disabled: l,
      type: "button",
      "aria-pressed": c,
      "aria-label": `${Ee(e, "EEEE d MMMM yyyy")}${f ? `, ${u}` : ""}`,
      onClick: () => {
        i(e);
      },
      children: /* @__PURE__ */ p("span", { children: Ee(e, "d") })
    }
  ) });
}
function lr(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Sh({
  value: e,
  onChange: t,
  activeMonth: n,
  activeYear: r,
  ariaLabelCurrentDay: o,
  locale: a,
  unavailableFrom: i,
  unavailableTo: u,
  unavailable: l
}) {
  const c = (d) => {
    const y = [];
    let h = Rr(d, { locale: a });
    const v = ga(d, { locale: a });
    for (; !On(h, v); ) {
      const O = new Date(r, n);
      y.push(
        /* @__PURE__ */ p(
          Th,
          {
            ariaLabelCurrentDay: o,
            unavailableFrom: i,
            unavailableTo: u,
            unavailable: l,
            date: h,
            value: e,
            monthYear: O,
            onChange: t
          },
          `day_${h.toISOString()}`
        )
      ), h = _u(h, 1);
    }
    return /* @__PURE__ */ p("tr", { children: y }, `aui-calendar-week-${h.toISOString()}`);
  }, f = () => {
    const d = [], y = new Date(r, n);
    let h = Rr(Su(y), { locale: a });
    const v = Tu(y);
    for (; !On(h, v); )
      d.push(c(h)), h = Rl(h, 1);
    return d;
  }, s = Dl({
    start: Rr(/* @__PURE__ */ new Date(), { locale: a }),
    end: ga(/* @__PURE__ */ new Date(), { locale: a })
  });
  return /* @__PURE__ */ p("div", { className: "m-datepicker__grid", children: /* @__PURE__ */ k("table", { children: [
    /* @__PURE__ */ p("thead", { children: /* @__PURE__ */ p("tr", { className: "m-datepicker__grid-head", children: s.map((d) => /* @__PURE__ */ p("th", { scope: "col", children: /* @__PURE__ */ p("span", { title: lr(Ee(d, "EEEE", { locale: a })), children: lr(Ee(d, "EEEEEE", { locale: a })) }) }, `aui-calendar-weekday-${d}`)) }) }),
    /* @__PURE__ */ p("tbody", { className: "m-datepicker__grid-body", children: f() })
  ] }) });
}
function $h({ onChange: e, value: t, activeYear: n, locale: r = Fu }) {
  const o = (i) => {
    const u = X({
      "is-current": i === wn(/* @__PURE__ */ new Date()) && n === bt(/* @__PURE__ */ new Date()),
      "is-selected": !!(t && i === wn(t) && n === bt(t))
    }), l = new Date(n, i);
    return /* @__PURE__ */ p("td", { children: /* @__PURE__ */ p("button", { type: "button", className: u, onClick: () => e(l), children: lr(Ee(l, "MMMM", { locale: r })) }) });
  };
  return /* @__PURE__ */ p("div", { className: "m-datepicker__list", children: /* @__PURE__ */ p("table", { children: /* @__PURE__ */ p("tbody", { className: "m-datepicker__list-body", children: (() => {
    let i = 0;
    const u = [];
    for (; i < 12; )
      u.push(
        /* @__PURE__ */ k("tr", { children: [
          o(i),
          o(i + 1)
        ] }, `aui-calendar-month-pair-${i}`)
      ), i += 2;
    return u;
  })() }) }) });
}
function Rh({ yearsRowsStart: e, value: t, activeMonth: n, onChange: r }) {
  const o = (i) => {
    const u = X({
      "is-current": i === bt(/* @__PURE__ */ new Date()),
      "is-selected": !!(t && i === bt(new Date(t)))
    });
    return /* @__PURE__ */ p("td", { children: /* @__PURE__ */ p(
      "button",
      {
        type: "button",
        className: u,
        onClick: () => r(new Date(i, n, t ? kc(t) : 1)),
        children: Ee(new Date(i, n), "yyyy")
      }
    ) });
  };
  return /* @__PURE__ */ p("div", { className: "m-datepicker__list", children: /* @__PURE__ */ p("table", { children: /* @__PURE__ */ p("tbody", { className: "m-datepicker__list-body", children: (() => {
    let i = 0;
    const u = [];
    for (; i < 16; )
      u.push(
        /* @__PURE__ */ k("tr", { children: [
          o(e + i),
          o(e + i + 1),
          o(e + i + 2)
        ] }, `aui-calendar-years-${i}`)
      ), i += 3;
    return u;
  })() }) }) });
}
const Eh = vr(
  ({
    ariaLabel: e = "Kalender",
    ariaLabelCurrentDay: t = "Huidige dag",
    ariaLabelNextMonth: n = "Ga naar de volgende maand",
    ariaLabelNextYear: r = "Ga naar het volgend jaar",
    ariaLabelNextYears: o = "Ga naar de volgende jaren",
    ariaLabelPreviousMonth: a = "Ga naar de vorige maand",
    ariaLabelPreviousYear: i = "Ga naar het vorig jaar",
    ariaLabelPreviousYears: u = "Ga naar de voorgaande jaren",
    className: l,
    isOpen: c = !0,
    locale: f = Fu,
    onBlur: s,
    onChange: d,
    qa: y,
    unavailable: h = [],
    unavailableFrom: v,
    unavailableTo: O,
    value: b
  }, x) => {
    const [$, P] = fe(b ? new Date(b) : void 0), [m, A] = fe(bt(new Date(b || /* @__PURE__ */ new Date()))), [D, I] = fe(wn(new Date(b || /* @__PURE__ */ new Date()))), [L, Q] = fe(be.DAYS), [W, z] = fe(m - 7);
    $e(() => {
      P(b ? new Date(b) : void 0);
    }, [b]);
    const J = Wr(() => {
      const _ = new Date(m, D);
      return {
        [be.DAYS]: {
          main: lr(Ee(_, "MMMM yyyy", { locale: f })),
          next: `${n}, ${Ee(oa(_, 1), "MMMM yyyy", { locale: f })}`,
          prev: `${a}, ${Ee(oy(_, 1), "MMMM yyyy", { locale: f })}`
        },
        [be.MONTHS]: {
          main: Ee(_, "yyyy", { locale: f }),
          next: `${r}, ${Ee(Ou(_, 1), "yyyy", { locale: f })}`,
          prev: `${i}, ${Ee(ay(_, 1), "yyyy", { locale: f })}`
        },
        [be.YEARS]: {
          main: `${W} - ${W + 17}`,
          next: o,
          prev: u
        }
      }[L];
    }, [
      L,
      m,
      D,
      W,
      n,
      r,
      o,
      a,
      i,
      u,
      f
    ]), N = () => {
      if (L === be.DAYS)
        return A(D === 0 ? m - 1 : m), I(D === 0 ? 11 : D - 1);
      if (L === be.MONTHS)
        return A(m - 1);
      if (L === be.YEARS)
        return z(W - 18);
    }, S = () => {
      if (L === be.DAYS)
        return A(D === 11 ? m + 1 : m), I((D + 1) % 12);
      if (L === be.MONTHS)
        return A(m + 1);
      if (L === be.YEARS)
        return z(W + 18);
    }, C = () => {
      const _ = [be.DAYS, be.MONTHS, be.YEARS];
      Q(_[(_.findIndex((R) => R === L) + 1) % _.length]);
    }, g = (_) => {
      if (L === be.DAYS)
        return P(_), d && d(ku(_));
      if (L === be.MONTHS)
        return I(wn(_)), Q(be.DAYS);
      if (L === be.YEARS)
        return A(bt(_)), Q(be.MONTHS);
    }, j = () => {
      switch (L) {
        case be.DAYS:
          return /* @__PURE__ */ p(
            Sh,
            {
              locale: f,
              ariaLabelCurrentDay: t,
              activeMonth: D,
              activeYear: m,
              value: $,
              onChange: g,
              unavailableFrom: v,
              unavailableTo: O,
              unavailable: h
            }
          );
        case be.MONTHS:
          return /* @__PURE__ */ p($h, { locale: f, value: $, onChange: g, activeYear: m });
        case be.YEARS:
          return /* @__PURE__ */ p(
            Rh,
            {
              value: $,
              onChange: g,
              yearsRowsStart: W,
              activeMonth: D
            }
          );
      }
    }, ce = X({ "m-datepicker": !0, "is-open": !!c, [`${l}`]: !!l });
    return /* @__PURE__ */ k(
      "div",
      {
        ref: x,
        "aria-label": e,
        className: ce,
        "aria-hidden": !c,
        "data-qa": y,
        onBlur: s,
        onClick: (_) => _.stopPropagation(),
        children: [
          /* @__PURE__ */ k("div", { className: "m-datepicker__nav", children: [
            /* @__PURE__ */ k(
              "button",
              {
                type: "button",
                className: "m-datepicker__nav-title",
                "aria-label": J.main,
                onClick: C,
                children: [
                  J.main,
                  /* @__PURE__ */ p(ve, { name: L === be.DAYS ? "arrow-down-1" : "arrow-up-1" })
                ]
              }
            ),
            /* @__PURE__ */ k("div", { className: "m-datepicker__nav-pagination", children: [
              /* @__PURE__ */ p(
                Ce,
                {
                  ariaLabel: J.prev,
                  emphasis: "low",
                  addOn: { type: "icon", iconProps: { name: "arrow-left-1" } },
                  onClick: N
                }
              ),
              /* @__PURE__ */ p(
                Ce,
                {
                  ariaLabel: J.next,
                  emphasis: "low",
                  addOn: { type: "icon", iconProps: { name: "arrow-right-1" } },
                  onClick: S
                }
              )
            ] })
          ] }),
          j()
        ]
      }
    );
  }
);
function Rv({
  qa: e,
  value: t,
  onChange: n,
  format: r = Hy,
  inputProps: o = {},
  invalidDateText: a = "Ongeldige datum",
  iconButtonLabel: i = "Open kalender",
  calendarProps: u,
  label: l,
  required: c
}) {
  const f = je(null), [s, d] = fe(t ? Ee(new Date(t), r) : ""), [y, h] = fe(t || ""), [v, O] = fe(""), [b, x] = fe(!1);
  $e(() => {
    I(s);
  }, [a]);
  const $ = (W) => {
    f.current?.contains(W) || x(!1);
  }, { elementRef: P } = uh($), m = () => x(!b), A = (W) => {
    W.currentTarget.contains(W.relatedTarget) || x(!1);
  }, D = (W) => {
    const z = W.target.value, J = new Date(Mi(z, r, /* @__PURE__ */ new Date()));
    if (d(z), o.onChange && o.onChange(W), !I(z)) {
      const N = z ? ku(J) : "";
      O(""), h(N), n && n(N);
    }
  }, I = (W) => {
    const z = W, J = new Date(Mi(z, r, /* @__PURE__ */ new Date())), N = !z || z.length === r.length && Pu(J);
    return z && !N || ll(J, u?.unavailableFrom, u?.unavailableTo, u?.unavailable) ? (O(a ?? ""), !0) : !1;
  }, L = (W) => {
    h(W), n && n(W), d(Ee(new Date(W), r)), O(""), x(!1);
  }, Q = (W) => {
    W.code === "Enter" && m();
  };
  return /* @__PURE__ */ k("div", { className: "a-input has-icon-right", "data-qa": e, children: [
    (l || o?.label) && _r({ label: l || o?.label, id: o?.id, required: c }),
    wr({
      description: v || o?.description,
      state: v ? "error" : o?.state
    }),
    /* @__PURE__ */ k("div", { className: "a-input__wrapper", children: [
      /* @__PURE__ */ p(
        Qu,
        {
          ...o,
          label: void 0,
          description: void 0,
          type: "text",
          value: s,
          onChange: D,
          state: v ? "error" : o?.state
        }
      ),
      /* @__PURE__ */ p(
        ve,
        {
          tabIndex: 0,
          screenReaderText: i,
          name: "calendar",
          role: "button",
          onClick: m,
          className: o?.disabled ? "" : "is-clickable",
          onKeyDown: Q,
          ref: f
        }
      ),
      /* @__PURE__ */ p(
        Eh,
        {
          ref: P,
          className: "m-datepicker--fixed",
          isOpen: b,
          onChange: L,
          onBlur: A,
          value: y,
          ...u
        }
      )
    ] })
  ] });
}
function xh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Ch(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      if (this instanceof r) {
        var o = [null];
        o.push.apply(o, arguments);
        var a = Function.bind.apply(t, o);
        return new a();
      }
      return t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var cr = {}, Nh = {
  get exports() {
    return cr;
  },
  set exports(e) {
    cr = e;
  }
}, st = {}, sr = {}, tu = {
  get exports() {
    return sr;
  },
  set exports(e) {
    sr = e;
  }
}, fr = {}, Dh = {
  get exports() {
    return fr;
  },
  set exports(e) {
    fr = e;
  }
}, he = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nu;
function Mh() {
  if (nu)
    return he;
  nu = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, s = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, O = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function $(m) {
    if (typeof m == "object" && m !== null) {
      var A = m.$$typeof;
      switch (A) {
        case t:
          switch (m = m.type, m) {
            case l:
            case c:
            case r:
            case a:
            case o:
            case s:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case u:
                case f:
                case h:
                case y:
                case i:
                  return m;
                default:
                  return A;
              }
          }
        case n:
          return A;
      }
    }
  }
  function P(m) {
    return $(m) === c;
  }
  return he.AsyncMode = l, he.ConcurrentMode = c, he.ContextConsumer = u, he.ContextProvider = i, he.Element = t, he.ForwardRef = f, he.Fragment = r, he.Lazy = h, he.Memo = y, he.Portal = n, he.Profiler = a, he.StrictMode = o, he.Suspense = s, he.isAsyncMode = function(m) {
    return P(m) || $(m) === l;
  }, he.isConcurrentMode = P, he.isContextConsumer = function(m) {
    return $(m) === u;
  }, he.isContextProvider = function(m) {
    return $(m) === i;
  }, he.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === t;
  }, he.isForwardRef = function(m) {
    return $(m) === f;
  }, he.isFragment = function(m) {
    return $(m) === r;
  }, he.isLazy = function(m) {
    return $(m) === h;
  }, he.isMemo = function(m) {
    return $(m) === y;
  }, he.isPortal = function(m) {
    return $(m) === n;
  }, he.isProfiler = function(m) {
    return $(m) === a;
  }, he.isStrictMode = function(m) {
    return $(m) === o;
  }, he.isSuspense = function(m) {
    return $(m) === s;
  }, he.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === r || m === c || m === a || m === o || m === s || m === d || typeof m == "object" && m !== null && (m.$$typeof === h || m.$$typeof === y || m.$$typeof === i || m.$$typeof === u || m.$$typeof === f || m.$$typeof === O || m.$$typeof === b || m.$$typeof === x || m.$$typeof === v);
  }, he.typeOf = $, he;
}
var me = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ru;
function kh() {
  return ru || (ru = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, s = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, O = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function $(T) {
      return typeof T == "string" || typeof T == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      T === r || T === c || T === a || T === o || T === s || T === d || typeof T == "object" && T !== null && (T.$$typeof === h || T.$$typeof === y || T.$$typeof === i || T.$$typeof === u || T.$$typeof === f || T.$$typeof === O || T.$$typeof === b || T.$$typeof === x || T.$$typeof === v);
    }
    function P(T) {
      if (typeof T == "object" && T !== null) {
        var oe = T.$$typeof;
        switch (oe) {
          case t:
            var re = T.type;
            switch (re) {
              case l:
              case c:
              case r:
              case a:
              case o:
              case s:
                return re;
              default:
                var te = re && re.$$typeof;
                switch (te) {
                  case u:
                  case f:
                  case h:
                  case y:
                  case i:
                    return te;
                  default:
                    return oe;
                }
            }
          case n:
            return oe;
        }
      }
    }
    var m = l, A = c, D = u, I = i, L = t, Q = f, W = r, z = h, J = y, N = n, S = a, C = o, g = s, j = !1;
    function ce(T) {
      return j || (j = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), _(T) || P(T) === l;
    }
    function _(T) {
      return P(T) === c;
    }
    function R(T) {
      return P(T) === u;
    }
    function Y(T) {
      return P(T) === i;
    }
    function E(T) {
      return typeof T == "object" && T !== null && T.$$typeof === t;
    }
    function U(T) {
      return P(T) === f;
    }
    function Z(T) {
      return P(T) === r;
    }
    function V(T) {
      return P(T) === h;
    }
    function G(T) {
      return P(T) === y;
    }
    function B(T) {
      return P(T) === n;
    }
    function F(T) {
      return P(T) === a;
    }
    function w(T) {
      return P(T) === o;
    }
    function H(T) {
      return P(T) === s;
    }
    me.AsyncMode = m, me.ConcurrentMode = A, me.ContextConsumer = D, me.ContextProvider = I, me.Element = L, me.ForwardRef = Q, me.Fragment = W, me.Lazy = z, me.Memo = J, me.Portal = N, me.Profiler = S, me.StrictMode = C, me.Suspense = g, me.isAsyncMode = ce, me.isConcurrentMode = _, me.isContextConsumer = R, me.isContextProvider = Y, me.isElement = E, me.isForwardRef = U, me.isFragment = Z, me.isLazy = V, me.isMemo = G, me.isPortal = B, me.isProfiler = F, me.isStrictMode = w, me.isSuspense = H, me.isValidElementType = $, me.typeOf = P;
  }()), me;
}
var ou;
function cl() {
  return ou || (ou = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = Mh() : e.exports = kh();
  }(Dh)), fr;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Mr, au;
function Ah() {
  if (au)
    return Mr;
  au = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, u = 0; u < 10; u++)
        i["_" + String.fromCharCode(u)] = u;
      var l = Object.getOwnPropertyNames(i).map(function(f) {
        return i[f];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        c[f] = f;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Mr = o() ? Object.assign : function(a, i) {
    for (var u, l = r(a), c, f = 1; f < arguments.length; f++) {
      u = Object(arguments[f]);
      for (var s in u)
        t.call(u, s) && (l[s] = u[s]);
      if (e) {
        c = e(u);
        for (var d = 0; d < c.length; d++)
          n.call(u, c[d]) && (l[c[d]] = u[c[d]]);
      }
    }
    return l;
  }, Mr;
}
var kr, iu;
function ha() {
  if (iu)
    return kr;
  iu = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return kr = e, kr;
}
var Ar, uu;
function sl() {
  return uu || (uu = 1, Ar = Function.call.bind(Object.prototype.hasOwnProperty)), Ar;
}
var Ir, lu;
function Ih() {
  if (lu)
    return Ir;
  lu = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = ha(), n = {}, r = sl();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(a, i, u, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in a)
        if (r(a, f)) {
          var s;
          try {
            if (typeof a[f] != "function") {
              var d = Error(
                (l || "React class") + ": " + u + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            s = a[f](i, f, l, u, null, t);
          } catch (h) {
            s = h;
          }
          if (s && !(s instanceof Error) && e(
            (l || "React class") + ": type specification of " + u + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof s + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), s instanceof Error && !(s.message in n)) {
            n[s.message] = !0;
            var y = c ? c() : "";
            e(
              "Failed " + u + " type: " + s.message + (y ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Ir = o, Ir;
}
var Ur, cu;
function Uh() {
  if (cu)
    return Ur;
  cu = 1;
  var e = cl(), t = Ah(), n = ha(), r = sl(), o = Ih(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(u) {
    var l = "Warning: " + u;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Ur = function(u, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function s(_) {
      var R = _ && (c && _[c] || _[f]);
      if (typeof R == "function")
        return R;
    }
    var d = "<<anonymous>>", y = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: x(),
      arrayOf: $,
      element: P(),
      elementType: m(),
      instanceOf: A,
      node: Q(),
      objectOf: I,
      oneOf: D,
      oneOfType: L,
      shape: z,
      exact: J
    };
    function h(_, R) {
      return _ === R ? _ !== 0 || 1 / _ === 1 / R : _ !== _ && R !== R;
    }
    function v(_, R) {
      this.message = _, this.data = R && typeof R == "object" ? R : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function O(_) {
      if (process.env.NODE_ENV !== "production")
        var R = {}, Y = 0;
      function E(Z, V, G, B, F, w, H) {
        if (B = B || d, w = w || G, H !== n) {
          if (l) {
            var T = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw T.name = "Invariant Violation", T;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var oe = B + ":" + G;
            !R[oe] && // Avoid spamming the console because they are often not actionable except for lib authors
            Y < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + w + "` prop on `" + B + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), R[oe] = !0, Y++);
          }
        }
        return V[G] == null ? Z ? V[G] === null ? new v("The " + F + " `" + w + "` is marked as required " + ("in `" + B + "`, but its value is `null`.")) : new v("The " + F + " `" + w + "` is marked as required in " + ("`" + B + "`, but its value is `undefined`.")) : null : _(V, G, B, F, w);
      }
      var U = E.bind(null, !1);
      return U.isRequired = E.bind(null, !0), U;
    }
    function b(_) {
      function R(Y, E, U, Z, V, G) {
        var B = Y[E], F = C(B);
        if (F !== _) {
          var w = g(B);
          return new v(
            "Invalid " + Z + " `" + V + "` of type " + ("`" + w + "` supplied to `" + U + "`, expected ") + ("`" + _ + "`."),
            { expectedType: _ }
          );
        }
        return null;
      }
      return O(R);
    }
    function x() {
      return O(i);
    }
    function $(_) {
      function R(Y, E, U, Z, V) {
        if (typeof _ != "function")
          return new v("Property `" + V + "` of component `" + U + "` has invalid PropType notation inside arrayOf.");
        var G = Y[E];
        if (!Array.isArray(G)) {
          var B = C(G);
          return new v("Invalid " + Z + " `" + V + "` of type " + ("`" + B + "` supplied to `" + U + "`, expected an array."));
        }
        for (var F = 0; F < G.length; F++) {
          var w = _(G, F, U, Z, V + "[" + F + "]", n);
          if (w instanceof Error)
            return w;
        }
        return null;
      }
      return O(R);
    }
    function P() {
      function _(R, Y, E, U, Z) {
        var V = R[Y];
        if (!u(V)) {
          var G = C(V);
          return new v("Invalid " + U + " `" + Z + "` of type " + ("`" + G + "` supplied to `" + E + "`, expected a single ReactElement."));
        }
        return null;
      }
      return O(_);
    }
    function m() {
      function _(R, Y, E, U, Z) {
        var V = R[Y];
        if (!e.isValidElementType(V)) {
          var G = C(V);
          return new v("Invalid " + U + " `" + Z + "` of type " + ("`" + G + "` supplied to `" + E + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return O(_);
    }
    function A(_) {
      function R(Y, E, U, Z, V) {
        if (!(Y[E] instanceof _)) {
          var G = _.name || d, B = ce(Y[E]);
          return new v("Invalid " + Z + " `" + V + "` of type " + ("`" + B + "` supplied to `" + U + "`, expected ") + ("instance of `" + G + "`."));
        }
        return null;
      }
      return O(R);
    }
    function D(_) {
      if (!Array.isArray(_))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function R(Y, E, U, Z, V) {
        for (var G = Y[E], B = 0; B < _.length; B++)
          if (h(G, _[B]))
            return null;
        var F = JSON.stringify(_, function(H, T) {
          var oe = g(T);
          return oe === "symbol" ? String(T) : T;
        });
        return new v("Invalid " + Z + " `" + V + "` of value `" + String(G) + "` " + ("supplied to `" + U + "`, expected one of " + F + "."));
      }
      return O(R);
    }
    function I(_) {
      function R(Y, E, U, Z, V) {
        if (typeof _ != "function")
          return new v("Property `" + V + "` of component `" + U + "` has invalid PropType notation inside objectOf.");
        var G = Y[E], B = C(G);
        if (B !== "object")
          return new v("Invalid " + Z + " `" + V + "` of type " + ("`" + B + "` supplied to `" + U + "`, expected an object."));
        for (var F in G)
          if (r(G, F)) {
            var w = _(G, F, U, Z, V + "." + F, n);
            if (w instanceof Error)
              return w;
          }
        return null;
      }
      return O(R);
    }
    function L(_) {
      if (!Array.isArray(_))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var R = 0; R < _.length; R++) {
        var Y = _[R];
        if (typeof Y != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + j(Y) + " at index " + R + "."
          ), i;
      }
      function E(U, Z, V, G, B) {
        for (var F = [], w = 0; w < _.length; w++) {
          var H = _[w], T = H(U, Z, V, G, B, n);
          if (T == null)
            return null;
          T.data && r(T.data, "expectedType") && F.push(T.data.expectedType);
        }
        var oe = F.length > 0 ? ", expected one of type [" + F.join(", ") + "]" : "";
        return new v("Invalid " + G + " `" + B + "` supplied to " + ("`" + V + "`" + oe + "."));
      }
      return O(E);
    }
    function Q() {
      function _(R, Y, E, U, Z) {
        return N(R[Y]) ? null : new v("Invalid " + U + " `" + Z + "` supplied to " + ("`" + E + "`, expected a ReactNode."));
      }
      return O(_);
    }
    function W(_, R, Y, E, U) {
      return new v(
        (_ || "React class") + ": " + R + " type `" + Y + "." + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + U + "`."
      );
    }
    function z(_) {
      function R(Y, E, U, Z, V) {
        var G = Y[E], B = C(G);
        if (B !== "object")
          return new v("Invalid " + Z + " `" + V + "` of type `" + B + "` " + ("supplied to `" + U + "`, expected `object`."));
        for (var F in _) {
          var w = _[F];
          if (typeof w != "function")
            return W(U, Z, V, F, g(w));
          var H = w(G, F, U, Z, V + "." + F, n);
          if (H)
            return H;
        }
        return null;
      }
      return O(R);
    }
    function J(_) {
      function R(Y, E, U, Z, V) {
        var G = Y[E], B = C(G);
        if (B !== "object")
          return new v("Invalid " + Z + " `" + V + "` of type `" + B + "` " + ("supplied to `" + U + "`, expected `object`."));
        var F = t({}, Y[E], _);
        for (var w in F) {
          var H = _[w];
          if (r(_, w) && typeof H != "function")
            return W(U, Z, V, w, g(H));
          if (!H)
            return new v(
              "Invalid " + Z + " `" + V + "` key `" + w + "` supplied to `" + U + "`.\nBad object: " + JSON.stringify(Y[E], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(_), null, "  ")
            );
          var T = H(G, w, U, Z, V + "." + w, n);
          if (T)
            return T;
        }
        return null;
      }
      return O(R);
    }
    function N(_) {
      switch (typeof _) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !_;
        case "object":
          if (Array.isArray(_))
            return _.every(N);
          if (_ === null || u(_))
            return !0;
          var R = s(_);
          if (R) {
            var Y = R.call(_), E;
            if (R !== _.entries) {
              for (; !(E = Y.next()).done; )
                if (!N(E.value))
                  return !1;
            } else
              for (; !(E = Y.next()).done; ) {
                var U = E.value;
                if (U && !N(U[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function S(_, R) {
      return _ === "symbol" ? !0 : R ? R["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && R instanceof Symbol : !1;
    }
    function C(_) {
      var R = typeof _;
      return Array.isArray(_) ? "array" : _ instanceof RegExp ? "object" : S(R, _) ? "symbol" : R;
    }
    function g(_) {
      if (typeof _ > "u" || _ === null)
        return "" + _;
      var R = C(_);
      if (R === "object") {
        if (_ instanceof Date)
          return "date";
        if (_ instanceof RegExp)
          return "regexp";
      }
      return R;
    }
    function j(_) {
      var R = g(_);
      switch (R) {
        case "array":
        case "object":
          return "an " + R;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + R;
        default:
          return R;
      }
    }
    function ce(_) {
      return !_.constructor || !_.constructor.name ? d : _.constructor.name;
    }
    return y.checkPropTypes = o, y.resetWarningCache = o.resetWarningCache, y.PropTypes = y, y;
  }, Ur;
}
var Lr, su;
function Lh() {
  if (su)
    return Lr;
  su = 1;
  var e = ha();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Lr = function() {
    function r(i, u, l, c, f, s) {
      if (s !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Lr;
}
if (process.env.NODE_ENV !== "production") {
  var Wh = cl(), jh = !0;
  tu.exports = Uh()(Wh.isElement, jh);
} else
  tu.exports = Lh()();
var dr = {}, qh = {
  get exports() {
    return dr;
  },
  set exports(e) {
    dr = e;
  }
}, Le = {}, Rt = {}, Fh = {
  get exports() {
    return Rt;
  },
  set exports(e) {
    Rt = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = f;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var n = "none", r = "contents", o = /input|select|textarea|button|object|iframe/;
  function a(s, d) {
    return d.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    s.scrollWidth <= 0 && s.scrollHeight <= 0;
  }
  function i(s) {
    var d = s.offsetWidth <= 0 && s.offsetHeight <= 0;
    if (d && !s.innerHTML)
      return !0;
    try {
      var y = window.getComputedStyle(s), h = y.getPropertyValue("display");
      return d ? h !== r && a(s, y) : h === n;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function u(s) {
    for (var d = s, y = s.getRootNode && s.getRootNode(); d && d !== document.body; ) {
      if (y && d === y && (d = y.host.parentNode), i(d))
        return !1;
      d = d.parentNode;
    }
    return !0;
  }
  function l(s, d) {
    var y = s.nodeName.toLowerCase(), h = o.test(y) && !s.disabled || y === "a" && s.href || d;
    return h && u(s);
  }
  function c(s) {
    var d = s.getAttribute("tabindex");
    d === null && (d = void 0);
    var y = isNaN(d);
    return (y || d >= 0) && l(s, !y);
  }
  function f(s) {
    var d = [].slice.call(s.querySelectorAll("*"), 0).reduce(function(y, h) {
      return y.concat(h.shadowRoot ? f(h.shadowRoot) : [h]);
    }, []);
    return d.filter(c);
  }
  e.exports = t.default;
})(Fh, Rt);
Object.defineProperty(Le, "__esModule", {
  value: !0
});
Le.resetState = zh;
Le.log = Vh;
Le.handleBlur = Et;
Le.handleFocus = xt;
Le.markForFocusLater = Qh;
Le.returnFocus = Xh;
Le.popWithoutFocus = Gh;
Le.setupScopedFocus = Kh;
Le.teardownScopedFocus = Jh;
var Hh = Rt, Yh = Bh(Hh);
function Bh(e) {
  return e && e.__esModule ? e : { default: e };
}
var ft = [], yt = null, ea = !1;
function zh() {
  ft = [];
}
function Vh() {
  process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), ft.forEach(function(e) {
    var t = e || {};
    console.log(t.nodeName, t.className, t.id);
  }), console.log("end focusManager ----------"));
}
function Et() {
  ea = !0;
}
function xt() {
  if (ea) {
    if (ea = !1, !yt)
      return;
    setTimeout(function() {
      if (!yt.contains(document.activeElement)) {
        var e = (0, Yh.default)(yt)[0] || yt;
        e.focus();
      }
    }, 0);
  }
}
function Qh() {
  ft.push(document.activeElement);
}
function Xh() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = null;
  try {
    ft.length !== 0 && (t = ft.pop(), t.focus({ preventScroll: e }));
    return;
  } catch {
    console.warn(["You tried to return focus to", t, "but it is not in the DOM anymore"].join(" "));
  }
}
function Gh() {
  ft.length > 0 && ft.pop();
}
function Kh(e) {
  yt = e, window.addEventListener ? (window.addEventListener("blur", Et, !1), document.addEventListener("focus", xt, !0)) : (window.attachEvent("onBlur", Et), document.attachEvent("onFocus", xt));
}
function Jh() {
  yt = null, window.addEventListener ? (window.removeEventListener("blur", Et), document.removeEventListener("focus", xt)) : (window.detachEvent("onBlur", Et), document.detachEvent("onFocus", xt));
}
var pr = {}, Zh = {
  get exports() {
    return pr;
  },
  set exports(e) {
    pr = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = Rt, r = o(n);
  function o(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function a() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return u.activeElement.shadowRoot ? a(u.activeElement.shadowRoot) : u.activeElement;
  }
  function i(u, l) {
    var c = (0, r.default)(u);
    if (!c.length) {
      l.preventDefault();
      return;
    }
    var f = void 0, s = l.shiftKey, d = c[0], y = c[c.length - 1], h = a();
    if (u === h) {
      if (!s)
        return;
      f = y;
    }
    if (y === h && !s && (f = d), d === h && s && (f = y), f) {
      l.preventDefault(), f.focus();
      return;
    }
    var v = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), O = v != null && v[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (O) {
      var b = c.indexOf(h);
      if (b > -1 && (b += s ? -1 : 1), f = c[b], typeof f > "u") {
        l.preventDefault(), f = s ? y : d, f.focus();
        return;
      }
      l.preventDefault(), f.focus();
    }
  }
  e.exports = t.default;
})(Zh, pr);
var We = {}, em = process.env.NODE_ENV !== "production", fl = function() {
};
if (em) {
  var tm = function(t, n) {
    var r = arguments.length;
    n = new Array(r > 1 ? r - 1 : 0);
    for (var o = 1; o < r; o++)
      n[o - 1] = arguments[o];
    var a = 0, i = "Warning: " + t.replace(/%s/g, function() {
      return n[a++];
    });
    typeof console < "u" && console.error(i);
    try {
      throw new Error(i);
    } catch {
    }
  };
  fl = function(e, t, n) {
    var r = arguments.length;
    n = new Array(r > 2 ? r - 2 : 0);
    for (var o = 2; o < r; o++)
      n[o - 2] = arguments[o];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || tm.apply(null, [t].concat(n));
  };
}
var nm = fl, Ue = {}, ta = {}, rm = {
  get exports() {
    return ta;
  },
  set exports(e) {
    ta = e;
  }
};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(e) {
  (function() {
    var t = !!(typeof window < "u" && window.document && window.document.createElement), n = {
      canUseDOM: t,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: t && !!(window.addEventListener || window.attachEvent),
      canUseViewport: t && !!window.screen
    };
    e.exports ? e.exports = n : window.ExecutionEnvironment = n;
  })();
})(rm);
Object.defineProperty(Ue, "__esModule", {
  value: !0
});
Ue.canUseDOM = Ue.SafeNodeList = Ue.SafeHTMLCollection = void 0;
var om = ta, am = im(om);
function im(e) {
  return e && e.__esModule ? e : { default: e };
}
var Sr = am.default, um = Sr.canUseDOM ? window.HTMLElement : {};
Ue.SafeHTMLCollection = Sr.canUseDOM ? window.HTMLCollection : {};
Ue.SafeNodeList = Sr.canUseDOM ? window.NodeList : {};
Ue.canUseDOM = Sr.canUseDOM;
Ue.default = um;
Object.defineProperty(We, "__esModule", {
  value: !0
});
We.resetState = dm;
We.log = pm;
We.assertNodeList = dl;
We.setElement = ym;
We.validateElement = ma;
We.hide = hm;
We.show = mm;
We.documentNotReadyOrSSRTesting = vm;
var lm = nm, cm = fm(lm), sm = Ue;
function fm(e) {
  return e && e.__esModule ? e : { default: e };
}
var xe = null;
function dm() {
  xe && (xe.removeAttribute ? xe.removeAttribute("aria-hidden") : xe.length != null ? xe.forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(xe).forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  })), xe = null;
}
function pm() {
  if (process.env.NODE_ENV !== "production") {
    var e = xe || {};
    console.log("ariaAppHider ----------"), console.log(e.nodeName, e.className, e.id), console.log("end ariaAppHider ----------");
  }
}
function dl(e, t) {
  if (!e || !e.length)
    throw new Error("react-modal: No elements were found for selector " + t + ".");
}
function ym(e) {
  var t = e;
  if (typeof t == "string" && sm.canUseDOM) {
    var n = document.querySelectorAll(t);
    dl(n, t), t = n;
  }
  return xe = t || xe, xe;
}
function ma(e) {
  var t = e || xe;
  return t ? Array.isArray(t) || t instanceof HTMLCollection || t instanceof NodeList ? t : [t] : ((0, cm.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function hm(e) {
  var t = !0, n = !1, r = void 0;
  try {
    for (var o = ma(e)[Symbol.iterator](), a; !(t = (a = o.next()).done); t = !0) {
      var i = a.value;
      i.setAttribute("aria-hidden", "true");
    }
  } catch (u) {
    n = !0, r = u;
  } finally {
    try {
      !t && o.return && o.return();
    } finally {
      if (n)
        throw r;
    }
  }
}
function mm(e) {
  var t = !0, n = !1, r = void 0;
  try {
    for (var o = ma(e)[Symbol.iterator](), a; !(t = (a = o.next()).done); t = !0) {
      var i = a.value;
      i.removeAttribute("aria-hidden");
    }
  } catch (u) {
    n = !0, r = u;
  } finally {
    try {
      !t && o.return && o.return();
    } finally {
      if (n)
        throw r;
    }
  }
}
function vm() {
  xe = null;
}
var _t = {};
Object.defineProperty(_t, "__esModule", {
  value: !0
});
_t.resetState = bm;
_t.log = gm;
var at = {}, it = {};
function fu(e, t) {
  e.classList.remove(t);
}
function bm() {
  var e = document.getElementsByTagName("html")[0];
  for (var t in at)
    fu(e, at[t]);
  var n = document.body;
  for (var r in it)
    fu(n, it[r]);
  at = {}, it = {};
}
function gm() {
  if (process.env.NODE_ENV !== "production") {
    var e = document.getElementsByTagName("html")[0].className, t = `Show tracked classes:

`;
    t += "<html /> (" + e + `):
  `;
    for (var n in at)
      t += "  " + n + " " + at[n] + `
  `;
    e = document.body.className, t += `

doc.body (` + e + `):
  `;
    for (var r in it)
      t += "  " + r + " " + it[r] + `
  `;
    t += `
`, console.log(t);
  }
}
var _m = function(t, n) {
  return t[n] || (t[n] = 0), t[n] += 1, n;
}, wm = function(t, n) {
  return t[n] && (t[n] -= 1), n;
}, Om = function(t, n, r) {
  r.forEach(function(o) {
    _m(n, o), t.add(o);
  });
}, Pm = function(t, n, r) {
  r.forEach(function(o) {
    wm(n, o), n[o] === 0 && t.remove(o);
  });
};
_t.add = function(t, n) {
  return Om(t.classList, t.nodeName.toLowerCase() == "html" ? at : it, n.split(" "));
};
_t.remove = function(t, n) {
  return Pm(t.classList, t.nodeName.toLowerCase() == "html" ? at : it, n.split(" "));
};
var wt = {};
Object.defineProperty(wt, "__esModule", {
  value: !0
});
wt.log = Sm;
wt.resetState = $m;
function Tm(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var pl = function e() {
  var t = this;
  Tm(this, e), this.register = function(n) {
    if (t.openInstances.indexOf(n) !== -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
      return;
    }
    t.openInstances.push(n), t.emit("register");
  }, this.deregister = function(n) {
    var r = t.openInstances.indexOf(n);
    if (r === -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + n + " as it was never registered");
      return;
    }
    t.openInstances.splice(r, 1), t.emit("deregister");
  }, this.subscribe = function(n) {
    t.subscribers.push(n);
  }, this.emit = function(n) {
    t.subscribers.forEach(function(r) {
      return r(
        n,
        // shallow copy to avoid accidental mutation
        t.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, yr = new pl();
function Sm() {
  console.log("portalOpenInstances ----------"), console.log(yr.openInstances.length), yr.openInstances.forEach(function(e) {
    return console.log(e);
  }), console.log("end portalOpenInstances ----------");
}
function $m() {
  yr = new pl();
}
wt.default = yr;
var va = {};
Object.defineProperty(va, "__esModule", {
  value: !0
});
va.resetState = Cm;
va.log = Nm;
var Rm = wt, Em = xm(Rm);
function xm(e) {
  return e && e.__esModule ? e : { default: e };
}
var Re = void 0, Ie = void 0, ut = [];
function Cm() {
  for (var e = [Re, Ie], t = 0; t < e.length; t++) {
    var n = e[t];
    n && n.parentNode && n.parentNode.removeChild(n);
  }
  Re = Ie = null, ut = [];
}
function Nm() {
  console.log("bodyTrap ----------"), console.log(ut.length);
  for (var e = [Re, Ie], t = 0; t < e.length; t++) {
    var n = e[t], r = n || {};
    console.log(r.nodeName, r.className, r.id);
  }
  console.log("edn bodyTrap ----------");
}
function du() {
  if (ut.length === 0) {
    process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
    return;
  }
  ut[ut.length - 1].focusContent();
}
function Dm(e, t) {
  !Re && !Ie && (Re = document.createElement("div"), Re.setAttribute("data-react-modal-body-trap", ""), Re.style.position = "absolute", Re.style.opacity = "0", Re.setAttribute("tabindex", "0"), Re.addEventListener("focus", du), Ie = Re.cloneNode(), Ie.addEventListener("focus", du)), ut = t, ut.length > 0 ? (document.body.firstChild !== Re && document.body.insertBefore(Re, document.body.firstChild), document.body.lastChild !== Ie && document.body.appendChild(Ie)) : (Re.parentElement && Re.parentElement.removeChild(Re), Ie.parentElement && Ie.parentElement.removeChild(Ie));
}
Em.default.subscribe(Dm);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = Object.assign || function(N) {
    for (var S = 1; S < arguments.length; S++) {
      var C = arguments[S];
      for (var g in C)
        Object.prototype.hasOwnProperty.call(C, g) && (N[g] = C[g]);
    }
    return N;
  }, r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(N) {
    return typeof N;
  } : function(N) {
    return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
  }, o = function() {
    function N(S, C) {
      for (var g = 0; g < C.length; g++) {
        var j = C[g];
        j.enumerable = j.enumerable || !1, j.configurable = !0, "value" in j && (j.writable = !0), Object.defineProperty(S, j.key, j);
      }
    }
    return function(S, C, g) {
      return C && N(S.prototype, C), g && N(S, g), S;
    };
  }(), a = ge, i = sr, u = m(i), l = Le, c = P(l), f = pr, s = m(f), d = We, y = P(d), h = _t, v = P(h), O = Ue, b = m(O), x = wt, $ = m(x);
  function P(N) {
    if (N && N.__esModule)
      return N;
    var S = {};
    if (N != null)
      for (var C in N)
        Object.prototype.hasOwnProperty.call(N, C) && (S[C] = N[C]);
    return S.default = N, S;
  }
  function m(N) {
    return N && N.__esModule ? N : { default: N };
  }
  function A(N, S) {
    if (!(N instanceof S))
      throw new TypeError("Cannot call a class as a function");
  }
  function D(N, S) {
    if (!N)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return S && (typeof S == "object" || typeof S == "function") ? S : N;
  }
  function I(N, S) {
    if (typeof S != "function" && S !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof S);
    N.prototype = Object.create(S && S.prototype, { constructor: { value: N, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(N, S) : N.__proto__ = S);
  }
  var L = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, Q = function(S) {
    return S.code === "Tab" || S.keyCode === 9;
  }, W = function(S) {
    return S.code === "Escape" || S.keyCode === 27;
  }, z = 0, J = function(N) {
    I(S, N);
    function S(C) {
      A(this, S);
      var g = D(this, (S.__proto__ || Object.getPrototypeOf(S)).call(this, C));
      return g.setOverlayRef = function(j) {
        g.overlay = j, g.props.overlayRef && g.props.overlayRef(j);
      }, g.setContentRef = function(j) {
        g.content = j, g.props.contentRef && g.props.contentRef(j);
      }, g.afterClose = function() {
        var j = g.props, ce = j.appElement, _ = j.ariaHideApp, R = j.htmlOpenClassName, Y = j.bodyOpenClassName, E = j.parentSelector, U = E && E().ownerDocument || document;
        Y && v.remove(U.body, Y), R && v.remove(U.getElementsByTagName("html")[0], R), _ && z > 0 && (z -= 1, z === 0 && y.show(ce)), g.props.shouldFocusAfterRender && (g.props.shouldReturnFocusAfterClose ? (c.returnFocus(g.props.preventScroll), c.teardownScopedFocus()) : c.popWithoutFocus()), g.props.onAfterClose && g.props.onAfterClose(), $.default.deregister(g);
      }, g.open = function() {
        g.beforeOpen(), g.state.afterOpen && g.state.beforeClose ? (clearTimeout(g.closeTimer), g.setState({ beforeClose: !1 })) : (g.props.shouldFocusAfterRender && (c.setupScopedFocus(g.node), c.markForFocusLater()), g.setState({ isOpen: !0 }, function() {
          g.openAnimationFrame = requestAnimationFrame(function() {
            g.setState({ afterOpen: !0 }), g.props.isOpen && g.props.onAfterOpen && g.props.onAfterOpen({
              overlayEl: g.overlay,
              contentEl: g.content
            });
          });
        }));
      }, g.close = function() {
        g.props.closeTimeoutMS > 0 ? g.closeWithTimeout() : g.closeWithoutTimeout();
      }, g.focusContent = function() {
        return g.content && !g.contentHasFocus() && g.content.focus({ preventScroll: !0 });
      }, g.closeWithTimeout = function() {
        var j = Date.now() + g.props.closeTimeoutMS;
        g.setState({ beforeClose: !0, closesAt: j }, function() {
          g.closeTimer = setTimeout(g.closeWithoutTimeout, g.state.closesAt - Date.now());
        });
      }, g.closeWithoutTimeout = function() {
        g.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, g.afterClose);
      }, g.handleKeyDown = function(j) {
        Q(j) && (0, s.default)(g.content, j), g.props.shouldCloseOnEsc && W(j) && (j.stopPropagation(), g.requestClose(j));
      }, g.handleOverlayOnClick = function(j) {
        g.shouldClose === null && (g.shouldClose = !0), g.shouldClose && g.props.shouldCloseOnOverlayClick && (g.ownerHandlesClose() ? g.requestClose(j) : g.focusContent()), g.shouldClose = null;
      }, g.handleContentOnMouseUp = function() {
        g.shouldClose = !1;
      }, g.handleOverlayOnMouseDown = function(j) {
        !g.props.shouldCloseOnOverlayClick && j.target == g.overlay && j.preventDefault();
      }, g.handleContentOnClick = function() {
        g.shouldClose = !1;
      }, g.handleContentOnMouseDown = function() {
        g.shouldClose = !1;
      }, g.requestClose = function(j) {
        return g.ownerHandlesClose() && g.props.onRequestClose(j);
      }, g.ownerHandlesClose = function() {
        return g.props.onRequestClose;
      }, g.shouldBeClosed = function() {
        return !g.state.isOpen && !g.state.beforeClose;
      }, g.contentHasFocus = function() {
        return document.activeElement === g.content || g.content.contains(document.activeElement);
      }, g.buildClassName = function(j, ce) {
        var _ = (typeof ce > "u" ? "undefined" : r(ce)) === "object" ? ce : {
          base: L[j],
          afterOpen: L[j] + "--after-open",
          beforeClose: L[j] + "--before-close"
        }, R = _.base;
        return g.state.afterOpen && (R = R + " " + _.afterOpen), g.state.beforeClose && (R = R + " " + _.beforeClose), typeof ce == "string" && ce ? R + " " + ce : R;
      }, g.attributesFromObject = function(j, ce) {
        return Object.keys(ce).reduce(function(_, R) {
          return _[j + "-" + R] = ce[R], _;
        }, {});
      }, g.state = {
        afterOpen: !1,
        beforeClose: !1
      }, g.shouldClose = null, g.moveFromContentToOverlay = null, g;
    }
    return o(S, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(g, j) {
        process.env.NODE_ENV !== "production" && (g.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), g.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !g.isOpen ? this.open() : !this.props.isOpen && g.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !j.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var g = this.props, j = g.appElement, ce = g.ariaHideApp, _ = g.htmlOpenClassName, R = g.bodyOpenClassName, Y = g.parentSelector, E = Y && Y().ownerDocument || document;
        R && v.add(E.body, R), _ && v.add(E.getElementsByTagName("html")[0], _), ce && (z += 1, y.hide(j)), $.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var g = this.props, j = g.id, ce = g.className, _ = g.overlayClassName, R = g.defaultStyles, Y = g.children, E = ce ? {} : R.content, U = _ ? {} : R.overlay;
        if (this.shouldBeClosed())
          return null;
        var Z = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", _),
          style: n({}, U, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, V = n({
          id: j,
          ref: this.setContentRef,
          style: n({}, E, this.props.style.content),
          className: this.buildClassName("content", ce),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", n({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), G = this.props.contentElement(V, Y);
        return this.props.overlayElement(Z, G);
      }
    }]), S;
  }(a.Component);
  J.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, J.propTypes = {
    isOpen: u.default.bool.isRequired,
    defaultStyles: u.default.shape({
      content: u.default.object,
      overlay: u.default.object
    }),
    style: u.default.shape({
      content: u.default.object,
      overlay: u.default.object
    }),
    className: u.default.oneOfType([u.default.string, u.default.object]),
    overlayClassName: u.default.oneOfType([u.default.string, u.default.object]),
    parentSelector: u.default.func,
    bodyOpenClassName: u.default.string,
    htmlOpenClassName: u.default.string,
    ariaHideApp: u.default.bool,
    appElement: u.default.oneOfType([u.default.instanceOf(b.default), u.default.instanceOf(O.SafeHTMLCollection), u.default.instanceOf(O.SafeNodeList), u.default.arrayOf(u.default.instanceOf(b.default))]),
    onAfterOpen: u.default.func,
    onAfterClose: u.default.func,
    onRequestClose: u.default.func,
    closeTimeoutMS: u.default.number,
    shouldFocusAfterRender: u.default.bool,
    shouldCloseOnOverlayClick: u.default.bool,
    shouldReturnFocusAfterClose: u.default.bool,
    preventScroll: u.default.bool,
    role: u.default.string,
    contentLabel: u.default.string,
    aria: u.default.object,
    data: u.default.object,
    children: u.default.node,
    shouldCloseOnEsc: u.default.bool,
    overlayRef: u.default.func,
    contentRef: u.default.func,
    id: u.default.string,
    overlayElement: u.default.func,
    contentElement: u.default.func,
    testId: u.default.string
  }, t.default = J, e.exports = t.default;
})(qh, dr);
function yl() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function hl(e) {
  function t(n) {
    var r = this.constructor.getDerivedStateFromProps(e, n);
    return r ?? null;
  }
  this.setState(t.bind(this));
}
function ml(e, t) {
  try {
    var n = this.props, r = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      n,
      r
    );
  } finally {
    this.props = n, this.state = r;
  }
}
yl.__suppressDeprecationWarning = !0;
hl.__suppressDeprecationWarning = !0;
ml.__suppressDeprecationWarning = !0;
function Mm(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return e;
  var n = null, r = null, o = null;
  if (typeof t.componentWillMount == "function" ? n = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (n = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? r = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (r = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? o = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (o = "UNSAFE_componentWillUpdate"), n !== null || r !== null || o !== null) {
    var a = e.displayName || e.name, i = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + a + " uses " + i + " but also contains the following legacy lifecycles:" + (n !== null ? `
  ` + n : "") + (r !== null ? `
  ` + r : "") + (o !== null ? `
  ` + o : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (t.componentWillMount = yl, t.componentWillReceiveProps = hl), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = ml;
    var u = t.componentDidUpdate;
    t.componentDidUpdate = function(c, f, s) {
      var d = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : s;
      u.call(this, c, f, d);
    };
  }
  return e;
}
const km = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: Mm
}, Symbol.toStringTag, { value: "Module" })), Am = /* @__PURE__ */ Ch(km);
Object.defineProperty(st, "__esModule", {
  value: !0
});
st.bodyOpenClassName = st.portalClassName = void 0;
var pu = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, Im = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}(), vl = ge, hr = Nt(vl), Um = bu, mr = Nt(Um), Lm = sr, ne = Nt(Lm), Wm = dr, yu = Nt(Wm), jm = We, qm = Hm(jm), Xe = Ue, hu = Nt(Xe), Fm = Am;
function Hm(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t.default = e, t;
}
function Nt(e) {
  return e && e.__esModule ? e : { default: e };
}
function Ym(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function mu(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function Bm(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var zm = st.portalClassName = "ReactModalPortal", Vm = st.bodyOpenClassName = "ReactModal__Body--open", nt = Xe.canUseDOM && mr.default.createPortal !== void 0, na = function(t) {
  return document.createElement(t);
}, vu = function() {
  return nt ? mr.default.createPortal : mr.default.unstable_renderSubtreeIntoContainer;
};
function Mt(e) {
  return e();
}
var Ot = function(e) {
  Bm(t, e);
  function t() {
    var n, r, o, a;
    Ym(this, t);
    for (var i = arguments.length, u = Array(i), l = 0; l < i; l++)
      u[l] = arguments[l];
    return a = (r = (o = mu(this, (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(n, [this].concat(u))), o), o.removePortal = function() {
      !nt && mr.default.unmountComponentAtNode(o.node);
      var c = Mt(o.props.parentSelector);
      c && c.contains(o.node) ? c.removeChild(o.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, o.portalRef = function(c) {
      o.portal = c;
    }, o.renderPortal = function(c) {
      var f = vu(), s = f(o, hr.default.createElement(yu.default, pu({ defaultStyles: t.defaultStyles }, c)), o.node);
      o.portalRef(s);
    }, r), mu(o, a);
  }
  return Im(t, [{
    key: "componentDidMount",
    value: function() {
      if (Xe.canUseDOM) {
        nt || (this.node = na("div")), this.node.className = this.props.portalClassName;
        var r = Mt(this.props.parentSelector);
        r.appendChild(this.node), !nt && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(r) {
      var o = Mt(r.parentSelector), a = Mt(this.props.parentSelector);
      return { prevParent: o, nextParent: a };
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, o, a) {
      if (Xe.canUseDOM) {
        var i = this.props, u = i.isOpen, l = i.portalClassName;
        r.portalClassName !== l && (this.node.className = l);
        var c = a.prevParent, f = a.nextParent;
        f !== c && (c.removeChild(this.node), f.appendChild(this.node)), !(!r.isOpen && !u) && !nt && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!Xe.canUseDOM || !this.node || !this.portal)) {
        var r = this.portal.state, o = Date.now(), a = r.isOpen && this.props.closeTimeoutMS && (r.closesAt || o + this.props.closeTimeoutMS);
        a ? (r.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, a - o)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!Xe.canUseDOM || !nt)
        return null;
      !this.node && nt && (this.node = na("div"));
      var r = vu();
      return r(hr.default.createElement(yu.default, pu({
        ref: this.portalRef,
        defaultStyles: t.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(r) {
      qm.setElement(r);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), t;
}(vl.Component);
Ot.propTypes = {
  isOpen: ne.default.bool.isRequired,
  style: ne.default.shape({
    content: ne.default.object,
    overlay: ne.default.object
  }),
  portalClassName: ne.default.string,
  bodyOpenClassName: ne.default.string,
  htmlOpenClassName: ne.default.string,
  className: ne.default.oneOfType([ne.default.string, ne.default.shape({
    base: ne.default.string.isRequired,
    afterOpen: ne.default.string.isRequired,
    beforeClose: ne.default.string.isRequired
  })]),
  overlayClassName: ne.default.oneOfType([ne.default.string, ne.default.shape({
    base: ne.default.string.isRequired,
    afterOpen: ne.default.string.isRequired,
    beforeClose: ne.default.string.isRequired
  })]),
  appElement: ne.default.oneOfType([ne.default.instanceOf(hu.default), ne.default.instanceOf(Xe.SafeHTMLCollection), ne.default.instanceOf(Xe.SafeNodeList), ne.default.arrayOf(ne.default.instanceOf(hu.default))]),
  onAfterOpen: ne.default.func,
  onRequestClose: ne.default.func,
  closeTimeoutMS: ne.default.number,
  ariaHideApp: ne.default.bool,
  shouldFocusAfterRender: ne.default.bool,
  shouldCloseOnOverlayClick: ne.default.bool,
  shouldReturnFocusAfterClose: ne.default.bool,
  preventScroll: ne.default.bool,
  parentSelector: ne.default.func,
  aria: ne.default.object,
  data: ne.default.object,
  role: ne.default.string,
  contentLabel: ne.default.string,
  shouldCloseOnEsc: ne.default.bool,
  overlayRef: ne.default.func,
  contentRef: ne.default.func,
  id: ne.default.string,
  overlayElement: ne.default.func,
  contentElement: ne.default.func
};
Ot.defaultProps = {
  isOpen: !1,
  portalClassName: zm,
  bodyOpenClassName: Vm,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(t, n) {
    return hr.default.createElement(
      "div",
      t,
      n
    );
  },
  contentElement: function(t, n) {
    return hr.default.createElement(
      "div",
      t,
      n
    );
  }
};
Ot.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, Fm.polyfill)(Ot);
process.env.NODE_ENV !== "production" && (Ot.setCreateHTMLElement = function(e) {
  return na = e;
});
st.default = Ot;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = st, r = o(n);
  function o(a) {
    return a && a.__esModule ? a : { default: a };
  }
  t.default = r.default, e.exports = t.default;
})(Nh, cr);
const Qm = /* @__PURE__ */ xh(cr);
function Ev({
  appRootId: e,
  ariaCloseLabel: t = "Sluiten",
  cancelButton: n,
  children: r,
  closeButton: o = !0,
  confirmButton: a,
  onAfterOpen: i,
  onClose: u,
  open: l,
  qa: c,
  shouldCloseOnOverlayClick: f = !0,
  size: s = "",
  title: d = { label: "" },
  trigger: y
}) {
  const [h, v] = ge.useState(!!l), O = l === !1 || l === !0 ? l : h, b = d?.tag || "h6", x = (P, m) => m && typeof m == "function" ? Promise.resolve(m(P)).then(() => v(!1)) : v(!1), $ = (P) => x(P, u);
  return /* @__PURE__ */ k(lt, { children: [
    y ? gt(y, { onClick: () => v(!0) }) : null,
    /* @__PURE__ */ p(
      Qm,
      {
        appElement: document.getElementById(e),
        bodyOpenClassName: null,
        htmlOpenClassName: null,
        className: X({ "m-modal": !0, [`m-modal--${ke[s || Me]}`]: !!s }),
        isOpen: O,
        onRequestClose: $,
        role: "dialog",
        "aria-modal": "true",
        overlayClassName: X({
          "m-overlay": !0,
          "is-active": !0
        }),
        "data-qa": c,
        ariaHideApp: !0,
        onAfterOpen: i,
        shouldCloseOnOverlayClick: n || a || o ? f : !0,
        children: /* @__PURE__ */ k("div", { className: "m-modal__content", children: [
          (d && d?.label || o) && /* @__PURE__ */ k("div", { className: "m-modal__header u-margin-bottom-xs", children: [
            d && d?.label && /* @__PURE__ */ p(b, { className: d.className, id: d.id, children: d.label }),
            o && /* @__PURE__ */ p(
              Ce,
              {
                className: "m-modal__close",
                theme: "neutral",
                addOn: { type: "icon", iconProps: { name: "ai-close" } },
                ariaLabel: t,
                emphasis: "low",
                onClick: $
              }
            )
          ] }),
          r && /* @__PURE__ */ p("div", { className: "u-margin-bottom", children: r }),
          a || n ? /* @__PURE__ */ k("div", { className: "m-modal__footer", children: [
            a ? /* @__PURE__ */ p(Ce, { ...a, onClick: (P) => x(P, a.onClick) }) : null,
            n ? /* @__PURE__ */ p(Ce, { ...n, onClick: (P) => x(P, n.onClick) }) : null
          ] }) : null
        ] })
      }
    )
  ] });
}
function xv({
  items: e = [],
  border: t,
  ariaLabel: n = "Navigatie",
  onItemClick: r,
  direction: o = "horizontal",
  qa: a
}) {
  const [i, u, l, c] = Gu(), f = X({
    "m-nav-list": o === "vertical",
    "m-nav-tabs": o !== "vertical",
    "has-border": !!t,
    "has-shadow-left": o !== "vertical" && !l,
    "has-shadow-right": o !== "vertical" && !c
  }), s = (y, h, v) => {
    r && !h.disabled && (y.preventDefault(), y.stopPropagation(), r(h.id, v));
  }, d = (y, h) => {
    const v = X({
      "is-active": !!y.active,
      "is-disabled": !!y.disabled
    });
    return /* @__PURE__ */ p("li", { className: v, children: /* @__PURE__ */ p(
      "a",
      {
        href: y.href,
        onClick: (O) => s(O, y, h),
        ...y.disabled ? { "aria-disabled": "true" } : {},
        ...y.active ? { "aria-current": "true" } : {},
        children: y.label
      }
    ) }, y.id);
  };
  return /* @__PURE__ */ p("nav", { role: "navigation", className: f, "aria-label": n, "data-qa": a, children: /* @__PURE__ */ p("ul", { ref: i, onScroll: u, ...!l || !c ? { tabIndex: 0 } : {}, children: e.map(d) }) });
}
function Cv({ qa: e, size: t, pages: n, activePage: r, onPageChange: o }) {
  const [a, i] = ge.useState(0), u = (s) => i(s), l = (s) => () => o && o(s), c = (s) => {
    const d = s.key === "ArrowLeft", y = s.key === "ArrowRight";
    if (d || y) {
      document.getElementById(r)?.setAttribute("tabindex", "-1");
      let h = a;
      y && (h = a + 1 >= n.length ? 0 : a + 1, i(h)), d && (h = a - 1 < 0 ? n.length - 1 : a - 1, i(h));
      const v = n[h].id;
      if (v) {
        const O = document.getElementById(v);
        O?.setAttribute("tabindex", "0"), n.filter((b) => b.id !== v).forEach((b) => {
          document.getElementById(b.id)?.setAttribute("tabindex", "-1");
        }), O?.focus();
      }
    }
  }, f = X({
    "a-page-indicator": !0,
    [`a-page-indicator--${ke[t || Me]}`]: !!t
  });
  return /* @__PURE__ */ p("div", { className: f, "data-qa": e, onKeyDown: c, role: "tablist", children: n?.map((s, d) => {
    const y = !!r && r === s.id, h = X({
      "a-page-indicator__item": !0,
      "is-active": y
    });
    return /* @__PURE__ */ p(
      "button",
      {
        id: s.id,
        role: "tab",
        className: h,
        "aria-label": s.ariaLabel,
        "aria-selected": y ? "true" : "false",
        "aria-controls": s.ariaControls,
        tabIndex: y ? 0 : -1,
        onClick: l(s.id),
        onFocus: () => u(d)
      },
      s.id
    );
  }) });
}
const Xm = (e, t, n, r) => /* @__PURE__ */ k("li", { className: "m-pagination__label", children: [
  /* @__PURE__ */ k("span", { className: "u-screen-reader-only", children: [
    r,
    " "
  ] }),
  n.replace("%currentPage%", `${e}`).replace("%totalPages%", `${t}`)
] }, "pagination__label"), Gm = (e, t, n, r) => Jy(e, t).map((a, i) => {
  if (a) {
    const u = X({
      "is-active": a === e
    });
    return /* @__PURE__ */ p("li", { children: /* @__PURE__ */ p(
      "a",
      {
        className: u,
        href: "#",
        onClick: (l) => r && r(a, l),
        "aria-label": `${n} ${a}`,
        "aria-current": a === e ? "page" : void 0,
        children: a
      }
    ) }, i);
  } else
    return /* @__PURE__ */ p("li", { children: "..." }, i);
});
function Nv({
  currentPage: e = 1,
  itemsPerPage: t,
  totalItems: n,
  onChange: r,
  display: o = "numbers",
  size: a,
  ariaLabel: i = "Paginering",
  ariaLabelNextPage: u = "Volgende pagina",
  ariaLabelPreviousPage: l = "Vorige pagina",
  ariaLabelPage: c = "Pagina",
  text: f = "%currentPage% van de %totalPages%",
  qa: s
}) {
  const [d, y] = fe(0), h = (P) => {
    P.preventDefault(), e > 1 && O(e - 1);
  }, v = (P) => {
    P.preventDefault(), e < d && O(e + 1);
  }, O = (P, m) => (m && m.preventDefault(), r && r(P)), b = X({
    "m-pagination": !0,
    [`m-pagination--${ke[a || Me]}`]: !!a
  }), x = X({ "is-disabled": e <= 1 }), $ = X({ "is-disabled": e >= d });
  return $e(() => {
    if (n && t) {
      const P = Math.ceil(Math.abs(n) / Math.abs(t));
      y(P);
    }
  }, [e, t, n]), /* @__PURE__ */ p("nav", { role: "navigation", "aria-label": i, "data-qa": s, children: /* @__PURE__ */ k("ul", { className: b, children: [
    /* @__PURE__ */ p("li", { className: "m-pagination__prev", children: /* @__PURE__ */ p("a", { href: "#", className: x, "aria-label": l, onClick: h, children: /* @__PURE__ */ p(ve, { name: "arrow-left-1" }) }) }, "pagination__prev"),
    o === "text" && Xm(e, d, f, c),
    o === "numbers" && Gm(e, d, c, O),
    /* @__PURE__ */ p("li", { className: "m-pagination__next", children: /* @__PURE__ */ p("a", { href: "#", className: $, "aria-label": u, onClick: v, children: /* @__PURE__ */ p(ve, { name: "arrow-right-1" }) }) }, "pagination__next")
  ] }) });
}
function Dv({
  steps: e = [],
  onStepClick: t,
  screenReaderStepLabel: n = "Stap ",
  screenReaderCompleteLabel: r = " (voltooid)",
  qa: o
}) {
  const a = (i, u, l) => {
    t && (i.preventDefault(), t(l, u));
  };
  return /* @__PURE__ */ p("ol", { className: "m-step-indicator", "data-qa": o, children: e?.map((i, u) => {
    const l = X({
      "is-completed": !!i.complete,
      "is-incompleted": !i.complete,
      "is-active": !!i.active
    }), c = i.link?.href;
    return /* @__PURE__ */ p("li", { className: l, children: gr(
      /* @__PURE__ */ k(lt, { children: [
        i.label ? null : /* @__PURE__ */ k("span", { className: "u-screen-reader-only", children: [
          n,
          " ",
          u + 1
        ] }),
        /* @__PURE__ */ p("span", { className: "m-step-indicator__number" }),
        /* @__PURE__ */ k("span", { className: "m-step-indicator__label", children: [
          i.label || null,
          i.complete ? /* @__PURE__ */ p("span", { className: "u-screen-reader-only", children: r }) : null
        ] })
      ] }),
      /* @__PURE__ */ p("a", { onClick: (f) => a(f, u, i?.id), href: c }),
      !!c
    ) }, i.id);
  }) });
}
function Mv({
  label: e,
  isToggle: t,
  active: n,
  iconLeft: r,
  removable: o,
  name: a,
  qa: i,
  onClick: u,
  ariaLabelDelete: l = "Verwijderen"
}) {
  const [c, f] = ge.useState(n), s = o && !t, d = n === !0 || n === !1 ? n : c, y = (b) => (t && f(!c), (t || s) && u && u(b)), h = t ? "button" : "div", v = X({
    "m-tag": !0,
    "is-clickable": !!s
  });
  return jr(
    h,
    {
      className: v,
      "data-qa": i,
      ...t ? {
        name: a,
        onClick: () => y(a),
        "aria-pressed": d
      } : {}
    },
    /* @__PURE__ */ k(lt, { children: [
      r && /* @__PURE__ */ p("div", { className: "m-tag__icon", children: /* @__PURE__ */ p(ve, { name: r }) }),
      /* @__PURE__ */ p("div", { className: "m-tag__label", children: e }),
      s ? /* @__PURE__ */ p(
        "button",
        {
          className: "m-tag__button",
          name: `${a}-delete`,
          onClick: () => y(`${a}-delete`),
          "aria-label": l,
          children: /* @__PURE__ */ p(ve, { name: "remove" })
        }
      ) : null
    ] })
  );
}
function Km({
  file: e,
  acceptedFormat: t,
  maxSize: n,
  onDelete: r,
  formatErrorLabel: o,
  deleteAriaLabel: a,
  sizeErrorLabel: i
}) {
  const u = Hu(e, t), l = Yu(e, n), c = !u || !l;
  return /* @__PURE__ */ k("li", { children: [
    /* @__PURE__ */ p(ve, { name: u && l ? "common-file-empty" : "alert-triangle" }),
    /* @__PURE__ */ p("span", { className: "m-upload__filename", children: e.name }),
    !u && /* @__PURE__ */ p("span", { className: "m-upload__error", children: o }),
    !l && /* @__PURE__ */ p("span", { className: "m-upload__error", children: i }),
    r && /* @__PURE__ */ p("div", { className: "m-upload__delete", children: /* @__PURE__ */ p(
      Ce,
      {
        ariaLabel: a,
        addOn: { type: "icon", iconProps: { name: "remove" } },
        emphasis: "low",
        theme: c ? "danger" : "neutral",
        size: "small",
        onClick: () => r(e)
      }
    ) })
  ] }, e.name);
}
function kv({
  acceptedFormat: e = "*",
  deleteAriaLabel: t = "Verwijder bestand",
  disabled: n = !1,
  files: r = [],
  formatErrorLabel: o = "Dit bestandsformaat is niet toegestaan.",
  id: a,
  label: i = "Sleep een bestand hier of klik om te bladeren",
  maxSize: u = 10,
  maxSizeLabel: l = "Maximale bestandsgrootte:",
  multiple: c = !0,
  onChange: f,
  onDelete: s,
  sizeErrorLabel: d = "Maximale bestandsgrootte overschreden.",
  qa: y
}) {
  const h = ge.useRef(null), v = (b) => {
    s && s(r?.filter((x) => x?.name !== b.name)), h.current && (h.current.value = "");
  }, O = (b) => {
    if (c) {
      const x = b.target?.files ? [...r, ...Array.from(b.target.files)].filter(
        ($, P, m) => m.findIndex((A) => A.name === $.name) === P
      ) : [];
      f && f(x, Ii(x, e, u));
    } else {
      const x = b.target?.files?.[0] ? [b.target?.files?.[0]] : [];
      f && f(x, Ii(x, e, u));
    }
  };
  return /* @__PURE__ */ k("div", { className: X({ "m-upload": !0, "is-disabled": !!n }), "data-qa": y, children: [
    /* @__PURE__ */ p("div", { className: "m-upload__inner", children: /* @__PURE__ */ k("div", { className: "m-upload__dropzone", children: [
      /* @__PURE__ */ p(
        "input",
        {
          ref: h,
          id: a,
          type: "file",
          multiple: c,
          onChange: O,
          accept: e,
          className: "m-upload__input",
          disabled: n,
          "aria-describedby": `${a}-description`
        }
      ),
      /* @__PURE__ */ p("div", { className: "m-upload__content", children: /* @__PURE__ */ p("label", { htmlFor: a, className: "m-upload__message u-margin-bottom", children: i }) })
    ] }) }),
    u && /* @__PURE__ */ k("small", { id: `${a}-description`, className: "m-upload__description", children: [
      l,
      " ",
      u,
      "MB"
    ] }),
    /* @__PURE__ */ p("ul", { className: "m-upload__files", children: r?.map((b) => /* @__PURE__ */ p(
      Km,
      {
        file: b,
        deleteAriaLabel: t,
        formatErrorLabel: o,
        sizeErrorLabel: d,
        onDelete: s && v,
        maxSize: u,
        acceptedFormat: e
      },
      b?.name
    )) })
  ] });
}
function Av({ backToTop: e, backToTopAriaLabel: t = "Terug naar omhoog", items: n = [], qa: r }) {
  const o = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return /* @__PURE__ */ k("footer", { className: "o-footer", "data-qa": r, children: [
    /* @__PURE__ */ p("span", { className: "o-footer__label", children: (() => n?.map((i, u) => {
      const l = fa(i), c = n.length > 1 && u !== n.length - 1;
      return /* @__PURE__ */ k(ge.Fragment, { children: [
        l,
        c ? " | " : ""
      ] }, i.label);
    }))() }),
    e && /* @__PURE__ */ p(
      Ce,
      {
        className: "o-footer__button a-button--secondary",
        addOn: { type: "icon", iconProps: { name: "arrow-up-1" } },
        onClick: o,
        ariaLabel: t
      }
    )
  ] });
}
function Iv({
  logoHref: e = "/",
  logoAlt: t = "Naar de startpagina",
  menuItems: n = [],
  logoSrc: r = "https://cdn.antwerpen.be/core_branding_scss/6.5.0/assets/images/a-logo.svg",
  skipToMainLabel: o = "Ga naar inhoud",
  qa: a
}) {
  return /* @__PURE__ */ p("header", { className: "o-header", "data-qa": a, children: /* @__PURE__ */ k("div", { className: "o-header__content-wrapper", children: [
    /* @__PURE__ */ k("div", { className: "o-header__content", children: [
      /* @__PURE__ */ p("a", { href: "#main", className: "a-button a-button--text a-button--neutral o-header__button-skip", children: o }),
      /* @__PURE__ */ p("a", { href: e, className: "o-header__logo", children: /* @__PURE__ */ p("img", { src: r, alt: t }) })
    ] }),
    /* @__PURE__ */ p("div", { className: "o-header__menu-items", children: (n || []).map(
      (i) => i.flyout ? /* @__PURE__ */ p(
        ul,
        {
          ...i.flyout,
          trigger: /* @__PURE__ */ jr(Ce, { ...i, key: i.id, emphasis: "low", theme: "neutral", className: "o-header__button" }, i.label)
        },
        i.id
      ) : /* @__PURE__ */ jr(Ce, { ...i, key: i.id, emphasis: "low", theme: "neutral", className: "o-header__button" }, i.label)
    ) })
  ] }) });
}
function Uv({ children: e = [], qa: t }) {
  const n = X({
    "o-tag-list": !0
  });
  return /* @__PURE__ */ p("ul", { className: n, "data-qa": t, children: ra.map(e, (r) => gr(r, /* @__PURE__ */ p("li", { className: "o-tag-list__item" }), !0)) });
}
export {
  wv as Accordion,
  Ov as AccordionTab,
  Pv as Alert,
  Tv as Autocomplete,
  Bu as Avatar,
  lv as AvatarList,
  nv as Badge,
  rv as Breadcrumb,
  Ce as Button,
  Sv as ButtonGroup,
  Eh as Calendar,
  $v as Card,
  da as Checkbox,
  cv as CheckboxList,
  ov as Copyright,
  Rv as Datepicker,
  uv as DefinitionList,
  ul as Flyout,
  Av as Footer,
  or as FunctionalList,
  Iv as Header,
  ve as Icon,
  Ph as Image,
  iv as Label,
  Li as ListItem,
  sv as ListItemAvatar,
  fv as ListItemCheckbox,
  Ev as Modal,
  xv as NavigationList,
  Cv as PageIndicator,
  Nv as Pagination,
  dv as ProgressBar,
  pv as Radio,
  yv as RadioGroup,
  hv as RangeSlider,
  mv as Select,
  zu as Spinner,
  Dv as StepIndicator,
  vv as Switch,
  bv as Table,
  Mv as Tag,
  Uv as TagList,
  av as TextArea,
  Qu as TextField,
  gv as Toggle,
  _v as Tooltip,
  kv as Upload,
  Km as UploadFile
};
